export const db_assessment = {
  "APP_CONFIG": {
    "STORAGE_KEY": "unipage_assessment_data",
    "ANALYTICS_STORAGE_KEY": "unipage_assessment_analytics",
    "ASSESSMENT_REDIRECT_URL": "/ru/navigator",
    "SCHOLARSHIPS_URL": "https://www.unipage.net/ru/scholarships",
    "UNIVERSITIES_URL": "https://www.unipage.net/ru/universities?country_id[]=",
    "REQUEST_CREATE_URL": "https://www.unipage.net/ru/service_strategic_planning#request-cta"
  },
  "LANGUAGES": {
    "en": {
      "label": "Английский",
      "count": 59
    },
    "es": {
      "label": "Испанский",
      "count": 6
    },
    "fr": {
      "label": "Французский",
      "count": 4
    },
    "de": {
      "label": "Немецкий",
      "count": 3
    },
    "zh": {
      "label": "Китайский",
      "count": 3
    },
    "ar": {
      "label": "Арабский",
      "count": 3
    },
    "nl": {
      "label": "Нидерландский",
      "count": 2
    },
    "pt": {
      "label": "Португальский",
      "count": 2
    },
    "it": {
      "label": "Итальянский",
      "count": 1
    },
    "ru": {
      "label": "Русский",
      "count": 3
    },
    "sl": {
      "label": "Словенский",
      "count": 1
    },
    "hr": {
      "label": "Хорватский",
      "count": 1
    },
    "ro": {
      "label": "Румынский",
      "count": 1
    },
    "sk": {
      "label": "Словацкий",
      "count": 1
    },
    "vi": {
      "label": "Вьетнамский",
      "count": 1
    },
    "ja": {
      "label": "Японский",
      "count": 1
    },
    "ko": {
      "label": "Корейский",
      "count": 1
    },
    "sv": {
      "label": "Шведский",
      "count": 1
    },
    "fi": {
      "label": "Финский",
      "count": 1
    },
    "no": {
      "label": "Норвежский",
      "count": 1
    },
    "pl": {
      "label": "Польский",
      "count": 1
    },
    "cs": {
      "label": "Чешский",
      "count": 1
    },
    "hu": {
      "label": "Венгерский",
      "count": 1
    },
    "tr": {
      "label": "Турецкий",
      "count": 1
    },
    "ms": {
      "label": "Малайский",
      "count": 1
    },
    "af": {
      "label": "Африкаанс",
      "count": 1
    },
    "id": {
      "label": "Индонезийский",
      "count": 1
    },
    "kk": {
      "label": "Казахский",
      "count": 1
    },
    "ka": {
      "label": "Грузинский",
      "count": 1
    },
    "sr": {
      "label": "Сербский",
      "count": 1
    },
    "bg": {
      "label": "Болгарский",
      "count": 1
    },
    "lt": {
      "label": "Литовский",
      "count": 1
    },
    "lv": {
      "label": "Латышский",
      "count": 1
    },
    "et": {
      "label": "Эстонский",
      "count": 1
    },
    "el": {
      "label": "Греческий",
      "count": 1
    },
    "he": {
      "label": "Иврит",
      "count": 1
    },
    "hi": {
      "label": "Хинди",
      "count": 1
    }
  },
  "LANG_LEVELS": [
    {
      "value": 0,
      "label": "A0 Начальный",
      "description": "Только начинаю учить или не владею языком."
    },
    {
      "value": 1,
      "label": "A1 Элементарный",
      "description": "Могу представиться и задать простые вопросы."
    },
    {
      "value": 2,
      "label": "A2 Базовый",
      "description": "Могу рассказать о себе и поддержать бытовую беседу."
    },
    {
      "value": 3,
      "label": "B1 Уверенный",
      "description": "Понимаю суть большинства разговоров на знакомые темы."
    },
    {
      "value": 4,
      "label": "B2 Высокий",
      "description": "Смотрю сериалы в оригинале, понимаю лекции."
    },
    {
      "value": 5,
      "label": "C1 Профессиональный",
      "description": "Читаю научные статьи, пишу сложные академические работы."
    },
    {
      "value": 6,
      "label": "C2 Уровень носителя",
      "description": "Владею языком как родным."
    }
  ],
  "GPA_OPTIONS": [
    {
      "value": 4.0,
      "label": "Идеально",
      "description": "Все оценки высшие (на отлично)"
    },
    {
      "value": 3.8,
      "label": "Отлично",
      "description": "Всё на отлично, но есть одна-две четверки"
    },
    {
      "value": 3.4,
      "label": "Выше среднего",
      "description": "В основном хорошие и отличные оценки"
    },
    {
      "value": 3.0,
      "label": "Средне",
      "description": "Микс оценок: есть отличные, хорошие и удв."
    },
    {
      "value": 2.5,
      "label": "Низкий",
      "description": "Преобладают минимальные баллы"
    },
    {
      "value": 1.5,
      "label": "Неудовлетворительно",
      "description": "Недостаточно баллов"
    }
  ],
  "BUDGET_OPTIONS": [
    {
      "value": 0,
      "label": "0 - 8,000 $",
      "description": "менее 650,000 ₽. Критический уровень. Требуется полное спонсорство."
    },
    {
      "value": 9000,
      "label": "8,000 - 10,000 $",
      "description": "~ 800,000 ₽. Минимальный бюджет, экономное проживание в Азии / Восточной Европе."
    },
    {
      "value": 12000,
      "label": "10,000 - 15,000 $",
      "description": "~ 1,200,000 ₽. Базовый бюджет, больше вариантов в бюджетных странах."
    },
    {
      "value": 20000,
      "label": "15,000 - 30,000 $",
      "description": "~ 2,500,000 ₽. Средний бюджет, большинство стран Европы."
    },
    {
      "value": 35000,
      "label": "30,000 - 50,000 $",
      "description": "~ 4,000,000 ₽. Комфортный бюджет, качественные программы в Канаде/США."
    },
    {
      "value": 60000,
      "label": "50,000+ $",
      "description": "4,000,000+ ₽. Высокий бюджет. Практически нет ограничений."
    }
  ],
  "RESIDENCY_OPTIONS": [
    {
      "value": "ru",
      "label": "Россия",
      "description": ""
    },
    {
      "value": "by",
      "label": "Беларусь",
      "description": ""
    },
    {
      "value": "kz",
      "label": "Казахстан",
      "description": ""
    },
    {
      "value": "ua",
      "label": "Украина",
      "description": ""
    },
    {
      "value": "uz",
      "label": "Узбекистан",
      "description": ""
    },
    {
      "value": "kg",
      "label": "Кыргызстан",
      "description": ""
    },
    {
      "value": "tj",
      "label": "Таджикистан",
      "description": ""
    },
    {
      "value": "tm",
      "label": "Туркменистан",
      "description": ""
    },
    {
      "value": "am",
      "label": "Армения",
      "description": ""
    },
    {
      "value": "az",
      "label": "Азербайджан",
      "description": ""
    },
    {
      "value": "ge",
      "label": "Грузия",
      "description": ""
    },
    {
      "value": "md",
      "label": "Молдова",
      "description": ""
    },
    {
      "value": "us",
      "label": "США и Green Card",
      "description": ""
    },
    {
      "value": "eu",
      "label": "Евросоюз и резиденты ЕС",
      "description": ""
    },
    {
      "value": "other",
      "label": "Другие страны и статусы",
      "description": ""
    }
  ],
  "TIME_TO_START_OPTIONS": [
    {
      "value": 0,
      "label": "В процессе поступления",
      "description": "Вы уже выбрали вузы и готовитесь к отправке документов или получению визы."
    },
    {
      "value": 3,
      "label": "3–6 месяцев",
      "description": "Финишная прямая: время для сдачи языкового теста и финальной сборки портфолио."
    },
    {
      "value": 6,
      "label": "6–12 месяцев",
      "description": "Оптимальное время, чтобы успеть подготовиться к дедлайнам топовых университетов."
    },
    {
      "value": 12,
      "label": "1–2 года",
      "description": "Идеальный запас времени, чтобы без спешки подтянуть язык и улучшить средний балл."
    },
    {
      "value": 24,
      "label": "2–4 года",
      "description": "Стратегическое планирование: работа над профилем, олимпиадами и выбором страны."
    },
    {
      "value": 48,
      "label": "Больше 4 лет",
      "description": "Ранний старт, позволяет заранее выбрать школу и траекторию к высшему образованию."
    }
  ],
  "REGION_OPTIONS": [
    {
      "value": "anglo",
      "label": "Англоязычные страны",
      "description": "США, Канада, Великобритания, Австралия"
    },
    {
      "value": "eur_west",
      "label": "Западная Европа",
      "description": "Германия, Франция, Швейцария, Нидерланды"
    },
    {
      "value": "eur_south",
      "label": "Южная Европа",
      "description": "Италия, Испания, Португалия, Греция"
    },
    {
      "value": "eur_scan",
      "label": "Северная Европа",
      "description": "Швеция, Норвегия, Дания, Финляндия"
    },
    {
      "value": "eur_east",
      "label": "Восточная Европа",
      "description": "Польша, Чехия, Венгрия, Словакия"
    },
    {
      "value": "asia_hub",
      "label": "Восточная Азия",
      "description": "Китай, Япония, Южная Корея"
    },
    {
      "value": "asia_em",
      "label": "Юго-Восточная Азия",
      "description": "Малайзия, Сингапур, Таиланд"
    },
    {
      "value": "mena",
      "label": "Ближний Восток",
      "description": "ОАЭ, Турция, Израиль"
    },
    {
      "value": "latam",
      "label": "Латинская Америка",
      "description": "Бразилия, Аргентина, Мексика"
    },
    {
      "value": "cis",
      "label": "СНГ и Кавказ",
      "description": "Грузия, Армения, Казахстан, Узбекистан"
    }
  ],
  "EUROPE_SUB_REGIONS": [
    {
      "id": "eur_west",
      "label": "Западная",
      "desc": "Германия, Франция, Нидерланды, Бельгия, Австрия и др."
    },
    {
      "id": "eur_scan",
      "label": "Скандинавия",
      "desc": "Швеция, Норвегия, Дания, Финляндия, Исландия и др."
    },
    {
      "id": "eur_balt",
      "label": "Страны Балтии",
      "desc": "Эстония, Латвия, Литва"
    },
    {
      "id": "eur_east",
      "label": "Восточная",
      "desc": "Польша, Чехия, Венгрия, Сербия, Словакия и др."
    },
    {
      "id": "eur_south",
      "label": "Южная Европа",
      "desc": "Испания, Италия, Португалия, Греция, Мальта и др."
    }
  ],
  "ASIA_SUB_REGIONS": [
    {
      "id": "asia_hub",
      "label": "Глобальные хабы",
      "desc": "Сингапур, Гонконг, Япония, Тайвань, Южная Корея и др."
    },
    {
      "id": "asia_em",
      "label": "Развивающиеся рынки",
      "desc": "Китай, Малайзия, Вьетнам, Таиланд, Индонезия и др."
    }
  ],
  "ASSESSMENT_QUESTIONS": [
    {
      "id": "langs",
      "title": "Язык обучения",
      "subtitle": "Укажите языки, которыми вы владеете или готовы изучить к моменту обучения",
      "optionsKey": "LANGUAGES",
      "multiple": true
    },
    {
      "id": "lang_level",
      "title": "Уровень языка",
      "subtitle": "Укажите какой у вас текущий уровень языка?",
      "optionsKey": "LANG_LEVELS",
      "multiple": false
    },
    {
      "id": "timeToStart",
      "title": "Когда вы планируете начать обучение?",
      "subtitle": "Запас времени позволяет лучше подготовиться и повысить шансы.",
      "optionsKey": "TIME_TO_START_OPTIONS",
      "multiple": false
    },
    {
      "id": "gpa",
      "title": "Академическая успеваемость — GPA",
      "subtitle": "Какая у вас ожидается успеваемость к моменту подачи документов?",
      "optionsKey": "GPA_OPTIONS",
      "multiple": false
    },
    {
      "id": "budget",
      "title": "Бюджет в год на всё (обучение + жизнь)",
      "subtitle": "Сколько вы готовы выделить на проживание и обучение за границей в год?",
      "optionsKey": "BUDGET_OPTIONS",
      "multiple": false
    },
    {
      "id": "regions",
      "title": "Где вы хотите учиться?",
      "subtitle": "Выберите один или несколько регионов. Мы повысим приоритет этих стран в результатах.",
      "optionsKey": "REGION_OPTIONS",
      "multiple": true
    },
    {
      "id": "residencies",
      "title": "Гражданство или резидентство",
      "subtitle": "Укажите гражданства и ВНЖ, которые будут у вас на момент подачи.",
      "optionsKey": "RESIDENCY_OPTIONS",
      "multiple": true
    }
  ]
};

export const db_countries = {
  "us": {
    "id": 224,
    "region": "Северная Америка",
    "groupCode": "anglo",
    "country": "США",
    "costApartments": 11400,
    "costLife": 7560,
    "popularity": 1100000,
    "quality": 1,
    "pages": {
      "country_hub": "study_usa"
    },
    "salary": {
      "graduate_mid": 3720.94,
      "comment": "Сильно варьируется по штатам"
    },
    "universities": {
      "total": 3343
    }
  },
  "gb": {
    "id": 77,
    "region": "Западная Европа",
    "groupCode": "anglo",
    "country": "Великобритания",
    "costApartments": 10200,
    "costLife": 7140,
    "popularity": 750000,
    "quality": 2,
    "pages": {
      "country_hub": "study_uk"
    },
    "salary": {
      "graduate_mid": 2646,
      "comment": "Рынок после Брексита"
    },
    "universities": {
      "total": 350
    }
  },
  "de": {
    "id": 57,
    "region": "Западная Европа",
    "groupCode": "eur_west",
    "country": "Германия",
    "costApartments": 7200,
    "costLife": 4800,
    "popularity": 458000,
    "quality": 3,
    "pages": {
      "country_hub": "study_germany"
    },
    "salary": {
      "graduate_mid": 2508.19,
      "comment": "Высокие социальные взносы"
    },
    "universities": {
      "total": 450
    }
  },
  "ca": {
    "id": 38,
    "region": "Северная Америка",
    "groupCode": "anglo",
    "country": "Канада",
    "costApartments": 9000,
    "costLife": 5880,
    "popularity": 1050000,
    "quality": 5,
    "pages": {
      "country_hub": "study_canada"
    },
    "salary": {
      "graduate_mid": 2894.06,
      "comment": "Прогрессивная система налогообложения"
    },
    "universities": {
      "total": 380
    }
  },
  "ch": {
    "id": 40,
    "region": "Западная Европа",
    "groupCode": "eur_west",
    "country": "Швейцария",
    "costApartments": 13200,
    "costLife": 10080,
    "popularity": 74000,
    "quality": 6,
    "pages": {
      "country_hub": "study_switzerland"
    },
    "salary": {
      "graduate_mid": 5292,
      "comment": "Низкие налоги, очень высокие доходы"
    },
    "universities": {
      "total": 120
    }
  },
  "fr": {
    "id": 73,
    "region": "Западная Европа",
    "groupCode": "eur_west",
    "country": "Франция",
    "costApartments": 7200,
    "costLife": 5460,
    "popularity": 402000,
    "quality": 9,
    "pages": {
      "country_hub": "study_france"
    },
    "salary": {
      "graduate_mid": 2222.64,
      "comment": "Обширная защита прав трудящихся"
    },
    "universities": {
      "total": 600
    }
  },
  "au": {
    "id": 15,
    "region": "Океания",
    "groupCode": "anglo",
    "country": "Австралия",
    "costApartments": 9600,
    "costLife": 6720,
    "popularity": 712000,
    "quality": 11,
    "pages": {
      "country_hub": "study_australia"
    },
    "salary": {
      "graduate_mid": 3307.5,
      "comment": "Высокая базовая минимальная зарплата"
    },
    "universities": {
      "total": 190
    }
  },
  "lu": {
    "id": 128,
    "region": "Западная Европа",
    "groupCode": "eur_west",
    "country": "Люксембург",
    "costApartments": 11400,
    "costLife": 7560,
    "popularity": 7000,
    "quality": 12,
    "salary": {
      "graduate_mid": 3307.5,
      "comment": "Доминирование финансового сектора"
    },
    "universities": {
      "total": 5
    }
  },
  "dk": {
    "id": 60,
    "region": "Северная Европа",
    "groupCode": "eur_scan",
    "country": "Дания",
    "costApartments": 8400,
    "costLife": 6720,
    "popularity": 35000,
    "quality": 13,
    "pages": {
      "country_hub": "study_denmark"
    },
    "salary": {
      "graduate_mid": 2734.2,
      "comment": "Высокие налоги, высокий уровень соцобеспечения"
    },
    "universities": {
      "total": 50
    }
  },
  "nl": {
    "id": 159,
    "region": "Западная Европа",
    "groupCode": "eur_west",
    "country": "Нидерланды",
    "costApartments": 9000,
    "costLife": 5880,
    "popularity": 122000,
    "quality": 14,
    "pages": {
      "country_hub": "study_netherlands"
    },
    "salary": {
      "graduate_mid": 2546.77,
      "comment": "Правило 30% для экспатов (если применимо)"
    },
    "universities": {
      "total": 120
    }
  },
  "jp": {
    "id": 110,
    "region": "Восточная Азия",
    "groupCode": "asia_hub",
    "country": "Япония",
    "costApartments": 5400,
    "costLife": 5880,
    "popularity": 242000,
    "quality": 15,
    "pages": {
      "country_hub": "study_japan"
    },
    "salary": {
      "graduate_mid": 1764,
      "comment": "Традиционная корпоративная структура"
    },
    "universities": {
      "total": 1000
    }
  },
  "se": {
    "id": 201,
    "region": "Северная Европа",
    "groupCode": "eur_scan",
    "country": "Швеция",
    "costApartments": 7800,
    "costLife": 5880,
    "popularity": 40000,
    "quality": 16,
    "pages": {
      "country_hub": "study_sweden"
    },
    "salary": {
      "graduate_mid": 2701.12,
      "comment": "Скандинавская модель"
    },
    "universities": {
      "total": 50
    }
  },
  "fi": {
    "id": 70,
    "region": "Северная Европа",
    "groupCode": "eur_scan",
    "country": "Финляндия",
    "costApartments": 6600,
    "costLife": 5460,
    "popularity": 32000,
    "quality": 17,
    "pages": {
      "country_hub": "study_finland"
    },
    "salary": {
      "graduate_mid": 2469.6,
      "comment": "Скандинавская модель соцобеспечения"
    },
    "universities": {
      "total": 40
    }
  },
  "no": {
    "id": 160,
    "region": "Северная Европа",
    "groupCode": "eur_scan",
    "country": "Норвегия",
    "costApartments": 9000,
    "costLife": 7560,
    "popularity": 25000,
    "quality": 18,
    "pages": {
      "country_hub": "study_norway"
    },
    "salary": {
      "graduate_mid": 3087,
      "comment": "Сильные профсоюзы"
    },
    "universities": {
      "total": 65
    }
  },
  "sg": {
    "id": 187,
    "region": "Юго-Восточная Азия",
    "groupCode": "asia_hub",
    "country": "Сингапур",
    "costApartments": 13200,
    "costLife": 8400,
    "popularity": 65000,
    "quality": 19,
    "pages": {
      "country_hub": "study_singapore"
    },
    "salary": {
      "graduate_mid": 2811.38,
      "comment": "Глобальный финансовый центр"
    },
    "universities": {
      "total": 20
    }
  },
  "hk": {
    "id": 93,
    "region": "Восточная Азия",
    "groupCode": "asia_hub",
    "country": "Гонконг",
    "costApartments": 10800,
    "costLife": 7560,
    "popularity": 45000,
    "quality": 20,
    "pages": {
      "country_hub": "study_hong_kong"
    },
    "salary": {
      "graduate_mid": 2480.62,
      "comment": "Низкие налоги, финансовый центр"
    },
    "universities": {
      "total": 22
    }
  },
  "be": {
    "id": 19,
    "region": "Западная Европа",
    "groupCode": "eur_west",
    "country": "Бельгия",
    "costApartments": 6000,
    "costLife": 5460,
    "popularity": 55000,
    "quality": 22,
    "pages": {
      "country_hub": "study_belgium"
    },
    "salary": {
      "graduate_mid": 2293.2,
      "comment": "Высокая налоговая нагрузка"
    },
    "universities": {
      "total": 95
    }
  },
  "es": {
    "id": 67,
    "region": "Южная Европа",
    "groupCode": "eur_south",
    "country": "Испания",
    "costApartments": 6000,
    "costLife": 4200,
    "popularity": 224000,
    "quality": 23,
    "pages": {
      "country_hub": "study_spain"
    },
    "salary": {
      "graduate_mid": 1653.75,
      "comment": "Высокая безработица среди молодежи"
    },
    "universities": {
      "total": 280
    }
  },
  "at": {
    "id": 16,
    "region": "Западная Европа",
    "groupCode": "eur_west",
    "country": "Австрия",
    "costApartments": 6600,
    "costLife": 5460,
    "popularity": 80000,
    "quality": 25,
    "pages": {
      "country_hub": "study_austria"
    },
    "salary": {
      "graduate_mid": 2315.25,
      "comment": "Сильное социальное обеспечение"
    },
    "universities": {
      "total": 85
    }
  },
  "it": {
    "id": 107,
    "region": "Южная Европа",
    "groupCode": "eur_south",
    "country": "Италия",
    "costApartments": 6000,
    "costLife": 4620,
    "popularity": 210000,
    "quality": 26,
    "pages": {
      "country_hub": "study_italy"
    },
    "salary": {
      "graduate_mid": 1389.15,
      "comment": "Региональные диспропорции"
    },
    "universities": {
      "total": 250
    }
  },
  "kr": {
    "id": 117,
    "region": "Восточная Азия",
    "groupCode": "asia_hub",
    "country": "Ю. Корея",
    "costApartments": 5400,
    "costLife": 5040,
    "popularity": 166000,
    "quality": 28,
    "pages": {
      "country_hub": "study_south_korea"
    },
    "salary": {
      "graduate_mid": 2061.67,
      "comment": "Конкурентный рынок труда"
    },
    "universities": {
      "total": 400
    }
  },
  "cn": {
    "id": 42,
    "region": "Восточная Азия",
    "groupCode": "asia_em",
    "country": "Китай",
    "costApartments": 4200,
    "costLife": 3360,
    "popularity": 492000,
    "quality": 29,
    "pages": {
      "country_hub": "study_china"
    },
    "salary": {
      "graduate_mid": 937.12,
      "comment": "Фокус на городах первого уровня (Tier-1)"
    },
    "universities": {
      "total": 3000
    }
  },
  "il": {
    "id": 106,
    "region": "Западная Азия",
    "groupCode": "mena_afr",
    "country": "Израиль",
    "costApartments": 9600,
    "costLife": 6300,
    "popularity": 12000,
    "quality": 31,
    "pages": {
      "country_hub": "study_israel"
    },
    "salary": {
      "graduate_mid": 2067.19,
      "comment": "Надбавка в высокотехнологичном секторе"
    },
    "universities": {
      "total": 65
    }
  },
  "ie": {
    "id": 102,
    "region": "Западная Европа",
    "groupCode": "anglo",
    "country": "Ирландия",
    "costApartments": 11400,
    "costLife": 6300,
    "popularity": 35000,
    "quality": 32,
    "pages": {
      "country_hub": "study_ireland"
    },
    "salary": {
      "graduate_mid": 2646,
      "comment": "Технологический центр Европы"
    },
    "universities": {
      "total": 45
    }
  },
  "nz": {
    "id": 163,
    "region": "Океания",
    "groupCode": "anglo",
    "country": "Новая Зеландия",
    "costApartments": 7800,
    "costLife": 5880,
    "popularity": 55000,
    "quality": 33,
    "pages": {
      "country_hub": "study_new_zealand"
    },
    "salary": {
      "graduate_mid": 2579.85,
      "comment": "Сбалансированный образ жизни"
    },
    "universities": {
      "total": 35
    }
  },
  "pt": {
    "id": 175,
    "region": "Южная Европа",
    "groupCode": "eur_south",
    "country": "Португалия",
    "costApartments": 6000,
    "costLife": 3780,
    "popularity": 70000,
    "quality": 34,
    "pages": {
      "country_hub": "study_portugal"
    },
    "salary": {
      "graduate_mid": 1074.94,
      "comment": "Привлекательно для удаленной работы"
    },
    "universities": {
      "total": 140
    }
  },
  "ru": {
    "id": 182,
    "region": "Восточная Европа",
    "groupCode": "cis",
    "country": "Россия",
    "costApartments": 3000,
    "costLife": 3780,
    "popularity": 0,
    "quality": 35,
    "pages": {
      "country_hub": "study_russia"
    },
    "salary": {
      "graduate_mid": 767.34,
      "comment": "Плоская налоговая ставка"
    },
    "universities": {
      "total": 1160
    }
  },
  "tw": {
    "id": 218,
    "region": "Восточная Азия",
    "groupCode": "asia_hub",
    "country": "Тайвань",
    "costApartments": 4200,
    "costLife": 3780,
    "popularity": 130000,
    "quality": 36,
    "salary": {
      "graduate_mid": 1190.7,
      "comment": "Полупроводниковая промышленность"
    },
    "universities": {
      "total": 160
    }
  },
  "pl": {
    "id": 172,
    "region": "Восточная Европа",
    "groupCode": "eur_east",
    "country": "Польша",
    "costApartments": 4800,
    "costLife": 3360,
    "popularity": 10500,
    "quality": 38,
    "pages": {
      "country_hub": "study_poland"
    },
    "salary": {
      "graduate_mid": 1240.31,
      "comment": "Сильный региональный хаб"
    },
    "universities": {
      "total": 386
    }
  },
  "cz": {
    "id": 56,
    "region": "Восточная Европа",
    "groupCode": "eur_east",
    "country": "Чехия",
    "costApartments": 5400,
    "costLife": 4200,
    "popularity": 55000,
    "quality": 39,
    "pages": {
      "country_hub": "study_zech_republic"
    },
    "salary": {
      "graduate_mid": 1323,
      "comment": "Сильный промышленный сектор"
    },
    "universities": {
      "total": 68
    }
  },
  "in": {
    "id": 100,
    "region": "Южная Азия",
    "groupCode": "asia_em",
    "country": "Индия",
    "costApartments": 1800,
    "costLife": 1680,
    "popularity": 50000,
    "quality": 41,
    "pages": {
      "country_hub": "study_india"
    },
    "salary": {
      "graduate_mid": 396.9,
      "comment": "Высокая дисперсия по секторам"
    },
    "universities": {
      "total": 5420
    }
  },
  "ar": {
    "id": 9,
    "region": "Южная Америка",
    "groupCode": "latam",
    "country": "Аргентина",
    "costApartments": 3000,
    "costLife": 3360,
    "popularity": 0,
    "quality": 42,
    "salary": {
      "graduate_mid": 468.56,
      "comment": "Высокие инфляционные корректировки"
    },
    "universities": {
      "total": 140
    }
  },
  "ae": {
    "id": 8,
    "region": "Западная Азия",
    "groupCode": "mena_afr",
    "country": "ОАЭ",
    "costApartments": 8400,
    "costLife": 6720,
    "popularity": 85000,
    "quality": 43,
    "pages": {
      "country_hub": "study_uae"
    },
    "salary": {
      "graduate_mid": 3307.5,
      "comment": "Нет подоходного налога, высокий спрос на экспатов"
    },
    "universities": {
      "total": 64
    }
  },
  "gr": {
    "id": 86,
    "region": "Южная Европа",
    "groupCode": "eur_south",
    "country": "Греция",
    "costApartments": 4200,
    "costLife": 3780,
    "popularity": 30000,
    "quality": 44,
    "pages": {
      "country_hub": "study_greece"
    },
    "salary": {
      "graduate_mid": 992.25,
      "comment": "Восстанавливающаяся экономика"
    },
    "universities": {
      "total": 40
    }
  },
  "mx": {
    "id": 136,
    "region": "Северная Америка",
    "groupCode": "latam",
    "country": "Мексика",
    "costApartments": 3000,
    "costLife": 3360,
    "popularity": 0,
    "quality": 45,
    "salary": {
      "graduate_mid": 655.99,
      "comment": "Рост ниаршоринга"
    },
    "universities": {
      "total": 1200
    }
  },
  "hu": {
    "id": 98,
    "region": "Восточная Европа",
    "groupCode": "eur_east",
    "country": "Венгрия",
    "costApartments": 4200,
    "costLife": 3360,
    "popularity": 42000,
    "quality": 46,
    "pages": {
      "country_hub": "study_hungary"
    },
    "salary": {
      "graduate_mid": 886.41,
      "comment": "Плоская шкала, высокие соц. взносы"
    },
    "universities": {
      "total": 70
    }
  },
  "za": {
    "id": 237,
    "region": "Южная Африка",
    "groupCode": "mena_afr",
    "country": "ЮАР",
    "costApartments": 3000,
    "costLife": 3360,
    "popularity": 0,
    "quality": 47,
    "salary": {
      "graduate_mid": 705.6,
      "comment": "Высокое неравенство доходов"
    },
    "universities": {
      "total": 120
    }
  },
  "tr": {
    "id": 216,
    "region": "Западная Азия",
    "groupCode": "mena_afr",
    "country": "Турция",
    "costApartments": 3000,
    "costLife": 2940,
    "popularity": 301000,
    "quality": 48,
    "pages": {
      "country_hub": "study_turkey"
    },
    "salary": {
      "graduate_mid": 529.2,
      "comment": "Высокие инфляционные корректировки"
    },
    "universities": {
      "total": 210
    }
  },
  "my": {
    "id": 150,
    "region": "Юго-Восточная Азия",
    "groupCode": "asia_em",
    "country": "Малайзия",
    "costApartments": 2400,
    "costLife": 2940,
    "popularity": 100000,
    "quality": 49,
    "pages": {
      "country_hub": "study_malaysia"
    },
    "salary": {
      "graduate_mid": 694.58,
      "comment": "Растущий технологический центр"
    },
    "universities": {
      "total": 130
    }
  },
  "is": {
    "id": 105,
    "region": "Северная Европа",
    "groupCode": "eur_scan",
    "country": "Исландия",
    "costApartments": 10800,
    "costLife": 7560,
    "popularity": 2000,
    "quality": 50,
    "pages": {
      "country_hub": "study_iceland"
    },
    "salary": {
      "graduate_mid": 3087,
      "comment": "Высокий уровень жизни"
    },
    "universities": {
      "total": 7
    }
  },
  "ee": {
    "id": 68,
    "region": "Северная Европа",
    "groupCode": "eur_balt",
    "country": "Эстония",
    "costApartments": 4800,
    "costLife": 3780,
    "popularity": 5000,
    "quality": 52,
    "pages": {
      "country_hub": "study_estonia"
    },
    "salary": {
      "graduate_mid": 1587.6,
      "comment": "Фокус на цифровую экономику"
    },
    "universities": {
      "total": 20
    }
  },
  "lt": {
    "id": 127,
    "region": "Северная Европа",
    "groupCode": "eur_balt",
    "country": "Литва",
    "costApartments": 4200,
    "costLife": 3360,
    "popularity": 8000,
    "quality": 56,
    "salary": {
      "graduate_mid": 1323,
      "comment": "Быстрорастущий рынок Балтии"
    },
    "universities": {
      "total": 45
    }
  },
  "th": {
    "id": 208,
    "region": "Юго-Восточная Азия",
    "groupCode": "asia_em",
    "country": "Таиланд",
    "costApartments": 3000,
    "costLife": 2940,
    "popularity": 35000,
    "quality": 58,
    "salary": {
      "graduate_mid": 496.12,
      "comment": "Туризм и производство"
    },
    "universities": {
      "total": 193
    }
  },
  "lv": {
    "id": 129,
    "region": "Северная Европа",
    "groupCode": "eur_balt",
    "country": "Латвия",
    "costApartments": 3600,
    "costLife": 2940,
    "popularity": 10000,
    "quality": 60,
    "pages": {
      "country_hub": "study_latvia"
    },
    "salary": {
      "graduate_mid": 1240.31,
      "comment": "Стабильный рост"
    },
    "universities": {
      "total": 40
    }
  },
  "cy": {
    "id": 55,
    "region": "Западная Азия",
    "groupCode": "eur_south",
    "country": "Кипр",
    "costApartments": 7200,
    "costLife": 4200,
    "popularity": 25000,
    "quality": 61,
    "pages": {
      "country_hub": "study_cyprus"
    },
    "salary": {
      "graduate_mid": 1405.69,
      "comment": "Благоприятный налоговый режим"
    },
    "universities": {
      "total": 40
    }
  },
  "si": {
    "id": 200,
    "region": "Центральная Европа",
    "groupCode": "eur_east",
    "country": "Словения",
    "costApartments": 4200,
    "costLife": 4200,
    "popularity": 5000,
    "quality": 63,
    "salary": {
      "graduate_mid": 1234.8,
      "comment": "Экспорто-ориентированная экономика"
    },
    "universities": {
      "total": 20
    }
  },
  "mt": {
    "id": 140,
    "region": "Южная Европа",
    "groupCode": "eur_south",
    "country": "Мальта",
    "costApartments": 7800,
    "costLife": 4200,
    "popularity": 12000,
    "quality": 64,
    "salary": {
      "graduate_mid": 1411.2,
      "comment": "Сфера iGaming и финансов"
    },
    "universities": {
      "total": 5
    }
  },
  "hr": {
    "id": 96,
    "region": "Южная Европа",
    "groupCode": "eur_south",
    "country": "Хорватия",
    "costApartments": 4800,
    "costLife": 3780,
    "popularity": 10000,
    "quality": 65,
    "salary": {
      "graduate_mid": 992.25,
      "comment": "Рост туризма и IT"
    },
    "universities": {
      "total": 40
    }
  },
  "ro": {
    "id": 181,
    "region": "Восточная Европа",
    "groupCode": "eur_east",
    "country": "Румыния",
    "costApartments": 3600,
    "costLife": 2520,
    "popularity": 35000,
    "quality": 66,
    "salary": {
      "graduate_mid": 859.95,
      "comment": "Налоговые льготы для IT"
    },
    "universities": {
      "total": 100
    }
  },
  "bg": {
    "id": 23,
    "region": "Восточная Европа",
    "groupCode": "eur_east",
    "country": "Болгария",
    "costApartments": 3000,
    "costLife": 2520,
    "popularity": 18000,
    "quality": 67,
    "pages": {
      "country_hub": "study_bulgaria"
    },
    "salary": {
      "graduate_mid": 859.95,
      "comment": "Плоская шкала налогообложения"
    },
    "universities": {
      "total": 52
    }
  },
  "sk": {
    "id": 199,
    "region": "Восточная Европа",
    "groupCode": "eur_east",
    "country": "Словакия",
    "costApartments": 4200,
    "costLife": 3360,
    "popularity": 15000,
    "quality": 69,
    "salary": {
      "graduate_mid": 1240.31,
      "comment": "Автомобилестроение"
    },
    "universities": {
      "total": 35
    }
  },
  "rs": {
    "id": 236,
    "region": "Южная Европа",
    "groupCode": "eur_south",
    "country": "Сербия",
    "costApartments": 4200,
    "costLife": 2940,
    "popularity": 12000,
    "quality": 73,
    "pages": {
      "country_hub": "study_serbia"
    },
    "salary": {
      "graduate_mid": 705.6,
      "comment": "Растущее присутствие IT и технологий"
    },
    "universities": {
      "total": 80
    }
  },
  "ph": {
    "id": 169,
    "region": "Юго-Восточная Азия",
    "groupCode": "asia_em",
    "country": "Филиппины",
    "costApartments": 1800,
    "costLife": 2100,
    "popularity": 10000,
    "quality": 76,
    "salary": {
      "graduate_mid": 347.29,
      "comment": "Доминирование сектора BPO (аутсорсинг)"
    },
    "universities": {
      "total": 300
    }
  },
  "ge": {
    "id": 78,
    "region": "Западная Азия",
    "groupCode": "cis",
    "country": "Грузия",
    "costApartments": 4800,
    "costLife": 2940,
    "popularity": 20000,
    "quality": 78,
    "salary": {
      "graduate_mid": 441,
      "comment": "Плоская шкала подоходного налога"
    },
    "universities": {
      "total": 60
    }
  },
  "vn": {
    "id": 231,
    "region": "Юго-Восточная Азия",
    "groupCode": "asia_em",
    "country": "Вьетнам",
    "costApartments": 2400,
    "costLife": 2100,
    "popularity": 25000,
    "quality": 83,
    "salary": {
      "graduate_mid": 347.29,
      "comment": "Быстрая индустриализация"
    },
    "universities": {
      "total": 180
    }
  },
  "br": {
    "id": 31,
    "region": "Южная Америка",
    "groupCode": "latam",
    "country": "Бразилия",
    "costApartments": 2400,
    "costLife": 3500,
    "popularity": 25000,
    "quality": 103,
    "salary": {
      "graduate_mid": 562.27,
      "comment": "Сложная налоговая система"
    },
    "universities": {
      "total": 1300
    }
  },
  "cl": {
    "id": 41,
    "region": "Южная Америка",
    "groupCode": "latam",
    "country": "Чили",
    "costApartments": 3600,
    "costLife": 3500,
    "popularity": 15000,
    "quality": 105,
    "salary": {
      "graduate_mid": 793.8,
      "comment": "Стабильный рынок Латинской Америки"
    },
    "universities": {
      "total": 131
    }
  },
  "co": {
    "id": 48,
    "region": "Южная Америка",
    "groupCode": "latam",
    "country": "Колумбия",
    "costApartments": 2400,
    "costLife": 3000,
    "popularity": 12000,
    "quality": 107,
    "salary": {
      "graduate_mid": 496.12,
      "comment": "Развивающийся рынок"
    },
    "universities": {
      "total": 300
    }
  },
  "pe": {
    "id": 168,
    "region": "Южная Америка",
    "groupCode": "latam",
    "country": "Перу",
    "costApartments": 2400,
    "costLife": 2500,
    "popularity": 8000,
    "quality": 108,
    "salary": {
      "graduate_mid": 396.9,
      "comment": "Добывающая промышленность и сельское хозяйство"
    },
    "universities": {
      "total": 140
    }
  },
  "sa": {
    "id": 184,
    "region": "Западная Азия",
    "groupCode": "mena_afr",
    "country": "Саудовская Аравия",
    "costApartments": 4800,
    "costLife": 6000,
    "popularity": 80000,
    "quality": 109,
    "salary": {
      "graduate_mid": 2756.25,
      "comment": "Инициативы Vision 2030, нет подоходного налога"
    },
    "universities": {
      "total": 64
    }
  },
  "eg": {
    "id": 64,
    "region": "Северная Африка",
    "groupCode": "mena_afr",
    "country": "Египет",
    "costApartments": 1800,
    "costLife": 2000,
    "popularity": 50000,
    "quality": 111,
    "salary": {
      "graduate_mid": 198.45,
      "comment": "Влияние девальвации валюты"
    },
    "universities": {
      "total": 83
    }
  },
  "ma": {
    "id": 131,
    "region": "Северная Африка",
    "groupCode": "mena_afr",
    "country": "Марокко",
    "costApartments": 1800,
    "costLife": 2500,
    "popularity": 25000,
    "quality": 114,
    "salary": {
      "graduate_mid": 374.85,
      "comment": "Развивающееся производство"
    },
    "universities": {
      "total": 146
    }
  },
  "id": {
    "id": 99,
    "region": "Юго-Восточная Азия",
    "groupCode": "asia_em",
    "country": "Индонезия",
    "costApartments": 1800,
    "costLife": 2500,
    "popularity": 10000,
    "quality": 116,
    "salary": {
      "graduate_mid": 396.9,
      "comment": "Быстрорастущий средний класс"
    },
    "universities": {
      "total": 2600
    }
  },
  "kz": {
    "id": 111,
    "region": "Центральная Азия",
    "groupCode": "cis",
    "country": "Казахстан",
    "costApartments": 3000,
    "costLife": 2500,
    "popularity": 40000,
    "quality": 118,
    "salary": {
      "graduate_mid": 562.27,
      "comment": "Ресурсоориентированная экономика"
    },
    "universities": {
      "total": 130
    }
  },
  "uz": {
    "id": 225,
    "region": "Центральная Азия",
    "groupCode": "cis",
    "country": "Узбекистан",
    "costApartments": 2400,
    "costLife": 2000,
    "popularity": 15000,
    "quality": 121,
    "salary": {
      "graduate_mid": 291.06,
      "comment": "Развивающаяся Центральная Азия"
    },
    "universities": {
      "total": 85
    }
  },
  "az": {
    "id": 17,
    "region": "Западная Азия",
    "groupCode": "cis",
    "country": "Азербайджан",
    "costApartments": 3000,
    "costLife": 2500,
    "popularity": 10000,
    "quality": 123,
    "salary": {
      "graduate_mid": 468.56,
      "comment": "Нефтяная экономика"
    },
    "universities": {
      "total": 40
    }
  },
  "am": {
    "id": 10,
    "region": "Западная Азия",
    "groupCode": "cis",
    "country": "Армения",
    "costApartments": 4200,
    "costLife": 2500,
    "popularity": 8000,
    "quality": 124,
    "salary": {
      "graduate_mid": 529.2,
      "comment": "Растущий IT-сектор"
    },
    "universities": {
      "total": 45
    }
  }
};

export const db_education = {
  "au": {
    "country": "Австралия",
    "overview": "Австралия — один из мировых лидеров по количеству иностранных студентов. Местные университеты славятся инновационным подходом к обучению и мощной научно-исследовательской базой. Бакалавриат отличается гибкостью: студенты могут самостоятельно формировать учебный план и выбирать смежные специализации. Строгий государственный контроль гарантирует соответствие образовательных программ высоким международным стандартам. Особое внимание уделяется практическим навыкам, что делает выпускников востребованными на глобальном рынке труда.",
    "pros": [
      "Инновационный подход к обучению и мощная научно-исследовательская база.",
      "Дипломы признаются и высоко ценятся работодателями по всему миру.",
      "Строгий государственный контроль гарантирует высокое качество образования.",
      "Возможность самостоятельно формировать учебный план и брать двойные специализации.",
      "Развитая инфраструктура кампусов и комфортная мультикультурная среда."
    ],
    "cons": [
      "Необходимость прохождения подготовительной программы перед поступлением.",
      "Академический процесс требует высокой самодисциплины из-за упора на самообучение.",
      "Удаленное географическое положение усложняет путешествия и поездки домой.",
      "Многоступенчатый и строгий процесс получения студенческой визы."
    ],
    "source": "article-overview"
  },
  "de": {
    "country": "Германия",
    "overview": "Высшее образование в Германии славится фундаментальным подходом и тесной связью с индустрией. Система предоставляет академическую свободу: обязательных предметов немного, остальные дисциплины выбираются самостоятельно. Бакалавриат делится на базовый и основной курсы, а промежуточные экзамены строго контролируют прогресс. Значительный акцент делается на лабораторные занятия и групповые проекты. Многие программы предполагают обязательную стажировку в компаниях, что обеспечивает плавный переход к профессиональной деятельности.",
    "pros": [
      "Высочайший уровень подготовки в инженерных, технических и медицинских областях.",
      "Тесное сотрудничество университетов с крупнейшими международными компаниями.",
      "Академическая свобода в выборе дисциплин и составлении расписания.",
      "Дипломы немецких вузов открывают двери на рынки труда многих стран Европы.",
      "Широкий выбор программ на английском языке, помимо традиционных немецкоязычных."
    ],
    "cons": [
      "Высокий процент отчислений из-за сложной программы и строгих экзаменов.",
      "Для прямого поступления часто требуется обучение в подготовительном колледже.",
      "Необходимость высокой самодисциплины из-за отсутствия жесткого контроля.",
      "Ограниченное количество мест на популярных направлениях (система Numerus clausus)."
    ],
    "source": "article-overview"
  },
  "us": {
    "country": "США",
    "overview": "Соединенные Штаты обладают самой масштабной и престижной системой высшего образования. Обучение на бакалавриате отличается уникальной гибкостью: студенты могут исследовать разные дисциплины перед выбором основной специализации (major) и дополнительной (minor). Образовательный процесс строится на интерактивных семинарах, дискуссиях и групповых проектах, что развивает лидерские качества и критическое мышление. Университеты располагают передовым оснащением и предлагают огромный выбор клубов и сообществ для всестороннего развития.",
    "pros": [
      "Огромный выбор образовательных учреждений и направлений подготовки.",
      "Гибкая система: возможность сменить специализацию в процессе учебы.",
      "Передовое техническое оснащение кампусов и богатая инфраструктура.",
      "Интерактивный формат занятий с упором на развитие критического мышления.",
      "Престижность дипломов и высокие шансы на успешную глобальную карьеру."
    ],
    "cons": [
      "Жесткая конкуренция при поступлении в наиболее престижные заведения.",
      "Высокий уровень стресса из-за постоянной соревновательной среды.",
      "Огромный объем самостоятельной работы и чтения академической литературы.",
      "Сложная система перевода баллов и кредитов между разными учебными заведениями."
    ],
    "source": "article-overview"
  },
  "kr": {
    "country": "Южная Корея",
    "overview": "Высшее образование в Южной Корее — это высококонкурентная среда, где технологические инновации соседствуют с традиционной академической иерархией. Учеба здесь требует максимальной самоотдачи, дисциплины и готовности к интенсивному графику. Бакалавриат предлагает отличную подготовку в STEM-направлениях, IT и инженерии. Университеты тесно сотрудничают с ведущими технологическими корпорациями, предоставляя доступ к передовым лабораториям. При этом студенты первый год часто изучают общие дисциплины, выбирая узкий профиль позже.",
    "pros": [
      "Мировое лидерство в сфере IT, робототехники и инженерных разработок.",
      "Доступ к передовым лабораториям и проектам крупнейших корпораций.",
      "Гибкость программ: возможность выбора конкретной специальности со второго курса.",
      "Развитая инфраструктура и высокотехнологичное оснащение кампусов.",
      "Диплом открывает широкие перспективы на рынках Азиатско-Тихоокеанского региона."
    ],
    "cons": [
      "Экстремально высокая академическая конкуренция и уровень стресса.",
      "Строгая иерархия и субординация в общении с преподавателями.",
      "Для комфортной адаптации жизненно необходимо знание корейского языка.",
      "Сложная бюрократическая система при оформлении документов и виз."
    ],
    "source": "article-overview"
  },
  "gb": {
    "country": "Великобритания",
    "overview": "Британская система высшего образования опирается на многовековые традиции и строгие академические стандарты. Обучение отличается высокой интенсивностью и узкой специализацией с самого начала. Основной упор делается на развитие навыков самостоятельного исследования, аналитического мышления и аргументации. Студенты проводят много времени в библиотеках, работая над эссе и индивидуальными проектами. Вузы обеспечивают сильную поддержку через институт тьюторства и карьерные центры, помогающие со стажировками и трудоустройством.",
    "pros": [
      "Всемирно признанные академические стандарты и престижность дипломов.",
      "Интенсивная подготовка с глубоким погружением в выбранную специальность.",
      "Сильная поддержка студентов через тьюторов и карьерные центры.",
      "Развитие навыков независимого исследования и критического мышления.",
      "Тесная интеграция учебных программ с потребностями крупного бизнеса."
    ],
    "cons": [
      "Узкая специализация ограничивает возможность смены направления в ходе учебы.",
      "Для зачисления часто требуется прохождение программы Foundation.",
      "Высокая интенсивность требует постоянной концентрации и стрессоустойчивости.",
      "Необходимость самостоятельной организации учебного процесса."
    ],
    "source": "article-overview"
  },
  "cn": {
    "country": "Китай",
    "overview": "Китай стремительно развивает систему высшего образования, активно внедряя инновации и международные стандарты. Местные университеты предлагают мощную подготовку в сфере компьютерных наук, инженерии и экономики. Образовательный процесс отличается строгой дисциплиной и высокой интенсивностью. Студенты невероятно мотивированы, что создает конкурентную среду для иностранцев. Учебный план включает как профильные, так и общие дисциплины, а развитая инфраструктура кампусов обеспечивает комфортные условия для научной деятельности.",
    "pros": [
      "Мощная подготовка в области технологий, инженерии и бизнеса.",
      "Большой выбор программ, полностью преподаваемых на английском языке.",
      "Современные кампусы с развитой инфраструктурой и хорошими общежитиями.",
      "Перспективы карьерного роста в связи с глобальным влиянием экономики страны.",
      "Знакомство с уникальной культурой и изучение востребованного китайского языка."
    ],
    "cons": [
      "Строгая дисциплина и высокие требования к посещаемости занятий.",
      "Острая конкуренция со стороны высокомотивированных местных студентов.",
      "Специфика интернет-ограничений требует адаптации к локальным сервисам.",
      "Для полноценной жизни вне кампуса базовый уровень местного языка обязателен."
    ],
    "source": "article-overview"
  },
  "fr": {
    "country": "Франция",
    "overview": "Высшее образование во Франции привлекает сочетанием многовековых традиций и европейских стандартов. Учеба в университетах требует высокой степени самоорганизации: лекции в просторных амфитеатрах дополняются семинарами, но основной объем материала студенты осваивают самостоятельно. Особенностью французской системы является жесткий контроль успеваемости — перевод на следующий курс получают только самые усердные. Особое внимание уделяется гуманитарным наукам, искусству, а также передовой инженерии и международному бизнесу.",
    "pros": [
      "Высокое качество подготовки в области искусства, гуманитарных и точных наук.",
      "Дипломы полностью соответствуют европейским стандартам Болонской системы.",
      "Доступ к богатому культурному и историческому наследию страны.",
      "Знакомство с французским языком, который широко востребован в мире.",
      "Развитие навыков самостоятельного поиска информации и самоорганизации."
    ],
    "cons": [
      "Жесткая система оценивания и высокий риск отчисления за неуспеваемость.",
      "Сложная и многоступенчатая административная бюрократия.",
      "Ограниченный выбор программ на английском языке на уровне бакалавриата.",
      "Формальный подход на лекциях с минимальным личным взаимодействием."
    ],
    "source": "article-overview"
  },
  "es": {
    "country": "Испания",
    "overview": "Испанские университеты предлагают качественное образование по европейским стандартам Болонской системы. Учебный процесс гармонично сочетает лекции, семинары, проектную работу и обязательные практики. Студенческая жизнь здесь наполнена международным общением благодаря огромной популярности программ обмена. Страна привлекает сильными направлениями в бизнесе, архитектуре и гуманитарных науках. Обучение в Испании позволяет не только получить престижный диплом, но и погрузиться в изучение одного из самых распространенных языков.",
    "pros": [
      "Широкое признание дипломов благодаря участию в Болонском процессе.",
      "Отличные программы в сфере бизнеса, архитектуры и гуманитарных наук.",
      "Интернациональная среда и возможность завести связи по всему миру.",
      "Погружение в испанский язык, востребованный в международной корпоративной среде.",
      "Баланс между качественным обучением и насыщенной культурной жизнью."
    ],
    "cons": [
      "Необходимость прохождения сложной процедуры омологации аттестата.",
      "Требование к сдаче специфического вступительного экзамена.",
      "Ограниченное количество полностью англоязычных программ на бакалавриате.",
      "Высокий уровень бюрократии при работе с университетскими администрациями."
    ],
    "source": "article-overview"
  },
  "ae": {
    "country": "ОАЭ",
    "overview": "Объединенные Арабские Эмираты — это глобальный образовательный хаб, объединяющий филиалы ведущих западных университетов. Здесь можно получить престижный британский, американский или австралийский диплом, обучаясь в ультрасовременных кампусах. Образование ориентировано на потребности глобального бизнеса: в топе находятся IT, инженерия, финансы и туризм. Инфраструктура поражает технологичностью, а связи, приобретенные во время учебы, часто становятся главным карьерным трамплином в крупных корпорациях на Ближнем Востоке.",
    "pros": [
      "Возможность получить диплом западного вуза в безопасном и стабильном регионе.",
      "Ультрасовременное оснащение исследовательских лабораторий и кампусов.",
      "Обучение подавляющего большинства программ полностью на английском языке.",
      "Мощный нетворкинг и перспективы карьеры в международных корпорациях.",
      "Практическая направленность программ под нужды глобального рынка."
    ],
    "cons": [
      "Высокий уровень стресса при потере скидок из-за снижения успеваемости.",
      "Отсутствие классической европейской студенческой атмосферы.",
      "Специфический жаркий климат ограничивает активность на улице в летние месяцы.",
      "Суровые требования к поддержанию высокого среднего балла во время учебы."
    ],
    "source": "article-overview"
  },
  "nl": {
    "country": "Нидерланды",
    "overview": "Нидерланды славятся инновационным подходом к образованию, в основе которого лежит проблемно-ориентированное обучение (problem-based learning). Вузы делятся на исследовательские и университеты прикладных наук. Студенты учатся работать в командах, критически мыслить и решать реальные профессиональные задачи. Отношения между преподавателями и учащимися максимально неформальные и демократичные. Страна предлагает огромный выбор англоязычных программ, что делает ее одним из главных студенческих центров на территории Европы.",
    "pros": [
      "Уникальная методика проблемно-ориентированного обучения (PBL).",
      "Огромный выбор программ, преподаваемых полностью на английском языке.",
      "Неформальные, равноправные отношения между преподавателями и студентами.",
      "Четкое разделение на прикладные и научно-исследовательские университеты.",
      "Международная среда и высокий уровень общественной безопасности в стране."
    ],
    "cons": [
      "Для поступления в исследовательский вуз часто требуется подготовительный год.",
      "Острая нехватка мест в студенческих общежитиях и сложности с поиском жилья.",
      "Интенсивная групповая работа, требующая постоянной вовлеченности.",
      "Своеобразный климат с частыми дождями и сильными ветрами."
    ],
    "source": "article-overview"
  },
  "it": {
    "country": "Италия",
    "overview": "Высшее образование в Италии идеально подходит для тех, кто планирует связать жизнь с искусством, архитектурой, дизайном или модой. Учебный процесс отличается высокой степенью академической свободы: студенты самостоятельно формируют учебный план, выбирая интересующие курсы и лекторов. Экзамены чаще всего проходят в устной форме, а подготовка требует изучения огромных объемов теоретического материала. Это развивает самостоятельность, но требует железной дисциплины, навыков планирования времени и высокой мотивации.",
    "pros": [
      "Мировое лидерство в сфере дизайна, моды, архитектуры и искусств.",
      "Академическая свобода в составлении расписания и выборе предметов.",
      "Богатейшее культурное наследие и вдохновляющая творческая атмосфера.",
      "Постоянно увеличивающееся число программ на английском языке.",
      "Возможность погрузиться в изучение итальянского языка и европейской культуры."
    ],
    "cons": [
      "Необходимость проходить подготовительную программу перед поступлением.",
      "Акцент на теорию и заучивание, меньше внимания уделяется практике.",
      "Сложная многоступенчатая бюрократия при оформлении документов.",
      "Специфический формат устных экзаменов, требующий отличной подготовки."
    ],
    "source": "article-overview"
  },
  "ca": {
    "country": "Канада",
    "overview": "Канада предлагает одну из самых престижных и сильных систем высшего образования в мире. Местные университеты и колледжи оснащены передовыми исследовательскими центрами и активно сотрудничают с бизнесом. Учебный процесс сфокусирован на развитии практических навыков, семинарских занятиях и самостоятельной работе. Канадские вузы отличаются гибкостью программ и возможностью комбинировать различные специализации. Безопасные и мультикультурные кампусы обеспечивают максимально комфортную среду для быстрой социальной адаптации.",
    "pros": [
      "Высочайшие стандарты образования и передовая исследовательская база.",
      "Практическая направленность программ и стажировки во время учебы.",
      "Исключительно безопасная, толерантная и мультикультурная среда.",
      "Гибкость в выборе предметов и возможность получить двойную специализацию.",
      "Дипломы канадских учебных заведений безоговорочно признаются во всем мире."
    ],
    "cons": [
      "Большая академическая нагрузка и строгий контроль за успеваемостью.",
      "Специфические требования к поступлению, варьирующиеся в зависимости от провинции.",
      "В некоторых регионах необходимо проходить специальные подготовительные курсы.",
      "Адаптация к суровому климату в ряде северных территорий и провинций."
    ],
    "source": "article-overview"
  },
  "gr": {
    "country": "Греция",
    "overview": "Бакалавриат в Греции отличается нестандартной продолжительностью — от 4 лет обучения. Система предполагает высокую самостоятельность: студенты сами формируют расписание и выбирают факультативы, при этом более половины времени уходит на самообразование. Посещение лекций часто свободное, что требует отличной самодисциплины. Обучение ведется преимущественно на греческом, но иностранцам дается год на языковую подготовку. Диплом признается в Европе и открывает доступ в магистратуру.",
    "pros": [
      "Бесплатное обучение на бакалавриате в государственных университетах.",
      "Отсутствие вступительных экзаменов, зачисление по среднему баллу аттестата.",
      "Предоставление года на изучение греческого языка уже после зачисления.",
      "Широкий спектр студенческих льгот на питание, транспорт и досуг."
    ],
    "cons": [
      "Длительная бюрократическая процедура легализации и признания документов.",
      "Подавляющее большинство программ преподается только на греческом языке.",
      "Студентам часто приходится самостоятельно искать жилье вне кампуса.",
      "Менее структурированный учебный процесс требует идеального тайм-менеджмента."
    ],
    "source": "article-overview"
  },
  "il": {
    "country": "Израиль",
    "overview": "Высшее образование в Израиле базируется на англо-саксонской трехуровневой модели. Программы бакалавриата славятся сильной подготовкой в точных науках, инженерии и медицине. Учебный процесс отличается гибкостью — можно брать дополнительные семестры летом для ускорения учебы. Студентов ждет интенсивная нагрузка, строгий контроль посещаемости и письменные экзамены. Инфраструктура вузов позволяет вести передовые исследования, а диплом высоко котируется за рубежом.",
    "pros": [
      "Высокий уровень программ в сфере IT, инженерии и естественных наук.",
      "Передовая научно-исследовательская база и современные лаборатории.",
      "Наличие образовательных программ, полностью преподаваемых на английском.",
      "Тесная интеграция университетов с передовыми высокотехнологичными компаниями."
    ],
    "cons": [
      "Обязательное прохождение годовой подготовительной программы перед бакалавриатом.",
      "Строгий контроль посещаемости занятий и сложная система сдачи сессий.",
      "Ограниченные возможности для легальной подработки по специальности во время учебы.",
      "Жесткие вступительные требования и высокие проходные баллы."
    ],
    "source": "article-overview"
  },
  "is": {
    "country": "Исландия",
    "overview": "Бакалавриат в Исландии предлагает передовые программы, особенно в сфере возобновляемой энергетики и экологии. Обучение требует высокой самостоятельности: помимо традиционных лекций, активно используется дистанционный формат, когда студенты передают работы через интернет. Успеваемость оценивается по десятибалльной шкале, а для пересдач установлены жесткие лимиты. Программы бакалавриата практически полностью преподаются на исландском языке, что требует серьезной языковой подготовки.",
    "pros": [
      "Сильнейшие в мире программы по энергетике и экологическим наукам.",
      "Инновационные форматы обучения с акцентом на самостоятельность и дистанционные технологии.",
      "Государственные университеты предлагают бесплатное академическое обучение.",
      "Высочайший уровень жизни, экологии и безопасности на территории всей страны."
    ],
    "cons": [
      "Бакалавриат преподается почти исключительно на сложном исландском языке.",
      "Необходимость компенсации академической разницы перед поступлением на первый курс.",
      "Жесткая миграционная политика и необходимость часто продлевать статус резидента.",
      "Лимитированное количество попыток для пересдачи экзаменационных работ."
    ],
    "source": "article-overview"
  },
  "nz": {
    "country": "Новая Зеландия",
    "overview": "Бакалавриат в Новой Зеландии основан на британской модели и обычно длится три года. Система образования отличается исключительной гибкостью: студенты могут комбинировать специализации из разных областей знаний, создавая персонализированный профиль. Оценивание строится на непрерывной работе в течение семестра — учитываются письменные работы, тесты и проекты, а не только финальный экзамен. Вузы тесно связаны с индустрией, что помогает развивать практические навыки.",
    "pros": [
      "Сокращенный до трех лет срок обучения на бакалавриате по британской модели.",
      "Все национальные университеты входят в число лучших мировых учебных заведений.",
      "Гибкая система выбора и комбинации изучаемых дисциплин (major и minor).",
      "Обучение строится на непрерывной оценке знаний, а не только на финальных сессиях."
    ],
    "cons": [
      "Для поступления требуется прохождение подготовительного года (Foundation).",
      "Достаточно высокие требования к уровню владения академическим английским.",
      "Удаленность страны значительно усложняет логистику и путешествия.",
      "Процесс зачисления и сбора необходимых документов занимает много времени."
    ],
    "source": "article-overview"
  },
  "no": {
    "country": "Норвегия",
    "overview": "Бакалавриат в Норвегии отличается практической направленностью и неформальным подходом к обучению. Занятия проходят в небольших группах, где поощряется равенство между студентами и преподавателями. Значительная часть времени отводится на практическую работу и групповые проекты. Учебный год интенсивен, а каникулы короче общеевропейских. Дипломы в области инженерии, IT и социальных наук особенно ценятся работодателями, но выбор англоязычных программ крайне ограничен.",
    "pros": [
      "Высочайший уровень технической оснащенности аудиторий и лабораторий.",
      "Неформальная, психологически комфортная академическая среда.",
      "Передовая практическая подготовка в инженерии, архитектуре и IT.",
      "Высокие стандарты качества жизни, экологии и безопасности на кампусах."
    ],
    "cons": [
      "Практически полное отсутствие программ бакалавриата на английском языке.",
      "Необходимость компенсации академической разницы до поступления.",
      "Жесткие требования к посещаемости занятий для допуска к экзаменам.",
      "Высокие требования к подтверждению финансовой состоятельности."
    ],
    "source": "article-overview"
  },
  "pl": {
    "country": "Польша",
    "overview": "Бакалавриат в Польше привлекает балансом между доступностью и качеством, соответствующим стандартам Болонского процесса. Образовательный процесс классический: обязательное посещение лекций, семинаров и групповых проектов. Существует строгое разделение на гуманитарно-естественные и инженерные степени с разной продолжительностью обучения. Вузы строго следят за посещаемостью и успеваемостью, а сессии требуют серьезной подготовки из-за ограниченного числа пересдач.",
    "pros": [
      "Большой выбор образовательных программ, полностью преподаваемых на английском.",
      "Полное соответствие дипломов общеевропейским академическим стандартам.",
      "Наличие заочных отделений для гибкого планирования образовательного графика.",
      "Развитая инфраструктура и хорошие перспективы для практики в IT-секторе."
    ],
    "cons": [
      "Жесткий контроль посещаемости и высокие требования к дисциплине.",
      "Серьезный риск отчисления после первого семестра из-за накопленных долгов.",
      "Строгие лимиты на количество возможных пересдач профильных экзаменов.",
      "Для комфортной жизни и интеграции за пределами кампуса требуется знание польского."
    ],
    "source": "article-overview"
  },
  "sg": {
    "country": "Сингапур",
    "overview": "Высшее образование в Сингапуре — это строгая, высокотехнологичная и невероятно конкурентная среда. Бакалавриат базируется на модульной системе, позволяющей комбинировать основные и дополнительные специализации. Учебный процесс объединяет британские стандарты качества с азиатской дисциплиной: студенты много работают над практическими проектами и в лабораториях. Оценивание строится на буквенной шкале, а для выпуска обязателен минимальный средний балл и часто дипломный проект.",
    "pros": [
      "Билингвальная образовательная среда с абсолютным приоритетом английского языка.",
      "Интеграция передовых технологий и инноваций в каждый учебный план.",
      "Тесное академическое сотрудничество университетов с глобальными корпорациями.",
      "Высочайший престиж сингапурских дипломов на международном рынке труда."
    ],
    "cons": [
      "Крайне жесткий конкурс и строгий отбор в ведущие учебные заведения.",
      "Огромная академическая нагрузка и постоянная соревновательная атмосфера.",
      "Высокие требования к результатам стандартизированных экзаменов.",
      "Специфический местный диалект английского языка, требующий привыкания."
    ],
    "source": "article-overview"
  },
  "tr": {
    "country": "Турция",
    "overview": "Бакалавриат в Турции динамично развивается, перенимая европейские стандарты по Болонской системе. В стране работают как массовые государственные, так и элитные частные университеты с западным подходом к обучению. Учеба включает лекции, проектные работы и промежуточные экзамены, которые формируют итоговую оценку. Инфраструктура передовых кампусов предлагает современные лаборатории. Особое внимание уделяется программам по инженерии, медицине, архитектуре и бизнесу.",
    "pros": [
      "Широкий выбор программ бакалавриата, преподаваемых полностью на английском.",
      "Активное участие местных университетов в программах международного обмена.",
      "Современные кампусы и отличная инфраструктура в ведущих частных вузах.",
      "Возможность взять дополнительный подготовительный год для изучения языка."
    ],
    "cons": [
      "Значительный разрыв в качестве образования между топовыми и рядовыми вузами.",
      "Необходимость сдачи специфических вступительных национальных экзаменов.",
      "Сильная бюрократизация административных процессов внутри учебных заведений.",
      "Нестабильность национальной валюты, влияющая на ценообразование в частном секторе."
    ],
    "source": "article-overview"
  },
  "fi": {
    "country": "Финляндия",
    "overview": "Финский бакалавриат выделяется исключительной гибкостью и практической направленностью. Здесь нет жесткого контроля: студенты сами формируют план, выбирая курсы и модули. Оценивание строится на непрерывной работе, презентациях и групповых проектах, а не на финальных экзаменах. Университеты тесно интегрированы с индустрией, что позволяет студентам участвовать в реальных разработках. Образование развивает самостоятельность, креативность и навыки тайм-менеджмента.",
    "pros": [
      "Инновационный подход с упором на проектную работу и групповое взаимодействие.",
      "Полная академическая свобода в планировании индивидуальной учебной нагрузки.",
      "Прямая связь исследовательских лабораторий с передовым бизнес-сектором.",
      "Развитие критического мышления в психологически комфортной среде без стресса."
    ],
    "cons": [
      "Бакалаврские программы на английском языке крайне малочисленны.",
      "Обучение требует колоссальной самоорганизации из-за отсутствия внешнего контроля.",
      "Жесткий конкурсный отбор, при котором вузы принимают небольшой процент заявок.",
      "Специфические и сложные вступительные испытания в ряде университетов."
    ],
    "source": "article-overview"
  },
  "cz": {
    "country": "Чехия",
    "overview": "Чешский бакалавриат гармонично сочетает академическую строгость с гибкостью учебного процесса. Студентам предлагается небольшое количество обязательных предметов, а остальное расписание, включая выбор преподавателей, они формируют сами. Помимо лекций, активно используются семинары и проектные работы в малых группах. Сессии требуют глубокой самостоятельной подготовки. Вузы активно развивают программы международного обмена, позволяя провести часть обучения за рубежом.",
    "pros": [
      "Полностью бесплатное обучение на программах, преподаваемых на чешском языке.",
      "Широкие возможности участия в программах студенческого обмена по всему миру.",
      "Свобода в выборе факультативных дисциплин и профессорско-преподавательского состава.",
      "Высокое качество академической подготовки на инженерных и технических курсах."
    ],
    "cons": [
      "Строгие ограничения на количество попыток пересдачи экзаменационных испытаний.",
      "Многоступенчатая процедура признания (нострификации) школьного аттестата.",
      "Высокий риск отчисления из-за нарушенных дедлайнов или не сданной вовремя сессии.",
      "Англоязычные программы в государственных университетах всегда являются платными."
    ],
    "source": "article-overview"
  },
  "se": {
    "country": "Швеция",
    "overview": "Образование в Швеции ориентировано на развитие независимого и критического мышления. Учебный процесс построен на неформальном взаимодействии с профессорами, групповых проектах и анализе реальных кейсов. Аудиторных часов немного, основной упор делается на глубокую самостоятельную подготовку. Студенты имеют возможность составлять индивидуальные планы, комбинируя дисциплины из разных областей. Шведская система требует от учащихся высокой самодисциплины и инициативности.",
    "pros": [
      "Огромный выбор актуальных бакалаврских программ на английском языке.",
      "Инновационный подход, поощряющий дискуссии и творческое решение задач.",
      "Неформальная, равноправная и демократичная атмосфера в учебных аудиториях.",
      "Сильнейшая научно-исследовательская база и передовые академические лаборатории."
    ],
    "cons": [
      "Ранние и строгие дедлайны подачи документов, требующие длительного планирования.",
      "Отсутствие жесткого контроля обязывает к идеальному тайм-менеджменту.",
      "Процесс поступления часто усложняется требованием высоких баллов по тестам.",
      "Сложная бюрократия при решении административных и организационных вопросов."
    ],
    "source": "article-overview"
  },
  "in": {
    "country": "Индия",
    "overview": "Бакалавриат в Индии строится по англо-саксонской модели с акцентом на технические, инженерные и естественнонаучные дисциплины. Обучение ведется на английском языке, что упрощает интеграцию в академическую среду. Система характеризуется жесткой конкуренцией и фокусом на интенсивное запоминание больших объемов информации. Кампусы ведущих институтов предлагают хорошую техническую базу, однако учебные аудитории часто бывают переполнены из-за невероятно высокого спроса.",
    "pros": [
      "Топовая академическая подготовка в сфере IT, инженерии и точных наук.",
      "Образовательные программы полностью преподаются на государственном английском.",
      "Упрощенная процедура зачисления без сложной легализации образовательных документов.",
      "Наличие удобной централизованной системы подачи заявок сразу в несколько вузов."
    ],
    "cons": [
      "Специфический стиль преподавания с ярко выраженным упором на механическое заучивание.",
      "Переполненные учебные аудитории и высочайшая конкуренция за оценки.",
      "Достаточно жесткая психологическая обстановка из-за сильного духа соперничества.",
      "Жесткие ограничения на возможности легальной подработки во время учебного процесса."
    ],
    "source": "article-overview"
  },
  "ar": {
    "country": "Аргентина",
    "overview": "Бакалавриат в Аргентине отличается сильной теоретической базой. Обучение полностью бесплатно для всех, но поступление требует прохождения обязательного подготовительного года. Программы строго структурированы, выбор элективов минимален. Основной язык — испанский. Образовательный процесс делает большой акцент на результаты экзаменов, а посещаемость строго контролируется и напрямую влияет на допуск к сессии. Большинство студентов успешно совмещают учебу с профессиональной деятельностью.",
    "pros": [
      "Полностью бесплатное обучение на программах бакалавриата в государственных вузах.",
      "Отсутствие традиционных вступительных экзаменов при зачислении в госуниверситеты.",
      "Высокая престижность дипломов ведущих вузов в латиноамериканском регионе.",
      "Понятные и относительно простые миграционные правила для оформления статуса резидента."
    ],
    "cons": [
      "Практически полное отсутствие бакалаврских программ, преподаваемых на английском.",
      "Огромное значение итоговых экзаменов, создающее стресс в период сессий.",
      "Децентрализация учебных программ усложняет стандартизацию полученных знаний.",
      "Строгие требования к уровню посещаемости для получения допуска к сдаче экзаменов."
    ],
    "source": "article-overview"
  },
  "ie": {
    "country": "Ирландия",
    "overview": "Бакалавриат в Ирландии тесно перекликается с британской академической традицией, предлагая интенсивное и качественное образование на английском языке. Студентов ждут семинары, исследовательские проекты и практические занятия, развивающие критическое мышление. Многие программы включают стажировки и тесно связаны с IT- и биофармацевтическим секторами. Ирландские институты отличаются инклюзивностью и передовым оснащением, предлагая студентам отличную инфраструктуру и поддержку.",
    "pros": [
      "Качественное и глубокое англоязычное образование по классической британской модели.",
      "Плотая интеграция учебных программ с потребностями IT и технологического секторов.",
      "Поступление возможно сразу после окончания школы при высоких академических оценках.",
      "Инклюзивная образовательная среда с развитой поддержкой для всех категорий студентов."
    ],
    "cons": [
      "Специфический местный акцент английского языка требует периода привыкания и адаптации.",
      "Ряд топовых университетов может потребовать прохождения дополнительного года подготовки.",
      "Высокая интенсивность учебного процесса и строгий контроль за выполнением заданий.",
      "Суровый и переменчивый островной климат с традиционно высоким уровнем влажности."
    ],
    "source": "article-overview"
  },
  "lt": {
    "country": "Литва",
    "overview": "Бакалавриат в Литве привлекает сочетанием европейских стандартов качества и академической доступности. Учебный процесс быстро адаптируется под современные реалии: на гуманитарных направлениях активно применяются дискуссии и метод кейсов, а на технических — лабораторные и полевые исследования. Обучение длится около четырех лет, в течение которых студенты могут участвовать в международных обменах. Большинство англоязычных программ сосредоточено в наиболее востребованных сферах: IT, инженерия, дизайн и бизнес.",
    "pros": [
      "Высокое качество жизни и благоприятная экологическая обстановка в стране.",
      "Доступно множество программ бакалавриата полностью на английском языке.",
      "Широкие возможности участия в программах международного студенческого обмена.",
      "Интерактивные методы обучения с упором на самостоятельную проектную работу."
    ],
    "cons": [
      "Бесплатные академические места недоступны для иностранных абитуриентов.",
      "Сложности с официальным трудоустройством на первых курсах из-за визовых правил.",
      "Ассортимент англоязычных программ ограничен специфическими направлениями.",
      "Обязательная процедура государственного признания аттестата до зачисления."
    ],
    "source": "article-overview"
  },
  "bg": {
    "country": "Болгария",
    "overview": "Высшее образование в Болгарии предоставляет качественные программы европейского стандарта, особенно в области медицины, туризма и гостеприимства. Обучение на бакалавриате занимает четыре года. Образовательный процесс включает обязательные лекции, профильные семинары и практические занятия. В государственных университетах большинство направлений преподается на болгарском, однако медицинские и экономические специализации часто доступны на английском. Выданные дипломы признаются на всей территории Европейского Союза.",
    "pros": [
      "Безоговорочное признание болгарских дипломов во всех странах Евросоюза.",
      "Наличие качественных англоязычных программ в сфере медицины и туризма.",
      "Мягкий климат, богатая природа и обилие исторических достопримечательностей.",
      "Близкий и относительно понятный язык для быстрой адаптации и изучения."
    ],
    "cons": [
      "Крайне ограниченный выбор англоязычных программ вне медицинских специальностей.",
      "Сложная и строго регламентированная процедура перевода образовательных документов.",
      "Полное отсутствие возможностей получить государственную стипендию для иностранцев.",
      "Необходимость предоставления специфических справок из школы при зачислении."
    ],
    "source": "article-overview"
  },
  "br": {
    "country": "Бразилия",
    "overview": "Бакалавриат в Бразилии предлагает глубокую академическую подготовку, особенно в ведущих государственных университетах. Обучение длится от четырех до шести лет и отличается строгой структурой: в первый год осваиваются общие дисциплины, затем начинается узкая специализация. Учебный план завершается дипломной или исследовательской работой. Государственные вузы предоставляют бесплатное образование для всех, однако поступление требует успешной сдачи сложного единого национального экзамена на португальском языке.",
    "pros": [
      "Обучение в престижных государственных университетах полностью бесплатно.",
      "Сильная академическая подготовка в передовых исследовательских центрах страны.",
      "Простая и понятная процедура легализации статуса после окончания учебы.",
      "Развитая инфраструктура кампусов с современными библиотеками и лабораториями."
    ],
    "cons": [
      "Обязательная сдача сложного единого национального экзамена на португальском.",
      "Практически полное отсутствие бакалаврских программ на английском языке.",
      "Строгий законодательный запрет на официальное трудоустройство во время учебы.",
      "Острый дефицит мест в студенческих общежитиях для иностранных учащихся."
    ],
    "source": "article-overview"
  },
  "ge": {
    "country": "Грузия",
    "overview": "Система высшего образования Грузии полностью интегрирована в Болонский процесс. Бакалавриат длится четыре года и опирается на систему европейских кредитов. Обучение отличается доступностью и гибкостью: для зачисления часто достаточно аттестата и прохождения профильного собеседования без необходимости сдачи сложных национальных тестирований. В крупных университетах активно развиваются англоязычные направления. Студенческая жизнь дополняется мягким климатом, колоритной культурой и гостеприимной атмосферой региона.",
    "pros": [
      "Максимально упрощенная процедура зачисления на основе онлайн-собеседования.",
      "Постоянно растущее количество программ, полностью преподаваемых на английском.",
      "Отсутствие законодательных ограничений на подработку во время учебы.",
      "Мягкий климат, живописная природа и знаменитый уровень гостеприимства."
    ],
    "cons": [
      "Скромный выбор университетов, занимающих высокие места в мировых рейтингах.",
      "Крайне ограниченное количество доступных грантов для иностранных учащихся.",
      "Периодически возникают сложности с поиском высокооплачиваемой подработки.",
      "Инфраструктура и оснащение некоторых вузов требуют существенной модернизации."
    ],
    "source": "article-overview"
  },
  "dk": {
    "country": "Дания",
    "overview": "Бакалавриат в Дании выделяется инновационным и практико-ориентированным подходом к академическому обучению. Преподаватели часто являются действующими экспертами в своих отраслях, что гарантирует актуальность знаний. Образовательный процесс строится на открытых дебатах, командной проектной работе и решении реальных кейсов. Такая методика развивает креативность и самостоятельность. Университетские программы глубоко интегрированы с бизнес-сектором, предлагая студентам участие в реальных исследованиях и стажировках.",
    "pros": [
      "Инновационный метод проблемно-ориентированного обучения в проектных группах.",
      "Тесная интеграция учебных программ с индустрией и реальным бизнес-сектором.",
      "Активное развитие навыков критического мышления, креативности и работы в команде.",
      "Высочайшие мировые стандарты экологии, безопасности и качества жизни в стране."
    ],
    "cons": [
      "Крайне малый выбор англоязычных бакалаврских программ в государственных вузах.",
      "Специфическая система группового оценивания, не всегда комфортная для студентов.",
      "Необходимость компенсации академической разницы при прямом поступлении после школы.",
      "Острый дефицит доступного студенческого жилья в крупных академических центрах."
    ],
    "source": "article-overview"
  },
  "my": {
    "country": "Малайзия",
    "overview": "Высшее образование в Малайзии стремительно набирает авторитет на международной арене. Страна предлагает уникальную возможность получить диплом западного образца благодаря многочисленным филиалам ведущих британских, американских и австралийских университетов. Бакалавриат длится от трех до пяти лет и полностью интегрирован в мировую академическую среду. Учебные планы нацелены на интенсивную академическую работу, а преподавание в подавляющем большинстве случаев ведется на английском языке.",
    "pros": [
      "Огромный выбор бакалаврских программ, полностью преподаваемых на английском.",
      "Наличие филиалов рейтинговых западных вузов, выдающих оригинальные дипломы.",
      "Многонациональная студенческая среда, способствующая быстрой социальной адаптации.",
      "Относительно доступная инфраструктура и высокий уровень безопасности в стране."
    ],
    "cons": [
      "Традиционный азиатский подход с упором на заучивание и сдачу тестов.",
      "Жесткие миграционные ограничения на подработку во время учебных семестров.",
      "Сложности с оформлением разрешения на работу и легализацией после выпуска.",
      "Жаркий тропический климат с высокой влажностью может быть тяжелым для адаптации."
    ],
    "source": "article-overview"
  },
  "pt": {
    "country": "Португалия",
    "overview": "Бакалавриат в Португалии (Licenciatura) привлекает комфортной образовательной средой и глубокой интеграцией в систему Болонского процесса. Учеба длится от трех до четырех лет и гармонично сочетает лекционные форматы с практическими семинарами. Ключевая особенность португальских вузов — лояльное отношение к студентам и отсутствие излишнего формализма: многие преподаватели поощряют творческую работу и свободные исследования. Диплом открывает широкие профессиональные возможности в странах Европы и Латинской Америки.",
    "pros": [
      "Дружелюбная, неформальная и поддерживающая атмосфера в учебных заведениях.",
      "Возможность изучения востребованного португальского языка в естественной среде.",
      "Активное развитие программ двойных дипломов совместно с зарубежными партнерами.",
      "Мягкий климат, богатая культура и комфортные условия для студенческой жизни."
    ],
    "cons": [
      "Серьезный дефицит программ бакалавриата, полностью преподаваемых на английском.",
      "Отсутствие строгой пунктуальности и медлительность в бюрократических процессах.",
      "Сложная ситуация на рынке труда и высокий уровень молодежной безработицы.",
      "Многоступенчатая процедура официального подтверждения документов об образовании."
    ],
    "source": "article-overview"
  },
  "sa": {
    "country": "Саудовская Аравия",
    "overview": "Высшее образование в Саудовской Аравии стремительно модернизируется благодаря масштабным государственным инвестициям. Бакалавриат длится от трех до четырех лет и предлагает передовые программы в сфере инженерии, бизнеса и инновационных технологий. Ведущие университеты обладают ультрасовременными кампусами и мощными исследовательскими лабораториями. Учебный процесс строго разделен по гендерному признаку. Значительная часть академических направлений преподается на английском языке, привлекая таланты со всего мира.",
    "pros": [
      "Наличие щедрых правительственных и университетских программ финансирования.",
      "Ультрасовременная инфраструктура и передовые исследовательские центры.",
      "Высокая доля программ бакалавриата, полностью преподаваемых на английском.",
      "Привлечение лучших иностранных преподавателей за счет высоких инвестиций."
    ],
    "cons": [
      "Строгие правила поведения и дресс-кода, продиктованные религиозными нормами.",
      "Обязательное раздельное обучение и строгая сегрегация по гендерному признаку.",
      "Специфический жаркий климат, сильно ограничивающий пребывание на улице.",
      "Крайне ограниченные возможности для развлечений и привычной студенческой жизни."
    ],
    "source": "article-overview"
  },
  "rs": {
    "country": "Сербия",
    "overview": "Высшее образование в Сербии предлагает классический европейский академический подход, полностью интегрированный в Болонскую систему. Обучение на бакалавриате длится от трех до четырех лет. Учебный процесс отличается строгостью и обязательным прохождением вступительных испытаний по профильным дисциплинам. Студентов ждут регулярные лекции, семинары и серьезные сессионные проверки знаний. Инфраструктура университетов активно развивается, а дипломы признаются на территории всей Европы, обеспечивая профессиональную мобильность.",
    "pros": [
      "Полное соответствие образовательных программ стандартам Болонского процесса.",
      "Наличие смешанных и полностью англоязычных программ в крупных университетах.",
      "Упрощенная процедура подготовки документов без обязательного апостилирования.",
      "Исключительное гостеприимство местных жителей и комфортная социальная среда."
    ],
    "cons": [
      "Обязательная сдача сложных вступительных экзаменов при зачислении на первый курс.",
      "Практическое отсутствие доступных государственных грантов для иностранных учащихся.",
      "Ограниченный доступ к местам в недорогих государственных студенческих общежитиях.",
      "Необходимость владения сербским языком для полноценной интеграции и трудоустройства."
    ],
    "source": "article-overview"
  },
  "sk": {
    "country": "Словакия",
    "overview": "Бакалавриат в Словакии предоставляет стабильное европейское образование с сильным акцентом на технические, медицинские и экономические специальности. Обучение занимает от трех до четырех лет и строго построено по кредитной системе ECTS. Университеты предлагают как бесплатные программы на государственном языке, так и платные англоязычные курсы. Учебный план классический: он включает лекции, лабораторные и проектные работы. Зачисление лояльное — на многие направления принимают по результатам собеседования.",
    "pros": [
      "Возможность абсолютно бесплатного обучения при знании государственного языка.",
      "Упрощенная процедура зачисления, часто не требующая международных языковых тестов.",
      "Наличие широкого спектра программ-дублеров, полностью преподаваемых на английском.",
      "Комфортное географическое положение для беспрепятственных путешествий по Европе."
    ],
    "cons": [
      "Сильное преобладание теоретического подхода над практическими и лабораторными занятиями.",
      "Необходимость прохождения сложной процедуры признания школьного аттестата до зачисления.",
      "Достаточно низкий уровень развития инфраструктуры в некоторых провинциальных вузах.",
      "Ограниченные перспективы быстрого построения высокооплачиваемой карьеры внутри страны."
    ],
    "source": "article-overview"
  },
  "th": {
    "country": "Таиланд",
    "overview": "Высшее образование в Таиланде стремительно интернационализируется, привлекая студентов современными программами и тесным партнерством с западными вузами. Бакалавриат длится четыре года и предлагает множество форматов двойных дипломов, когда финальная часть обучения проходит в Австралии или Великобритании. Студенческая жизнь подчинена строгим академическим правилам. Университеты обеспечивают передовую базу для изучения международного туризма, бизнеса, маркетинга и экологии в колоритной азиатской среде.",
    "pros": [
      "Огромный выбор международных программ с преподаванием полностью на английском языке.",
      "Развитая система двойных дипломов совместно с ведущими западными университетами.",
      "Теплая, толерантная и исключительно гостеприимная культурная среда для иностранцев.",
      "Обучение востребованным профессиям в сфере туризма, гостиничного бизнеса и маркетинга."
    ],
    "cons": [
      "Строгие правила дисциплины, включая обязательное ношение студенческой униформы.",
      "Полный законодательный запрет на официальное трудоустройство вне кампуса по студенческой визе.",
      "Необходимость регулярного бюрократического подтверждения адреса проживания в стране.",
      "Специфический тропический климат и особенности местной системы здравоохранения."
    ],
    "source": "article-overview"
  },
  "hr": {
    "country": "Хорватия",
    "overview": "Хорватский бакалавриат привлекает студентов современной академической системой, полностью соответствующей стандартам Болонского процесса. Обучение длится от трех до четырех лет. Образовательный процесс разделен на академический (в университетах) и прикладной (в политехникумах) треки. Вузы активно развивают программы международной мобильности, что позволяет легко получать опыт в других странах ЕС. Наличие интегрированных программ позволяет осваивать сложные специальности непрерывно до уровня магистра.",
    "pros": [
      "Наличие интегрированных программ, объединяющих ступени бакалавриата и магистратуры.",
      "Активная поддержка международного студенческого обмена и академической мобильности.",
      "Отсутствие строгих визовых ограничений и лимитов на студенческую подработку.",
      "Теплый морской климат, красивая природа и развитая туристическая инфраструктура."
    ],
    "cons": [
      "Необходимость прохождения вступительных испытаний или тестов по профильным предметам.",
      "Строгие квоты и серьезные ограничения на прием иностранных абитуриентов.",
      "Отсутствие крупных государственных стипендий для финансирования полного курса обучения.",
      "Крайне малый выбор англоязычных программ непосредственно на ступени бакалавриата."
    ],
    "source": "article-overview"
  },
  "ee": {
    "country": "Эстония",
    "overview": "Бакалавриат в Эстонии — это полное погружение в одну из самых высокотехнологичных и цифровизированных образовательных систем Европы. Программы длятся три года и базируются на строгих европейских стандартах. Вузы предлагают передовой подход: студенты могут гибко комбинировать основную и дополнительную специализации. Все административные процессы полностью переведены в онлайн-формат. Эстония по праву славится инновациями в IT-сфере, кибербезопасности, электронном управлении и мощной стартап-экосистеме.",
    "pros": [
      "Абсолютная цифровизация учебного процесса и бытовых бюрократических процедур.",
      "Возможность бесплатного академического обучения при подтвержденном знании эстонского языка.",
      "Огромный выбор актуальных программ, полностью преподаваемых на английском.",
      "Отсутствие законодательных ограничений на количество часов подработки во время учебы."
    ],
    "cons": [
      "Специфические вступительные испытания, включающие онлайн-интервью и профильные тесты.",
      "Обязательное требование к глубокому знанию сложного эстонского языка для интеграции.",
      "Небольшой выбор культурных и развлекательных активностей за пределами столицы.",
      "Сложный климат с коротким световым днем и продолжительными холодными зимами."
    ],
    "source": "article-overview"
  },
  "hk": {
    "country": "Гонконг",
    "overview": "Высшее образование сочетает традиции британской академической системы и невероятное азиатское трудолюбие. Обучение ведется преимущественно на английском языке, что привлекает студентов со всего мира. Бакалавриат предполагает интенсивную нагрузку, строгую дисциплину и высочайшую конкуренцию за оценки. Университеты отличаются ультрасовременной инфраструктурой и тесными связями с мировыми корпорациями. Студенты сами контролируют свой академический прогресс и набор кредитов. Мегаполис является одним из ведущих финансовых центров, открывая колоссальные перспективы для практики.",
    "pros": [
      "Высокие позиции местных университетов в престижных международных рейтингах.",
      "Преподавание подавляющего большинства программ полностью на английском языке.",
      "Огромные карьерные перспективы в одном из главных финансовых центров мира.",
      "Развитая транспортная и технологическая инфраструктура космополитичного мегаполиса."
    ],
    "cons": [
      "Высочайшая конкуренция и достаточно стрессовая академическая среда.",
      "Строгая дисциплина и неукоснительное требование уважительной субординации.",
      "Специфический местный акцент английского языка требует длительной адаптации.",
      "Чрезвычайно высокая плотность населения и специфический жаркий климат."
    ],
    "source": "article-overview"
  },
  "hu": {
    "country": "Венгрия",
    "overview": "Бакалавриат предоставляет качественное европейское образование с сильным акцентом на фундаментальную теорию. Университеты активно внедряют международные стандарты, предлагая сотни программ полностью на английском языке, что позволяет учиться без знания сложного местного языка. Учебный процесс опирается на классические методы преподавания с лекциями и семинарами. Государство и университеты предлагают масштабные программы поддержки для талантливых иностранцев. Дипломы имеют мировое признание благодаря интеграции в Болонскую систему кредитов.",
    "pros": [
      "Широчайший выбор программ бакалавриата, преподаваемых на английском языке.",
      "Развитая система правительственных грантов, полностью покрывающих расходы.",
      "Центральное расположение в Европе, максимально удобное для путешествий.",
      "Безоговорочное признание полученных дипломов во всех европейских странах."
    ],
    "cons": [
      "Традиционный академический подход с явным перевесом теории над практикой.",
      "Необходимость владения местным языком для комфортной жизни за пределами кампуса.",
      "Ограниченные перспективы быстрого трудоустройства внутри страны без знания языка.",
      "Умеренные позиции большинства национальных университетов в глобальных рейтингах."
    ],
    "source": "article-overview"
  },
  "lv": {
    "country": "Латвия",
    "overview": "Бакалавриат предлагает европейское образование с большим выбором программ на английском языке. Система высшего образования активно модернизируется, интегрируясь в международное академическое пространство. Программы делятся на академические, нацеленные на исследования, и профессиональные, ориентированные на прикладные навыки. Обучение сопровождается умеренной нагрузкой и возможностью выбора элективных курсов. Мультиязычная среда внутри страны способствует быстрой адаптации и максимально комфортному повседневному общению за пределами аудиторий.",
    "pros": [
      "Доступность большого числа программ, преподаваемых полностью на английском языке.",
      "Сильная практическая направленность профессиональных бакалаврских программ.",
      "Мультиязычная социальная среда, значительно облегчающая бытовую адаптацию.",
      "Выданные дипломы признаются на территории всех государств Европейского союза."
    ],
    "cons": [
      "Сложности с интеграцией на местный рынок труда без знания государственного языка.",
      "Крайне ограниченное количество доступных программ финансовой поддержки.",
      "Необходимость прохождения процедуры признания некоторых образовательных документов.",
      "Сложности с поиском стажировок в местных компаниях исключительно с английским."
    ],
    "source": "article-overview"
  },
  "ro": {
    "country": "Румыния",
    "overview": "Бакалавриат предлагает доступное европейское образование в строгих рамках Болонской системы. Обучение длится от трех до четырех лет и охватывает широкий спектр специализаций. Университеты выделяются мультиязычностью: помимо национального языка, программы преподаются на английском, французском и немецком. Учебный план строится на основе системы кредитов ECTS. Академическая среда отличается лояльностью, а университеты часто не требуют сдачи сложных стандартизированных тестов, ограничиваясь общим конкурсом аттестатов и проверкой языкового сертификата.",
    "pros": [
      "Возможность обучаться на выбор на английском, французском или немецком языках.",
      "Отсутствие сложных вступительных экзаменов на абсолютное большинство специальностей.",
      "Диплом стандартизированного европейского образца, признаваемый во всем мире.",
      "Наличие правительственных грантов, полностью покрывающих базовые расходы на учебу."
    ],
    "cons": [
      "Частое взимание дополнительной платы за пересдачи и внутренние вступительные испытания.",
      "Бюрократические сложности и не всегда адаптированные для иностранцев сайты вузов.",
      "Острая необходимость знания государственного языка для успешного трудоустройства.",
      "Ограниченные перспективы для построения высокооплачиваемой карьеры внутри страны."
    ],
    "source": "article-overview"
  },
  "ru": {
    "country": "Россия",
    "overview": "Бакалавриат предлагает фундаментальную академическую подготовку с мощным акцентом на инженерные, математические и естественнонаучные специальности. Обучение длится четыре года и базируется на классической модели с обязательными лекциями, семинарами и жестко фиксированным учебным планом, где свобода выбора дисциплин ограничена. Преподавание ведется преимущественно на государственном языке, что чаще всего требует предварительного прохождения языкового подготовительного года. Ведущие исследовательские центры обладают передовым техническим оснащением.",
    "pros": [
      "Сильнейшая фундаментальная подготовка в области точных наук и инженерии.",
      "Возможность обучаться бесплатно за счет масштабных программ государственной поддержки.",
      "Доступная развитая инфраструктура и насыщенная студенческая жизнь на базе кампусов.",
      "Огромный выбор узконаправленных специальностей в ведущих национальных университетах."
    ],
    "cons": [
      "Преобладание глубокого теоретического подхода в ущерб развитию практических навыков.",
      "Острая необходимость прохождения подготовительного факультета из-за языкового барьера.",
      "Крайне ограниченное количество программ бакалавриата, преподаваемых на английском.",
      "Многоступенчатая процедура официального признания выданных дипломов за рубежом."
    ],
    "source": "article-overview"
  },
  "at": {
    "country": "Австрия",
    "overview": "Бакалавриат в Австрии привлекает свободой построения учебного процесса и высоким качеством программ. Студенты самостоятельно формируют расписание, выбирают дисциплины, преподавателей и темы курсовых работ. Такая академическая независимость требует высокой мотивации и отличных навыков тайм-менеджмента. Практические занятия направлены на развитие прикладных компетенций, таких как академическое письмо. Обучение ведется преимущественно на немецком языке, но предлагаются и англоязычные направления. Особенностью является возможность за дополнительную плату посещать лекции в других вузах страны.",
    "pros": [
      "Огромная академическая свобода в выборе предметов, преподавателей и расписания.",
      "Высокое качество образовательных программ и европейские стандарты обучения.",
      "Практические занятия ориентированы на освоение конкретных прикладных навыков.",
      "Возможность за дополнительную плату проходить нужные курсы в других университетах."
    ],
    "cons": [
      "Высокий процент отчислений из-за сложности программ и нехватки внешнего контроля.",
      "Сложно найти место в студенческом общежитии из-за большого наплыва учащихся.",
      "Для комфортной жизни и перспектив на рынке труда обязательно знание местного языка.",
      "Отсутствие жесткого контроля требует идеальной самодисциплины и высокой мотивации."
    ],
    "source": "article-overview"
  },
  "be": {
    "country": "Бельгия",
    "overview": "Высшее образование в Бельгии отличается гибкостью и децентрализацией: учебным процессом управляют французское и фламандское сообщества. Бакалавриат делится на профессиональный, ориентированный на быстрый выход на рынок труда, и академический, подготавливающий к магистратуре и научной деятельности. Система обучения предполагает высокий уровень самостоятельной работы, где студенты уделяют много времени чтению и домашним заданиям. Экзамены включают теорию и практику, а в случае неудачи предусмотрена дополнительная сессия пересдач в конце лета.",
    "pros": [
      "Разделение бакалавриата на академический и профессиональный (прикладной) треки.",
      "Уникальная мультиязычная и мультикультурная среда в самом центре Европы.",
      "Отсутствие вступительных экзаменов на абсолютное большинство гуманитарных специальностей.",
      "Доступ к стажировкам в штаб-квартирах крупных международных организаций."
    ],
    "cons": [
      "Высокий процент отсева на первом курсе из-за интенсивной самостоятельной нагрузки.",
      "Специфическая бюрократия, требующая заполнения большого количества форм и бланков.",
      "Англоязычных программ на бакалавриате мало, необходимо знание национальных языков.",
      "Сложная система признания документов об образовании во франкоязычных университетах."
    ],
    "source": "article-overview"
  },
  "ch": {
    "country": "Швейцария",
    "overview": "Швейцарское высшее образование формировалось под влиянием немецкой, французской и англосаксонской академических традиций. Страна славится передовыми программами в сфере естественных наук, инженерии и гостиничного бизнеса. Государственные университеты ориентированы на фундаментальные исследования, а университеты прикладных наук предлагают практическое обучение с обязательными стажировками. Инфраструктура вузов великолепно оснащена благодаря мощному государственному финансированию, однако из-за высокой популярности аудитории могут быть переполнены.",
    "pros": [
      "Мировое лидерство в сфере гостиничного бизнеса, инженерии и естественных наук.",
      "Многоязычная культура, позволяющая учиться на немецком, французском или итальянском.",
      "Интернациональная среда, где иностранцев зачастую больше, чем местных студентов.",
      "Мощная исследовательская база и щедрое государственное финансирование университетов."
    ],
    "cons": [
      "Аудитории в наиболее престижных государственных вузах часто бывают переполнены.",
      "Строгие государственные квоты сильно ограничивают возможности трудоустройства иностранцев.",
      "Крайне малое количество образовательных программ на английском языке для бакалавров.",
      "Специфическая процедура прямого зачисления требует сдачи дополнительного экзамена."
    ],
    "source": "article-overview"
  },
  "jp": {
    "country": "Япония",
    "overview": "Высшее образование в Японии славится передовыми программными направлениями в области инженерии, робототехники и информационных технологий. Учебный процесс пронизан традиционной культурой: в аудиториях и лабораториях соблюдается строгая иерархия и абсолютное уважение к профессорам. Страна предлагает программы на английском языке, однако для полноценной жизни и успешного трудоустройства необходимо знание японского. Местные университеты тесно сотрудничают с глобальными корпорациями, что открывает студентам доступ к передовым разработкам и технологиям.",
    "pros": [
      "Мировое лидерство учебных программ в сфере высоких технологий, инженерии и робототехники.",
      "Широкие возможности для прохождения стажировок в крупнейших международных корпорациях.",
      "Наличие сотен англоязычных программ бакалавриата, не требующих знания национального языка.",
      "Уникальная исследовательская культура и доступ к передовым научным разработкам."
    ],
    "cons": [
      "Строгая академическая иерархия, не предполагающая свободных дискуссий с преподавателями.",
      "Без знания сложного японского языка перспективы карьерного роста крайне ограничены.",
      "Необходимость сдачи сложного профильного экзамена для поступления на японские программы.",
      "Специфическая корпоративная культура и выраженное гендерное неравенство на рынке труда."
    ]
  },
  "am": {
    "country": "Армения",
    "overview": "Образование в Армении активно развивается и постепенно интегрируется в европейское академическое пространство. Университеты предлагают программы, особенно сильные в сферах IT, прикладной математики, физики и медицины. Обучение на бакалавриате стандартно длится четыре года. Академическая среда отличается традиционным подходом с упором на фундаментальные теоретические знания, классические лекции и семинары. Студентов ждет гостеприимная культура и быстрая социальная адаптация. Многие востребованные программы доступны на английском языке, что существенно облегчает процесс обучения.",
    "pros": [
      "Сильные академические традиции в области точных наук и IT-технологий.",
      "Доступность многих образовательных программ на английском языке.",
      "Простая и понятная процедура зачисления без сложных бюрократических преград.",
      "Мягкий климат, богатая культура и традиционное кавказское гостеприимство."
    ],
    "cons": [
      "Инфраструктура и оснащение некоторых региональных вузов требуют модернизации.",
      "Преобладание глубокого теоретического подхода над практическими занятиями.",
      "Ограниченный выбор англоязычных программ в узких гуманитарных сферах.",
      "Необходимость базового знания местного языка для комфортной жизни вне кампуса."
    ]
  },
  "az": {
    "country": "Азербайджан",
    "overview": "Высшее образование в Азербайджане гармонично сочетает исторические традиции с современными академическими стандартами. Страна активно развивает международное сотрудничество, предлагая перспективные программы двойных дипломов с европейскими вузами. Бакалавриат длится четыре года, с особым акцентом на нефтегазовое дело, химическую инженерию, экономику и международные отношения. Инфраструктура ведущих университетов стремительно обновляется. Для прямого поступления требуются хорошие школьные оценки и подтвержденное знание языка преподавания.",
    "pros": [
      "Сильнейшая подготовка в сфере энергетики, нефтегазового дела и инженерии.",
      "Развивающиеся программы обмена и партнерства с европейскими университетами.",
      "Современное технологическое оснащение кампусов в ведущих национальных вузах.",
      "Мультикультурная среда и комфортные условия для проживания студентов."
    ],
    "cons": [
      "Значительный разрыв в качестве образования между столичными и региональными вузами.",
      "Ограниченный выбор специальностей, полностью преподаваемых на английском.",
      "Строгая академическая иерархия и традиционный стиль преподавания.",
      "Бюрократические сложности при оформлении учебных документов и регистраций."
    ]
  },
  "cl": {
    "country": "Чили",
    "overview": "Чили располагает одной из самых престижных, стабильных и качественных систем высшего образования в Латинской Америке. Местные университеты стабильно занимают топовые позиции в региональных рейтингах, предлагая передовые программы в области горного дела, астрономии, бизнеса, экологии и инженерии. Бакалавриат обычно длится от четырех до пяти лет. Учебный процесс отличается высокой интенсивностью, строгими правилами и требует серьезной самоотдачи. Большинство программ преподается исключительно на испанском языке, что предполагает его уверенное академическое владение.",
    "pros": [
      "Безоговорочное признание и высокий престиж чилийских дипломов в регионе.",
      "Мировое лидерство в подготовке высококлассных специалистов по астрономии.",
      "Современная исследовательская база в топовых национальных университетах.",
      "Высокий уровень общей безопасности и экономического развития внутри страны."
    ],
    "cons": [
      "Практически полное отсутствие программ бакалавриата на английском языке.",
      "Длительный срок обучения на многих инженерных и профильных специальностях.",
      "Высокая академическая нагрузка и строгая бескомпромиссная система оценивания.",
      "Специфический местный диалект испанского языка, требующий долгого привыкания."
    ]
  },
  "co": {
    "country": "Колумбия",
    "overview": "Система высшего образования Колумбии активно модернизируется и делает ставку на исследовательскую деятельность. В стране представлены как крупные государственные, так и элитные частные университеты с превосходной инфраструктурой. Сильными направлениями считаются бизнес, медицина, инженерия и социальные науки. Бакалаврские программы длятся в среднем пять лет и включают обязательные практические проекты. Академическая среда очень открытая и дружелюбная, преподаватели поощряют дискуссии, однако обучение проходит почти на 100% на испанском языке.",
    "pros": [
      "Активное развитие программ международного студенческого обмена.",
      "Теплая, инклюзивная и очень дружелюбная социальная среда на кампусах.",
      "Отличная подготовка в сфере латиноамериканского бизнеса и социологии.",
      "Возможность глубокого погружения в испанский язык в естественной языковой среде."
    ],
    "cons": [
      "Очень длительный срок обучения на программах бакалавриата (до 5 лет).",
      "Тотальный дефицит образовательных программ на английском языке.",
      "Значительная разница в качестве оборудования между государственными и частными вузами.",
      "Высокая степень бюрократизации при оформлении академических документов."
    ]
  },
  "cy": {
    "country": "Кипр",
    "overview": "Система высшего образования Кипра ориентирована на международные стандарты и тесно переплетена с британской академической традицией. Бакалавриат длится четыре года и предлагает отличную подготовку в сфере международного туризма, морского дела, финансов и IT. Обучение в подавляющем большинстве случаев ведется полностью на английском языке. Инфраструктура университетов отличается современностью, а учебный процесс поощряет интерактивность и командную работу. Дипломы признаются в ЕС, а мультикультурная среда острова способствует быстрой адаптации.",
    "pros": [
      "Огромный выбор бакалаврских программ, полностью преподаваемых на английском.",
      "Дипломы европейского стандарта, безоговорочно признаваемые в странах ЕС.",
      "Мощная практическая направленность в сфере гостеприимства, бизнеса и туризма.",
      "Исключительно безопасная среда и комфортный средиземноморский климат."
    ],
    "cons": [
      "Ограниченный выбор узкоспециализированных научных и инженерных направлений.",
      "Необходимость владения греческим языком для работы вне туристического сектора.",
      "Относительно небольшие размеры кампусов по сравнению с крупными странами.",
      "Жесткая конкуренция на локальном рынке труда для молодых специалистов."
    ]
  },
  "eg": {
    "country": "Египет",
    "overview": "Египет является историческим и крупнейшим образовательным центром Ближнего Востока и Северной Африки. В стране действуют престижные национальные и международные университеты, предлагающие программы по британской и американской моделям. Бакалавриат длится от четырех до пяти лет. Особенно сильны направления медицины, инженерии, археологии и гуманитарных наук. В ведущих вузах преподавание часто ведется на английском языке. Учебный процесс характеризуется традиционным подходом, строгой дисциплиной и высокой лекционной нагрузкой на студентов.",
    "pros": [
      "Высокий статус и престиж дипломов ведущих вузов в арабском мире.",
      "Уникальные возможности для полевых исследований в археологии и истории.",
      "Широкий спектр качественных бакалаврских программ на английском языке.",
      "Активное развитие партнерских программ с топовыми западными университетами."
    ],
    "cons": [
      "Высокий уровень бюрократии и медлительность административных процессов в вузах.",
      "Переполненные лекционные аудитории в крупных государственных университетах.",
      "Специфический жаркий климат и перегруженная инфраструктура мегаполисов.",
      "Традиционный подход с упором на механическое заучивание объемных текстов."
    ]
  },
  "id": {
    "country": "Индонезия",
    "overview": "Индонезия стремительно развивает сектор высшего образования, инвестируя в инфраструктуру и международные связи. Бакалавриат длится четыре года, предлагая качественную подготовку в сфере экологии, сельского хозяйства, бизнеса и информационных технологий. Университеты активно внедряют практико-ориентированный подход, поощряя участие студентов в реальных проектах. Национальная культура глубоко пронизывает академическую среду, требуя соблюдения субординации. Для иностранцев открывается все больше программ на английском языке, особенно в престижных частных вузах.",
    "pros": [
      "Уникальная база для исследований в области тропической экологии и биологии.",
      "Стремительный рост количества программ, преподаваемых на английском языке.",
      "Невероятно гостеприимная и толерантная мультикультурная студенческая среда.",
      "Тесная интеграция некоторых учебных программ с быстрорастущим азиатским рынком."
    ],
    "cons": [
      "Значительный разрыв в академическом качестве между регионами и столицей.",
      "Обязательное соблюдение строгих правил дресс-кода на территории кампусов.",
      "Необходимость владения индонезийским языком для комфортной жизни в стране.",
      "Периодические сложности с поиском высокоскоростного интернета за пределами вузов."
    ]
  },
  "kz": {
    "country": "Казахстан",
    "overview": "Система высшего образования Казахстана полностью интегрирована в Болонский процесс и активно внедряет международные стандарты качества. Бакалавриат длится четыре года по кредитной системе ECTS. Вузы предлагают сильные программы в области инженерии, IT, добычи полезных ископаемых и экономики. В стране успешно работают филиалы зарубежных университетов, предлагающие англоязычное обучение. Академическая инфраструктура в крупных городах постоянно модернизируется, а учебные планы ориентированы на потребности быстрорастущего регионального бизнеса.",
    "pros": [
      "Полное соответствие дипломов общеевропейским стандартам Болонской системы.",
      "Растущее число программ двойных дипломов совместно с западными университетами.",
      "Упрощенная процедура зачисления и нострификации документов об образовании.",
      "Доступность качественных программ на английском языке в топовых университетах."
    ],
    "cons": [
      "Неравномерное качество преподавания и инфраструктуры в региональных институтах.",
      "Преобладание теоретического компонента над актуальными практическими навыками.",
      "Высокий уровень бюрократии во внутренних административных процессах вузов.",
      "Ограниченные возможности для академических исследований в узких гуманитарных сферах."
    ]
  },
  "lu": {
    "country": "Люксембург",
    "overview": "Высшее образование в Люксембурге — это элитная, компактная и глубоко интернациональная система. Главный университет страны предлагает высококлассный бакалавриат в сфере финансов, права, IT и европейского управления. Отличительной чертой является обязательная мультиязычность: программы часто требуют знания как минимум двух языков (английский, французский или немецкий). Обучение занимает три года и строго требует проведения как минимум одного семестра в университете-партнере за рубежом, что гарантирует мощный международный опыт и расширение связей.",
    "pros": [
      "Прямой доступ к стажировкам в ведущих финансовых и европейских институтах.",
      "Обязательная международная мобильность (семестр по обмену) включена в программу.",
      "Исключительно высокий уровень безопасности и качества жизни в государстве.",
      "Мультиязычная среда, развивающая навыки кросс-культурной коммуникации."
    ],
    "cons": [
      "Обязательное требование свободного владения минимум двумя иностранными языками.",
      "Крайне узкий выбор специализаций и направлений подготовки на бакалавриате.",
      "Острая нехватка студенческих общежитий и жесткая конкуренция за аренду жилья.",
      "Высокая интенсивность учебы, требующая непрерывной вовлеченности в процесс."
    ]
  },
  "ma": {
    "country": "Марокко",
    "overview": "Марокко развивает современную систему высшего образования, органично сочетая французскую академическую модель с местными культурными традициями. Бакалавриат длится три года по системе LMD (Licence-Master-Doctorat). Сильные позиции традиционно занимают программы в инженерии, бизнесе и сельском хозяйстве. Обучение в государственных университетах преимущественно ведется на французском и арабском языках, однако новые частные и международные институты активно внедряют стопроцентно англоязычные программы, ориентируясь на глобальный рынок труда.",
    "pros": [
      "Интеграция с европейской системой LMD, облегчающая признание дипломов.",
      "Тесные академические связи и программы обмена с франкоязычными странами.",
      "Уникальная кросс-культурная среда на стыке европейской и африканской цивилизаций.",
      "Быстрое развитие частных англоязычных университетов с отличным оснащением."
    ],
    "cons": [
      "Для обучения в государственных вузах критически необходимо знание французского.",
      "Переполненные аудитории и классический подход к лекциям в госсекторе.",
      "Сложные бюрократические процедуры при оформлении виз и студенческих документов.",
      "Значительный отрыв теоретических знаний от реальных потребностей локального рынка."
    ]
  },
  "mt": {
    "country": "Мальта",
    "overview": "Мальта предлагает компактную, но очень престижную систему высшего образования, выстроенную по строгим британским стандартам. Бакалавриат длится три года. Главный университет страны и филиалы зарубежных вузов предлагают сильнейшую подготовку в IT, медицине, блокчейн-технологиях и бизнесе. Обучение проходит исключительно на английском языке. Учебный процесс требует самостоятельности, а экзамены часто проходят в строгой письменной форме. Студентов привлекает теплая атмосфера, безопасность и возможность легкого старта международной карьеры.",
    "pros": [
      "Полностью англоязычная образовательная среда по классической британской модели.",
      "Передовые программы в области информационных технологий и блокчейна.",
      "Европейский диплом, признаваемый во всем мире без дополнительных подтверждений.",
      "Высокий уровень безопасности, идеальная экология и мягкий островной климат."
    ],
    "cons": [
      "Очень скромный выбор высших учебных заведений и узких специальностей.",
      "Необходимость наличия дополнительного года (Foundation) после некоторых школ.",
      "Высокая конкуренция за комфортное студенческое жилье в туристический сезон.",
      "Специфический консервативный подход к оцениванию знаний на экзаменах."
    ]
  },
  "mx": {
    "country": "Мексика",
    "overview": "Мексика обладает одной из крупнейших систем высшего образования в Латинской Америке. Ведущие университеты страны имеют статус исследовательских центров мирового уровня и предлагают передовые программы в инженерии, архитектуре, медицине и бизнесе. Бакалавриат длится от четырех до пяти лет. В учебном плане сбалансированы глубокая теория и обязательная социальная практика. Атмосфера на кампусах живая и неформальная, преподаватели открыты к общению. Основной язык обучения — испанский, хотя престижные частные вузы активно вводят англоязычные модули.",
    "pros": [
      "Высочайший престиж дипломов топовых университетов на американском континенте.",
      "Развитая и масштабная инфраструктура кампусов с отличными лабораториями.",
      "Обязательная интеграция практических проектов в любой академический учебный план.",
      "Яркая культурная жизнь, гостеприимство и комфортная социальная среда."
    ],
    "cons": [
      "Длительный срок обучения на бакалавриате (часто до полных пяти лет).",
      "Дефицит программ, преподаваемых на 100% на английском языке.",
      "Неравномерный уровень безопасности в разных регионах и городах страны.",
      "Сложная и запутанная система перевода академических кредитов."
    ]
  },
  "pe": {
    "country": "Перу",
    "overview": "Высшее образование в Перу динамично реформируется для соответствия современным международным стандартам. Бакалавриат здесь длится пять лет и требует от студентов серьезной вовлеченности в исследовательские проекты. Сильные академические направления включают экономику, инженерию, экологию и гуманитарные науки. Частные университеты Лимы предлагают передовое оснащение и активно привлекают иностранных лекторов. Обучение ведется на испанском языке. Студенческая жизнь отличается строгим расписанием и обязательным выполнением масштабных курсовых работ.",
    "pros": [
      "Отличная база для полевых исследований в области археологии и экологии.",
      "Стремительно развивающаяся инфраструктура частных столичных университетов.",
      "Строгий контроль качества образования со стороны государственных органов.",
      "Глубокое погружение в богатую культуру и уверенное освоение испанского языка."
    ],
    "cons": [
      "Увеличенный срок получения степени бакалавра (в среднем пять лет).",
      "Полное отсутствие доступных бакалаврских программ на английском языке.",
      "Заметная разница в уровне подготовки между государственными и частными вузами.",
      "Высокая степень формализма и бюрократии при работе с администрацией вуза."
    ]
  },
  "ph": {
    "country": "Филиппины",
    "overview": "Филиппины предлагают уникальную для Азии образовательную модель, основанную на американских стандартах. Бакалавриат длится четыре года. Страна является одним из крупнейших англоязычных образовательных центров в регионе, поэтому абсолютно все программы от инженерии до медицины и IT преподаются на качественном английском языке. Инфраструктура варьируется, но ведущие частные университеты предоставляют современные лаборатории. Академический процесс интерактивен, с большим количеством презентаций, групповых эссе и практических заданий.",
    "pros": [
      "Полностью англоязычная академическая среда во всех учебных заведениях.",
      "Образовательная система, максимально приближенная к американским стандартам.",
      "Высокое качество программ в сфере сестринского дела, медицины и IT.",
      "Исключительное дружелюбие местных жителей и быстрая культурная адаптация."
    ],
    "cons": [
      "Перегруженность инфраструктуры и сложная транспортная логистика в мегаполисах.",
      "Частые природные катаклизмы (тайфуны), способные нарушить учебный график.",
      "Явно устаревшее оборудование в ряде государственных университетов.",
      "Сложности с оформлением разрешительных документов для длительного проживания."
    ]
  },
  "si": {
    "country": "Словения",
    "overview": "Словения предоставляет высококачественное и доступное европейское образование, полностью соответствующее стандартам Болонской системы. Бакалавриат занимает три-четыре года. Учебный процесс отличается современным подходом: помимо классических лекций, студенты активно участвуют в проектных семинарах и практических исследованиях. Сильные направления — бизнес, IT, экология и инженерия. Университеты активно сотрудничают с бизнесом. В стране появляется все больше программ на английском языке, а студенты пользуются обширной системой государственных скидок.",
    "pros": [
      "Полное признание словенских дипломов на территории всего Европейского Союза.",
      "Щедрая система национальных студенческих льгот на транспорт и питание.",
      "Безопасная, экологически чистая и очень комфортная среда для проживания.",
      "Активное развитие англоязычных программ и международных обменов (Erasmus)."
    ],
    "cons": [
      "Количество англоязычных программ на уровне бакалавриата все еще ограничено.",
      "Для глубокой интеграции в общество необходимо изучение словенского языка.",
      "Ограниченные возможности локального рынка труда из-за малых размеров страны.",
      "Достаточно строгие требования к посещаемости семинарских занятий."
    ]
  },
  "tw": {
    "country": "Тайвань",
    "overview": "Высшее образование на Тайване славится мировым лидерством в области полупроводников, инженерии и информационных технологий. Бакалавриат длится четыре года и характеризуется высокой академической строгостью, интенсивной лабораторной практикой и духом инноваций. Университеты предлагают множество грантов и активно открывают программы на английском языке для привлечения талантов. Учебный процесс требует огромной самоотдачи и конкурентоспособности. Кампусы оснащены по последнему слову техники, предоставляя студентам ресурсы для прорывных исследований.",
    "pros": [
      "Абсолютное мировое лидерство образовательных программ в сфере IT и инженерии.",
      "Огромное количество англоязычных программ в передовых технологических вузах.",
      "Превосходное техническое оснащение исследовательских центров и лабораторий.",
      "Высочайший уровень безопасности и развитая инфраструктура мегаполисов."
    ],
    "cons": [
      "Крайне высокая интенсивность учебы и жесткая соревновательная среда.",
      "Специфический климат с частыми тайфунами и повышенной сейсмической активностью.",
      "Сложности с интеграцией в общество без базового знания китайского языка.",
      "Строгая иерархия в общении с профессурой, типичная для азиатской культуры."
    ]
  },
  "uz": {
    "country": "Узбекистан",
    "overview": "Высшее образование в Узбекистане переживает масштабную трансформацию, активно внедряя западные стандарты и систему кредитов. Страна привлекает многочисленные филиалы ведущих международных университетов (британских, южнокорейских, американских), которые предлагают оригинальные бакалаврские программы на английском языке. Классический бакалавриат длится четыре года. Основной упор делается на экономику, инженерию и бизнес-администрирование. Академическая среда постепенно отходит от строгих традиций в сторону интерактивных форматов обучения.",
    "pros": [
      "Возможность получить дипломы престижных западных вузов через их филиалы.",
      "Широкий спектр современных образовательных программ на английском языке.",
      "Динамично развивающаяся экономика, создающая новые карьерные перспективы.",
      "Упрощенная и прозрачная процедура зачисления для иностранных абитуриентов."
    ],
    "cons": [
      "Процесс модернизации инфраструктуры в государственных вузах еще не завершен.",
      "Преобладание жесткого теоретического подхода на некоторых специальностях.",
      "Забюрократизированность внутренних процессов в традиционных университетах.",
      "Ограниченные возможности для передовых научных исследований в ряде сфер."
    ]
  },
  "vn": {
    "country": "Вьетнам",
    "overview": "Вьетнам уверенно интегрируется в международную академическую среду, развивая как национальные вузы, так и совместные кампусы с зарубежными партнерами. Бакалавриат занимает четыре года. Сильными сторонами являются программы по IT, международному бизнесу и инженерии. Обучение во многих частных и международных университетах ведется на английском языке с привлечением иностранных преподавателей. Учебный процесс сочетает азиатскую дисциплину с растущим вниманием к практическим кейсам и командным проектам, готовя студентов к динамичному рынку.",
    "pros": [
      "Наличие высококлассных филиалов зарубежных университетов с англоязычной средой.",
      "Быстрорастущая экономика, обеспечивающая отличные перспективы для стажировок.",
      "Ориентация учебных программ на потребности современного технологического рынка.",
      "Очень гостеприимная культура и богатый колорит студенческой жизни."
    ],
    "cons": [
      "Заметная разница в академических стандартах между государственными и частными вузами.",
      "Строгие требования к посещаемости и традиционный подход к заучиванию материала.",
      "Сложная дорожная обстановка и перегруженная инфраструктура крупных городов.",
      "Трудности в бытовой коммуникации за пределами кампусов без знания вьетнамского."
    ]
  },
  "za": {
    "country": "ЮАР",
    "overview": "Высшее образование в ЮАР является самым сильным и престижным на Африканском континенте, оно исторически базируется на классической британской образовательной модели. Бакалавриат длится три-четыре года. Университеты знамениты передовыми программами в медицине, горной инженерии, экологии и бизнес-администрировании. Обучение проходит на высокоуровневом английском языке. Академическая среда поощряет глубокое критическое мышление. Студенты имеют доступ к уникальным полевым исследованиям, что делает практическую часть учебы невероятно ценной.",
    "pros": [
      "Наличие авторитетных университетов, стабильно входящих в мировые рейтинги.",
      "Абсолютно англоязычная среда, построенная по строгим британским стандартам.",
      "Уникальные возможности для полевых исследований в экологии и геологии.",
      "Интенсивная интеграция теоретических учебных программ с практическим опытом."
    ],
    "cons": [
      "Специфическая ситуация с личной безопасностью в некоторых районах крупных городов.",
      "Сложные и долгие бюрократические процедуры при оформлении студенческой визы.",
      "Возможные инфраструктурные проблемы, такие как веерные отключения электричества.",
      "Крайне высокие требования к успеваемости и напряженный ритм сдачи сессий."
    ]
  }
};

export const db_programs = [
  {
    "iso": "us",
    "langCode": "en",
    "langScore": 4.71,
    "langScoreComment": "IELTS 6.5; TOEFL iBT 90.0",
    "uniType": "Private",
    "gpaLevel": 3.8,
    "status": 1,
    "version": 1,
    "recommended": 1.1,
    "deadlines": [
      {
        "date": "01-01"
      },
      {
        "date": "05-30"
      }
    ],
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года. Первые два года посвящены общеобразовательным предметам (General Education)."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Возможно поступление через Community College (2+2) для экономии средств."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "costTuition": 49000
  },
  {
    "iso": "gb",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0/6.5; TOEFL iBT 80",
    "uniType": "Public",
    "gpaLevel": 3.7,
    "status": 1,
    "version": 1,
    "recommended": 1.1,
    "deadlines": [
      {
        "date": "10-15",
        "comment": "Oxbridge, Med"
      },
      {
        "date": "01-15",
        "comment": "General UCAS"
      }
    ],
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года в Англии и Уэльсе. В Шотландии стандартный бакалавриат длится 4 года."
    },
    "enrollment_age": {
      "age_min": 17,
      "comment": "18 лет. Можно поступить в 17, но для некоторых курсов (медицина) строго 18 на момент начала клиники.",
      "age_max": 18
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "11 классов + 1 год вуза или foundation (=12)"
    },
    "costTuition": 22000
  },
  {
    "iso": "de",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0",
    "uniType": "Public",
    "gpaLevel": 3.6,
    "status": 1,
    "version": 1,
    "recommended": 1.1,
    "study_duration": {
      "years_mid": 4,
      "comment": "3 года (6 семестров). В университетах прикладных наук (FH) — 3.5 года с семестром практики.",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Для поступления в Studienkolleg можно быть младше при наличии согласия родителей."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "11 классов + 1 год вуза или штуденколлег (=12)"
    },
    "deadlines": [
      {
        "date": "07-15"
      }
    ],
    "costTuition": 1800
  },
  {
    "iso": "de",
    "langCode": "de",
    "langScore": 5,
    "langScoreComment": "TestDAF 4",
    "uniType": "Public",
    "gpaLevel": 3.4,
    "status": 1,
    "version": 1,
    "recommended": 1.1,
    "study_duration": {
      "years_mid": 4,
      "comment": "3 года (6 семестров). В университетах прикладных наук (FH) — 3.5 года с семестром практики.",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Для поступления в Studienkolleg можно быть младше при наличии согласия родителей."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "11 классов + 1 год вуза или штуденколлег (=12)"
    },
    "deadlines": [
      {
        "date": "07-15"
      }
    ],
    "costTuition": 1800
  },
  {
    "iso": "ca",
    "langCode": "en",
    "langScore": 4.5,
    "langScoreComment": "IELTS 6.5; TOEFL 4.5",
    "uniType": "Public",
    "gpaLevel": 3.7,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года для Bachelor with Honours. В Квебеке — 3 года после колледжа CEGEP."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. В некоторых провинциях совершеннолетие наступает в 19 лет, что влияет на опекунство."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. В Квебеке — 11 лет школы + 2 года CEGEP."
    },
    "deadlines": [
      {
        "date": "01-01"
      },
      {
        "date": "05-01"
      }
    ],
    "costTuition": 32500
  },
  {
    "iso": "ch",
    "langCode": "en",
    "langScore": 4,
    "langScoreComment": "IELTS 5.5; TOEFL iBT 80",
    "uniType": "Private",
    "gpaLevel": 3.8,
    "status": 1,
    "version": 1,
    "recommended": 1.1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года. Обучение в школах гостеприимства может включать длительные оплачиваемые стажировки."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Очень строгие требования к визе и финансовым гарантиям."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов в частных"
    },
    "deadlines": [
      {
        "date": "02-28"
      },
      {
        "date": "07"
      }
    ],
    "costTuition": 37500
  },
  {
    "iso": "ch",
    "langCode": "fr",
    "langScore": 4,
    "langScoreComment": "DELF B2",
    "uniType": "Public",
    "gpaLevel": 3.8,
    "status": 1,
    "version": 1,
    "recommended": 1.1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года. В государственных вузах обучение ведется на национальных языках."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Очень строгие требования к визе и финансовым гарантиям."
    },
    "school_grade": {
      "grade_min": 13,
      "comment": "11 классов+2 года вуза в госах"
    },
    "deadlines": [
      {
        "date": "04-30"
      }
    ],
    "costTuition": 1500
  },
  {
    "iso": "ch",
    "langCode": "de",
    "langScore": 5,
    "langScoreComment": "TestDAF 4",
    "uniType": "Public",
    "gpaLevel": 3.8,
    "status": 1,
    "version": 1,
    "recommended": 1.1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года. В государственных вузах обучение ведется на национальных языках."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Очень строгие требования к визе и финансовым гарантиям."
    },
    "school_grade": {
      "grade_min": 13,
      "comment": "11 классов+2 года вуза в госах"
    },
    "deadlines": [
      {
        "date": "04-30"
      }
    ],
    "costTuition": 1500
  },
  {
    "iso": "fr",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0",
    "uniType": "Private",
    "gpaLevel": 3.6,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года (Licence). Далее следует магистратура (Master) — 2 года."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Поступление через платформу Parcoursup или Etudes en France."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "deadlines": [
      {
        "date": "12-15"
      },
      {
        "date": "06"
      },
      {
        "date": "07"
      }
    ],
    "costTuition": 3235
  },
  {
    "iso": "fr",
    "langCode": "fr",
    "langScore": 4,
    "langScoreComment": "DELF B2",
    "uniType": "Private",
    "gpaLevel": 3.4,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года (Licence). Далее следует магистратура (Master) — 2 года."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Поступление через платфорную Parcoursup или Etudes en France."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "deadlines": [
      {
        "date": "12-15"
      },
      {
        "date": "06"
      },
      {
        "date": "07"
      }
    ],
    "costTuition": 3235
  },
  {
    "iso": "au",
    "langCode": "en",
    "langScore": 4.71,
    "langScoreComment": "IELTS 6.5; TOEFL iBT 90",
    "uniType": "Private",
    "gpaLevel": 3.8,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 3,
      "comment": "Стандарт — 3 года. Программы Honors, инженерные и медицинские специальности длятся 4-6 лет."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "Обычно 18 лет. Возможен прием с 17 лет при наличии опекуна, gap year распространен."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет школы. Выпускникам 11 классов РФ обычно требуется программа Foundation или диплом IB/A-Level."
    },
    "deadlines": [
      {
        "date": "02"
      },
      {
        "date": "07"
      }
    ],
    "costTuition": 20667
  },
  {
    "iso": "lu",
    "langCode": "en",
    "langScore": 4.71,
    "langScoreComment": "IELTS 6.5",
    "uniType": "Private",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года. Обязательным условием для студентов является мобильность (семестр за границей)."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Многоязычная среда требует владения минимум двумя языками (фр/нем/англ)."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12-13 лет. Дипломы должны соответствовать стандартам люксембургского аттестата (Diplôme de fin d’études)."
    },
    "deadlines": [
      {
        "date": "04-30"
      }
    ],
    "costTuition": 11000
  },
  {
    "iso": "dk",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0; TOEFL iBT 80",
    "uniType": "Private",
    "gpaLevel": 3.6,
    "status": 1,
    "version": 1,
    "deadlines": [
      {
        "date": "03-15",
        "comment": "на осень"
      },
      {
        "date": "08-15",
        "comment": "на весну"
      }
    ],
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года. После этого большинство студентов продолжают обучение в магистратуре (2 года)."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Система образования ориентирована на самостоятельность и критическое мышление."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12-13 лет. Требования к предметам (уровни A, B, C) очень строгие для каждой программы."
    },
    "costTuition": 9000
  },
  {
    "iso": "nl",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0/6.5; TOEFL iBT 80",
    "uniType": "Private",
    "gpaLevel": 3.6,
    "status": 1,
    "version": 1,
    "recommended": 1.2,
    "deadlines": [
      {
        "date": "04-01",
        "comment": "на осень"
      },
      {
        "date": "06-15",
        "comment": "на осень"
      }
    ],
    "study_duration": {
      "years_mid": 4,
      "comment": "3 года в исследовательских вузах (WO), 4 года — в вузах прикладных наук (HBO).",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "\"18 лет. Система \"\"Numerus Fixus\"\" ограничивает количество мест на популярных направлениях.\""
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов или 11 классов + 1 год вуза"
    },
    "costTuition": 15000
  },
  {
    "iso": "jp",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0; TOEFL iBT 93",
    "uniType": "Public",
    "gpaLevel": 3.6,
    "status": 1,
    "version": 1,
    "deadlines": [
      {
        "date": "10",
        "comment": "for march"
      },
      {
        "date": "11",
        "comment": "for october"
      },
      {
        "date": "03",
        "comment": "for october"
      }
    ],
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года. Для иностранных студентов часто предлагаются программы с обучением на английском (G30)."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Традиционный период начала занятий — апрель."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "costTuition": 11000
  },
  {
    "iso": "se",
    "langCode": "en",
    "langScore": 4.71,
    "langScoreComment": "IELTS 6.5; TOEFL iBT 90",
    "uniType": "Public",
    "gpaLevel": 3.6,
    "status": 1,
    "version": 1,
    "deadlines": [
      {
        "date": "01-15",
        "comment": "на осень"
      },
      {
        "date": "10-15",
        "comment": "на весну"
      }
    ],
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года (180 ECTS). Учебный процесс сфокусирован на групповых проектах и критическом анализе."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Заявки подаются через единый портал Universityadmissions.se."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "costTuition": 13500
  },
  {
    "iso": "fi",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0/6.5; TOEFL iBT 80",
    "uniType": "Public",
    "gpaLevel": 3.6,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 4,
      "comment": "3.5 – 4 года в университетах прикладных наук (UAS). 3 года — в академических университетах.",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 17,
      "comment": "18 лет. Вступительные экзамены часто проводятся онлайн (International University Exam).",
      "age_max": 18
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "deadlines": [
      {
        "date": "01"
      }
    ],
    "costTuition": 10500
  },
  {
    "iso": "no",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0/6.5; TOEFL iBT 80",
    "uniType": "Private",
    "gpaLevel": 3.6,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года. Обучение на бакалавриате в основном ведется на норвежском языке.",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Иностранцы должны подтвердить владение языком и финансовую независимость."
    },
    "school_grade": {
      "grade_min": 13,
      "comment": "13 лет (GNS). После 11 лет школы СНГ требуется 1 год обучения в вузе на родине."
    },
    "deadlines": [
      {
        "date": "04-15",
        "comment": "Абитуриенты не из ЕС/ЕЭЗ"
      },
      {
        "date": "06-01",
        "comment": "Абитуриенты из ЕС/ЕЭЗ"
      }
    ],
    "costTuition": 10667
  },
  {
    "iso": "sg",
    "langCode": "en",
    "langScore": 4.71,
    "langScoreComment": "IELTS 6.5; TOEFL iBT 90",
    "uniType": "Public",
    "gpaLevel": 3.7,
    "status": 1,
    "version": 1,
    "deadlines": [
      {
        "date": "01"
      },
      {
        "date": "02"
      },
      {
        "date": "0",
        "comment": "круглый год"
      }
    ],
    "study_duration": {
      "years_mid": 4,
      "comment": "3 года. В государственных вузах программы Honours могут занимать 4 года.",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Очень жесткие требования к академической успеваемости."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. Принимаются результаты A-Level, IB или национальных экзаменов высокого уровня."
    },
    "costTuition": 24000
  },
  {
    "iso": "hk",
    "langCode": "en",
    "langScore": 4.71,
    "langScoreComment": "IELTS 6.5",
    "uniType": "Private",
    "gpaLevel": 3.6,
    "status": 1,
    "version": 1,
    "deadlines": [
      {
        "date": "11",
        "comment": "early"
      },
      {
        "date": "01",
        "comment": "regular"
      }
    ],
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года — стандарт после реформы образования. Медицина может длиться до 6 лет.",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Очень высокая конкуренция, важны академические достижения и внеучебная деятельность."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "costTuition": 15667
  },
  {
    "iso": "hk",
    "langCode": "zh",
    "langScore": 5,
    "langScoreComment": "HSK 5.0",
    "uniType": "Private",
    "gpaLevel": 3.4,
    "status": 1,
    "version": 1,
    "deadlines": [
      {
        "date": "11",
        "comment": "early"
      },
      {
        "date": "01",
        "comment": "regular"
      }
    ],
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года — стандарт после реформы образования. Медицина может длиться до 6 лет.",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Очень высокая конкуренция, важны академические достижения и внеучебная деятельность."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "costTuition": 5000
  },
  {
    "iso": "be",
    "langCode": "en",
    "langScore": 4.71,
    "langScoreComment": "IELTS 6.5; TOEFL iBT 90",
    "uniType": "Public",
    "gpaLevel": 3.4,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года (180 ECTS). Профессиональный бакалавриат ориентирован на практику, академический — на магистратуру."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Ограничений по максимальному возрасту практически нет."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "deadlines": [
      {
        "date": "03-01"
      },
      {
        "date": "04-01"
      },
      {
        "date": "05-01"
      }
    ],
    "costTuition": 6000
  },
  {
    "iso": "es",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0; TOEFL iBT 82",
    "uniType": "Private",
    "gpaLevel": 3.4,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года (Grado) для большинства программ. Исключение — архитектура и медицина.",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Для поступления в госвузы важен балл экзамена Selectividad (EBAU)."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "deadlines": [
      {
        "date": "05"
      },
      {
        "date": "06"
      }
    ],
    "costTuition": 9000
  },
  {
    "iso": "es",
    "langCode": "es",
    "langScore": 6,
    "langScoreComment": "DELE C2",
    "uniType": "Private",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года (Grado) для большинства программ. Исключение — архитектура и медицина.",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Для поступления в госвузы важен балл экзамена Selectividad (EBAU)."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "deadlines": [
      {
        "date": "05"
      },
      {
        "date": "06"
      }
    ],
    "costTuition": 6000
  },
  {
    "iso": "at",
    "langCode": "de",
    "langScore": 4.71,
    "langScoreComment": "IELTS 6.5; TOEFL iBT 90",
    "uniType": "Public",
    "gpaLevel": 3.4,
    "status": 1,
    "version": 1,
    "recommended": 1.1,
    "deadlines": [
      {
        "date": "06"
      },
      {
        "date": "07"
      }
    ],
    "study_duration": {
      "years_mid": 4,
      "comment": "3 года (6 семестров) для большинства программ. Медицина и архитектура — до 6 лет.",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Поступление сразу после школы (Matura) является стандартным."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "costTuition": 1600
  },
  {
    "iso": "it",
    "langCode": "en",
    "langScore": 4,
    "langScoreComment": "IELTS 5.5; TOEFL iBT 82",
    "uniType": "Public",
    "gpaLevel": 3.4,
    "status": 1,
    "version": 1,
    "recommended": 1.1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года (Laurea Triennale). Для архитектуры и медицины — программы Laurea Magistrale a ciclo unico (5-6 лет)."
    },
    "enrollment_age": {
      "age_min": 17,
      "comment": "17 лет (с опекуном)"
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "11 классов + 1 год вуза или foundation (=12)"
    },
    "deadlines": [
      {
        "date": "03"
      },
      {
        "date": "05"
      }
    ],
    "costTuition": 3500
  },
  {
    "iso": "it",
    "langCode": "it",
    "langScore": 4,
    "langScoreComment": "CILS B2",
    "uniType": "Public",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1,
    "recommended": 1.1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года (Laurea Triennale). Для архитектуры и медицины — программы Laurea Magistrale a ciclo unico (5-6 лет)."
    },
    "enrollment_age": {
      "age_min": 17,
      "comment": "17 лет (с опекуном)"
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "11 классов + 1 год вуза или foundation (=12)"
    },
    "deadlines": [
      {
        "date": "03"
      },
      {
        "date": "05"
      }
    ],
    "costTuition": 3500
  },
  {
    "iso": "kr",
    "langCode": "en",
    "langScore": 4,
    "langScoreComment": "IELTS 5.5; TOEFL iBT 80",
    "uniType": "Public",
    "gpaLevel": 3.6,
    "status": 1,
    "version": 1,
    "recommended": 1.1,
    "deadlines": [
      {
        "date": "2",
        "comment": "for september"
      },
      {
        "date": "5",
        "comment": "for september"
      },
      {
        "date": "7",
        "comment": "for march"
      },
      {
        "date": "11",
        "comment": "for march"
      }
    ],
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года. Учебный год начинается в марте, но есть и осенний набор в сентябре."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Важна не только успеваемость, но и знание корейского языка (TOPIK)."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "costTuition": 8000
  },
  {
    "iso": "cn",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0; TOEFL iBT 80",
    "uniType": "Public",
    "gpaLevel": 3.4,
    "status": 1,
    "version": 1,
    "recommended": 1.1,
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года. Для медицинских специальностей — 5-6 лет, включая интернатуру."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Ограничение по возрасту для получения стипендий часто составляет 25 лет для бакалавриата."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "deadlines": [
      {
        "date": "03-31"
      },
      {
        "date": "06-15"
      }
    ],
    "costTuition": 4000
  },
  {
    "iso": "cn",
    "langCode": "zh",
    "langScore": 4,
    "langScoreComment": "HSK 4/5",
    "uniType": "Public",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1,
    "recommended": 1.1,
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года. Для медицинских специальностей — 5-6 лет, включая интернатуру."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Ограничение по возрасту для получения стипендий часто составляет 25 лет для бакалавриата."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "deadlines": [
      {
        "date": "03-31"
      },
      {
        "date": "06-15"
      }
    ],
    "costTuition": 4000
  },
  {
    "iso": "il",
    "langCode": "en",
    "langScore": 4.36,
    "langScoreComment": "TOEFL iBT 80",
    "uniType": "Public",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года для большинства гуманитарных и точных наук. Инженерия — 4 года."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет для иностранцев. Местные студенты обычно поступают в 20-21 год после службы в армии."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет (Bagrut). Выпускникам 11 классов СНГ обычно требуется подготовительный год (Mechina)."
    },
    "deadlines": [
      {
        "date": "01"
      },
      {
        "date": "05"
      }
    ],
    "costTuition": 8167
  },
  {
    "iso": "ie",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0; TOEFL iBT 90",
    "uniType": "Public",
    "gpaLevel": 3.6,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 4,
      "comment": "3 года для Ordinary Bachelor degree, 4 года для Honours Bachelor degree (наиболее востребован).",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Поступление через систему CAO для местных или напрямую для иностранцев."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет (Leaving Certificate). Российский аттестат 11 классов требует года Foundation."
    },
    "deadlines": [
      {
        "date": "06-30"
      }
    ],
    "costTuition": 16000
  },
  {
    "iso": "nz",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0; TOEFL iBT 90",
    "uniType": "Public",
    "gpaLevel": 3.6,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года. Степень бакалавра с отличием (Honours) требует дополнительного года обучения."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Требования к визе включают подтверждение оплаты обучения и средств на проживание."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 классов"
    },
    "deadlines": [
      {
        "date": "02"
      },
      {
        "date": "07"
      }
    ],
    "costTuition": 20767
  },
  {
    "iso": "pt",
    "langCode": "en",
    "langScore": 4,
    "langScoreComment": "IELTS 5.5",
    "uniType": "Private",
    "gpaLevel": 3.4,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 4,
      "comment": "3 года (Licenciatura). Некоторые инженерные степени могут длиться до 5 лет (Mestrado Integrado).",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Иностранцы поступают через специальный конкурс (Estatuto do Estudante Internacional)."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. Обязательна сдача вступительных экзаменов или признание результатов национальных тестов."
    },
    "deadlines": [
      {
        "date": "02"
      },
      {
        "date": "04"
      }
    ],
    "costTuition": 5000
  },
  {
    "iso": "ru",
    "langCode": "ru",
    "langScore": 4,
    "langScoreComment": "ТРКИ-2 (B2)",
    "uniType": "Public",
    "gpaLevel": 3,
    "version": 1,
    "costTuition": 4200,
    "recommended": 0.5,
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года для бакалавриата, 5 лет для специалитета"
    },
    "enrollment_age": {
      "age_min": 17,
      "comment": "Неявное требование, основанное на окончании 11-летней школы"
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "Аттестат о среднем общем образовании (11 лет)"
    }
  },
  {
    "iso": "tw",
    "langCode": "en",
    "langScore": 4,
    "langScoreComment": "IELTS 5.5; TOEFL iBT 80",
    "uniType": "Private",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1,
    "deadlines": [
      {
        "date": "03-31",
        "comment": "на осень"
      },
      {
        "date": "10-31",
        "comment": "на весну"
      }
    ],
    "study_duration": {
      "years_mid": 5,
      "comment": "4 года. Тайваньские вузы занимают высокие места в рейтингах по инженерии и ИТ.",
      "years_min": 4
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Для иностранцев доступны щедрые правительственные стипендии."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. Требуется подтверждение владения китайским (TOCFL) или английским языком."
    },
    "costTuition": 3900
  },
  {
    "iso": "tw",
    "langCode": "zh",
    "langScore": 3,
    "langScoreComment": "HSK 3",
    "uniType": "Private",
    "gpaLevel": 3,
    "status": 1,
    "version": 1,
    "deadlines": [
      {
        "date": "03-31",
        "comment": "на осень"
      },
      {
        "date": "10-31",
        "comment": "на весну"
      }
    ],
    "study_duration": {
      "years_mid": 5,
      "comment": "4 года. Тайваньские вузы занимают высокие места в рейтингах по инженерии и ИТ.",
      "years_min": 4
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Для иностранцев доступны щедрые правительственные стипендии."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. Требуется подтверждение владения китайским (TOCFL) или английским языком."
    },
    "costTuition": 3900
  },
  {
    "iso": "pl",
    "langCode": "en",
    "langScore": 4,
    "langScoreComment": "IELTS 5.5; TOEFL iBT 80",
    "uniType": "Private",
    "gpaLevel": 3.4,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года (Licencjat) или 3.5 года (Inżynier). Медицина — 6 лет непрерывного обучения."
    },
    "enrollment_age": {
      "age_min": 17,
      "comment": "18 лет. Одно из самых популярных направлений для студентов из СНГ.",
      "age_max": 18
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. С 11 классами РФ поступать можно, требуется апостиль и перевод."
    },
    "deadlines": [
      {
        "date": "04"
      },
      {
        "date": "05"
      }
    ],
    "costTuition": 2667
  },
  {
    "iso": "cz",
    "langCode": "en",
    "langScore": 3.71,
    "langScoreComment": "IELTS 5.0; TOEFL iBT 62",
    "uniType": "Private",
    "gpaLevel": 3.4,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 4,
      "comment": "3 года. Обучение на чешском в госвузах бесплатно при любом гражданстве.",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Обязательна процедура нострификации аттестата (часто со сдачей экзаменов)."
    },
    "school_grade": {
      "grade_min": 13,
      "comment": "13 лет. Выпускникам 11 классов РФ нужно подтверждать аттестат через нострификацию."
    },
    "deadlines": [
      {
        "date": "04"
      },
      {
        "date": "05"
      }
    ],
    "costTuition": 3500
  },
  {
    "iso": "in",
    "langCode": "en",
    "langScore": 3.71,
    "langScoreComment": "IELTS 5.0; TOEFL iBT 80",
    "uniType": "Public",
    "gpaLevel": 3.2,
    "status": 0,
    "version": 1,
    "study_duration": {
      "years_mid": 4,
      "comment": "3 года для искусств и коммерции. 4 года для инженерии (B.Tech) и сельского хозяйства.",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "17-18 лет. Возрастной ценз может варьироваться в зависимости от штата и университета."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет (10+2). Высоко ценятся результаты экзаменов центральных советов (CBSE/ICSE)."
    },
    "deadlines": [
      {
        "date": "01-15"
      },
      {
        "date": "03-15"
      }
    ],
    "costTuition": 1566
  },
  {
    "iso": "ar",
    "langCode": "es",
    "langScore": 4,
    "langScoreComment": "DELE B2",
    "uniType": "Public",
    "gpaLevel": 3,
    "status": 1,
    "version": 1,
    "costTuition": 100,
    "deadlines": [
      {
        "date": "12-15",
        "comment": "Основной набор для начала в марте"
      },
      {
        "date": "05-31",
        "comment": "Для начала в августе"
      }
    ],
    "study_duration": {
      "years_mid": 5,
      "comment": "Licenciatura и профессиональные степени обычно требуют 5 лет"
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "Bachillerato или эквивалентное среднее образование"
    }
  },
  {
    "iso": "ae",
    "langCode": "en",
    "langScore": 4,
    "langScoreComment": "IELTS 5.5/6.0; TOEFL iBT 80",
    "uniType": "Private",
    "gpaLevel": 3.6,
    "status": 1,
    "version": 1,
    "recommended": 1.1,
    "study_duration": {
      "years_mid": 4,
      "comment": "3-4 года. Зависит от того, британский это филиал (3г) или американский/местный (4г).",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Студенты-иностранцы часто живут в кампусах международных академических городков."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов или 11 классов + foundation"
    },
    "deadlines": [
      {
        "date": "круглыйгод"
      }
    ],
    "costTuition": 32500
  },
  {
    "iso": "gr",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0; TOEFL iBT 80",
    "uniType": "Public",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года для большинства специальностей. Политехнические и некоторые аграрные вузы — 5 лет.",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 17,
      "comment": "18 лет. Иностранцы поступают по отдельной квоте через Министерство образования.",
      "age_max": 18
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. Обязателен сертификат о знании греческого языка (или год на его изучение)."
    },
    "deadlines": [
      {
        "date": "07-20"
      },
      {
        "date": "07-30"
      }
    ],
    "costTuition": 1667
  },
  {
    "iso": "mx",
    "langCode": "es",
    "langScore": 4,
    "langScoreComment": "DELE B2",
    "uniType": "Public",
    "gpaLevel": 3,
    "status": 1,
    "version": 1,
    "costTuition": 3600,
    "study_duration": {
      "years_mid": 4.5,
      "comment": "Варьируется от 4 до 5 лет в зависимости от факультета"
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "Возраст совершеннолетия в Мексике"
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "Bachillerato (полное среднее образование)"
    }
  },
  {
    "iso": "hu",
    "langCode": "en",
    "langScore": 4,
    "langScoreComment": "IELTS 5.5; TOEFL iBT 80",
    "uniType": "Private",
    "gpaLevel": 3.4,
    "status": 1,
    "version": 1,
    "recommended": 1.1,
    "deadlines": [
      {
        "date": "04-30",
        "comment": "на осень"
      },
      {
        "date": "06-15",
        "comment": "на осень"
      },
      {
        "date": "11-15",
        "comment": "на зиму"
      }
    ],
    "study_duration": {
      "years_mid": 3,
      "comment": "3 или 3.5 года в зависимости от специальности. Инженерные направления часто длиннее."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Популярно среди иностранных студентов благодаря доступности и качеству."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "costTuition": 6000
  },
  {
    "iso": "za",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0/6.5; TOEFL iBT 80",
    "uniType": "Public",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1,
    "costTuition": 4500,
    "study_duration": {
      "years_min": 3,
      "years_mid": 4,
      "comment": "Бакалавриат - 3 года; степень Honours добавляет 1 год"
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "Национальный сертификат старшей школы (NSC)"
    }
  },
  {
    "iso": "tr",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0",
    "uniType": "Public",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года. Перед началом обучения часто требуется год языковой подготовки (турецкий или английский)."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Иностранцы часто сдают специальный экзамен TR-YÖS для поступления."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "deadlines": [
      {
        "date": "06-01"
      },
      {
        "date": "08-30"
      }
    ],
    "costTuition": 1500
  },
  {
    "iso": "my",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0; TOEFL iBT 80",
    "uniType": "Public",
    "gpaLevel": 3.4,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 4,
      "comment": "3 года для большинства программ. Технические и медицинские направления — 4-5 лет.",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Обучение в международных филиалах часто дешевле, чем в оригинальных кампусах."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет (STPM/UEC). После 11 классов СНГ обычно требуется Foundation (1 год)."
    },
    "deadlines": [
      {
        "date": "02-28"
      },
      {
        "date": "07-30"
      }
    ],
    "costTuition": 4800
  },
  {
    "iso": "is",
    "langCode": "en",
    "langScore": 4.71,
    "langScoreComment": "IELTS 6.5",
    "uniType": "Private",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года (180 ECTS). Учебный год делится на два семестра: осенний и весенний."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Иностранные студенты должны подтвердить финансовую состоятельность для визы."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. Требуется эквивалент исландского аттестата зрелости (Studentspróf)."
    },
    "deadlines": [
      {
        "date": "02-01"
      }
    ],
    "costTuition": 6000
  },
  {
    "iso": "ee",
    "langCode": "en",
    "langScore": 4,
    "langScoreComment": "IELTS 5.5",
    "uniType": "Public",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года. Эстония — лидер по цифровизации образования, много программ в сфере ИТ."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Для поступления часто требуется минимальный средний балл аттестата."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. Принимаются аттестаты СНГ при условии их эквивалентности эстонскому уровню."
    },
    "deadlines": [
      {
        "date": "02"
      },
      {
        "date": "05"
      }
    ],
    "costTuition": 2667
  },
  {
    "iso": "lt",
    "langCode": "en",
    "langScore": 4,
    "langScoreComment": "IELTS 5.5",
    "uniType": "Private",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 3.5,
      "comment": "3.5 – 4 года. Программы включают обязательную практику и написание дипломной работы."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Многие вузы предлагают программы на английском для иностранных групп."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. Документы об образовании должны быть верифицированы центром SKVC."
    },
    "deadlines": [
      {
        "date": "05"
      },
      {
        "date": "07"
      }
    ],
    "costTuition": 3333
  },
  {
    "iso": "th",
    "langCode": "en",
    "langScore": 4,
    "langScoreComment": "IELTS 5.5/6.0",
    "uniType": "Public",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года. Программы в международных колледжах часто следуют западным стандартам.",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Студенческая виза оформляется после получения письма о зачислении."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. Аттестат о среднем образовании должен быть легализован."
    },
    "deadlines": [
      {
        "date": "04"
      },
      {
        "date": "06"
      }
    ],
    "costTuition": 4500
  },
  {
    "iso": "lv",
    "langCode": "en",
    "langScore": 4,
    "langScoreComment": "IELTS 5.5",
    "uniType": "Public",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года для академического бакалавриата, 4 года — для профессионального."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Студенческая виза позволяет работать до 20 часов в неделю."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. Требуется академическая справка (AIC) о признании уровня образования."
    },
    "deadlines": [
      {
        "date": "05"
      },
      {
        "date": "07"
      }
    ],
    "costTuition": 2433
  },
  {
    "iso": "cy",
    "langCode": "en",
    "langScore": 4,
    "langScoreComment": "IELTS 5.5; TOEFL iBT 80",
    "uniType": "Public",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года. Учебные планы часто строятся по американской системе (кредиты)."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Популярное место для международного образования на английском языке."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "deadlines": [
      {
        "date": "06-30"
      }
    ],
    "costTuition": 10000
  },
  {
    "iso": "si",
    "langCode": "sl",
    "langScore": 4,
    "langScoreComment": "B2 Level",
    "uniType": "Public",
    "gpaLevel": 3,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года. Словения имеет соглашения о бесплатном обучении с некоторыми странами."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Поступление проходит через централизованную систему приписки."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. Требуется перевод аттестата на словенский язык и признание его эквивалентности."
    },
    "deadlines": [
      {
        "date": "05"
      }
    ],
    "costTuition": 2400
  },
  {
    "iso": "mt",
    "langCode": "en",
    "langScore": 4,
    "langScoreComment": "IELTS 5.5; TOEFL iBT 80",
    "uniType": "Public",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года. Учебная система полностью основана на британских стандартах."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Привлекает студентов возможностью изучения английского и получения диплома ЕС."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. Требуется наличие Matriculation Certificate или международного эквивалента."
    },
    "deadlines": [
      {
        "date": "05"
      },
      {
        "date": "06"
      }
    ],
    "costTuition": 5717
  },
  {
    "iso": "hr",
    "langCode": "hr",
    "langScore": 4,
    "langScoreComment": "B2 Level",
    "uniType": "Public",
    "gpaLevel": 3,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года. Программы соответствуют стандартам Болонского процесса."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Иностранцы должны зарегистрироваться в системе Postani-student."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. Требуется признание аттестата через агентство AZOO или ASHE."
    },
    "deadlines": [
      {
        "date": "04"
      },
      {
        "date": "06"
      }
    ],
    "costTuition": 2000
  },
  {
    "iso": "ro",
    "langCode": "ro",
    "langScore": 4,
    "langScoreComment": "B2 Level",
    "uniType": "Private",
    "gpaLevel": 3,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года для большинства, 4 года для технических специальностей, 6 лет — медицина."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Требуется письмо о зачислении от Министерства образования Румынии."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. Аттестат должен пройти процедуру нострификации (признания)."
    },
    "deadlines": [
      {
        "date": "07-31",
        "comment": "Основной летний набор"
      },
      {
        "date": "09-13",
        "comment": "Поздний набор при наличии мест"
      }
    ],
    "costTuition": 3000
  },
  {
    "iso": "bg",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0",
    "uniType": "Public",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 4,
      "comment": "Обычно 4 года для степени бакалавра. Магистратура после этого занимает еще 1-2 года."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Поступление возможно до конца июля — начала сентября."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "deadlines": [
      {
        "date": "04"
      },
      {
        "date": "05"
      }
    ],
    "costTuition": 3483
  },
  {
    "iso": "sk",
    "langCode": "sk",
    "langScore": 4,
    "langScoreComment": "B2 Level",
    "uniType": "Public",
    "gpaLevel": 3,
    "status": 1,
    "version": 1,
    "deadlines": [
      {
        "date": "02-28",
        "comment": "Bachelor"
      }
    ],
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года. Обучение на словацком языке бесплатно для иностранцев в государственных вузах."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Визовый процесс требует справки о несудимости с апостилем."
    },
    "school_grade": {
      "grade_min": 13,
      "comment": "12-13 лет. Аттестат 11 классов РФ признается, но требует процесса нострификации."
    },
    "costTuition": 1900
  },
  {
    "iso": "rs",
    "langCode": "en",
    "langScore": 5,
    "langScoreComment": "TOEFL iBT 95",
    "uniType": "Public",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 4,
      "comment": "3 или 4 года (180 или 240 ECTS). Зависит от конкретной программы и факультета."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Процедура признания дипломов (нострификация) обязательна для всех иностранцев."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "deadlines": [
      {
        "date": "06"
      }
    ],
    "costTuition": 3000
  },
  {
    "iso": "ph",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0; TOEFL iBT 61",
    "uniType": "Public",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года. Система образования исторически связана с американской моделью."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Популярное направление для медицинского образования (BS + MD)."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет (после реформы K-12). Требуется легализация документов в посольстве."
    },
    "deadlines": [
      {
        "date": "01"
      },
      {
        "date": "06"
      }
    ],
    "costTuition": 1200,
    "recommended": 0.7
  },
  {
    "iso": "ge",
    "langCode": "en",
    "langScore": 4,
    "langScoreComment": "IELTS 5.5/6.5; TOEFL iBT 65/94",
    "uniType": "Public",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года (240 ECTS). Медицинские программы (MD) длятся 6 лет и приравнены к магистратуре."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Признание документов для иностранцев проходит через центр NCEQE в упрощенном порядке."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "deadlines": [
      {
        "date": "06"
      },
      {
        "date": "08"
      }
    ],
    "costTuition": 3500,
    "recommended": 0.8
  },
  {
    "iso": "vn",
    "langCode": "vi",
    "langScore": 4,
    "langScoreComment": "B2 Level",
    "uniType": "Private",
    "gpaLevel": 3,
    "status": 1,
    "version": 1,
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года для большинства специальностей. Инженерные программы часто длятся 5 лет."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Поступление на базе результатов национального экзамена или международных тестов."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет образования (K-12). Иностранные аттестаты проходят процедуру признания в министерстве."
    },
    "costTuition": 7500
  },
  {
    "iso": "jp",
    "langCode": "ja",
    "langScore": 4.35,
    "langScoreComment": "JLPT N2",
    "uniType": "Public",
    "gpaLevel": 3,
    "status": 1,
    "version": 1.1,
    "deadlines": [
      {
        "date": "10",
        "comment": "for march"
      },
      {
        "date": "11",
        "comment": "for october"
      },
      {
        "date": "03",
        "comment": "for october"
      }
    ],
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года. Для иностранных студентов часто предлагаются программы с обучением на английском (G30)."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Традиционный период начала занятий — апрель."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "costTuition": 5000
  },
  {
    "iso": "kr",
    "langCode": "ko",
    "langScore": 4,
    "langScoreComment": "TOPIK 4",
    "uniType": "Public",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1.1,
    "deadlines": [
      {
        "date": "2",
        "comment": "for september"
      },
      {
        "date": "5",
        "comment": "for september"
      },
      {
        "date": "7",
        "comment": "for march"
      },
      {
        "date": "11",
        "comment": "for march"
      }
    ],
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года. Учебный год начинается в марте, но есть и осенний набор в сентябре."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Важна не только успеваемость, но и знание корейского языка (TOPIK)."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "costTuition": 8000
  },
  {
    "iso": "se",
    "langCode": "sv",
    "langScore": 5.35,
    "langScoreComment": "TISUS",
    "uniType": "Public",
    "gpaLevel": 3.4,
    "status": 1,
    "version": 1.1,
    "deadlines": [
      {
        "date": "01-15",
        "comment": "на осень"
      },
      {
        "date": "10-15",
        "comment": "на весну"
      }
    ],
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года (180 ECTS). Учебный процесс сфокусирован на групповых проектах и критическом анализе."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Заявки подаются через единый портал Universityadmissions.se."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "costTuition": 9000
  },
  {
    "iso": "fi",
    "langCode": "fi",
    "langScore": 4.35,
    "langScoreComment": "YKI 4",
    "uniType": "Public",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1.1,
    "study_duration": {
      "years_mid": 4,
      "comment": "3.5 – 4 года в университетах прикладных наук (UAS). 3 года — в академических университетах.",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 17,
      "comment": "18 лет. Вступительные экзамены часто проводятся онлайн (International University Exam).",
      "age_max": 18
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "deadlines": [
      {
        "date": "01"
      }
    ],
    "costTuition": 0
  },
  {
    "iso": "no",
    "langCode": "no",
    "langScore": 4.71,
    "langScoreComment": "Bergenstest / Trinn 3",
    "uniType": "Public",
    "gpaLevel": 3.4,
    "status": 1,
    "version": 1.1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года. Обучение на бакалавриате в основном ведется на норвежском языке.",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Иностранцы должны подтвердить владение языком и финансовую независимость."
    },
    "school_grade": {
      "grade_min": 13,
      "comment": "13 лет (GNS). После 11 лет школы СНГ требуется 1 год обучения в вузе на родине."
    },
    "costTuition": 12000
  },
  {
    "iso": "nl",
    "langCode": "nl",
    "langScore": 4.35,
    "langScoreComment": "NT2-II",
    "uniType": "Public",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1.2,
    "deadlines": [
      {
        "date": "04-01",
        "comment": "на осень"
      },
      {
        "date": "06-15",
        "comment": "на осень"
      }
    ],
    "study_duration": {
      "years_mid": 4,
      "comment": "3 года в исследовательских вузах (WO), 4 года — в вузах прикладных наук (HBO).",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "\"18 лет. Система \"\"Numerus Fixus\"\" ограничивает количество мест на популярных направлениях.\""
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов или 11 классов + 1 год вуза"
    },
    "costTuition": 10000
  },
  {
    "iso": "be",
    "langCode": "fr",
    "langScore": 4,
    "langScoreComment": "DELF B2",
    "uniType": "Public",
    "gpaLevel": 3,
    "status": 1,
    "version": 1.1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года (180 ECTS). Профессиональный бакалавриат ориентирован на практику, академический — на магистратуру."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Ограничений по максимальному возрасту практически нет."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "deadlines": [
      {
        "date": "03-01"
      },
      {
        "date": "04-01"
      },
      {
        "date": "05-01"
      }
    ],
    "costTuition": 6000
  },
  {
    "iso": "be",
    "langCode": "nl",
    "langScore": 4,
    "langScoreComment": "CNaVT B2",
    "uniType": "Public",
    "gpaLevel": 3,
    "status": 1,
    "version": 1.1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года (180 ECTS). Профессиональный бакалавриат ориентирован на практику, академический — на магистратуру."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Ограничений по максимальному возрасту практически нет."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "deadlines": [
      {
        "date": "03-01"
      },
      {
        "date": "04-01"
      },
      {
        "date": "05-01"
      }
    ],
    "costTuition": 6000
  },
  {
    "iso": "pt",
    "langCode": "pt",
    "langScore": 4,
    "langScoreComment": "DIPLE B2",
    "uniType": "Public",
    "gpaLevel": 2.8,
    "status": 1,
    "version": 1.1,
    "study_duration": {
      "years_mid": 4,
      "comment": "3 года (Licenciatura). Некоторые инженерные степени могут длиться до 5 лет (Mestrado Integrado).",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Иностранцы поступают через специальный конкурс (Estatuto do Estudante Internacional)."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. Обязательна сдача вступительных экзаменов или признание результатов национальных тестов."
    },
    "deadlines": [
      {
        "date": "02"
      },
      {
        "date": "04"
      }
    ],
    "costTuition": 3000
  },
  {
    "iso": "pl",
    "langCode": "pl",
    "langScore": 4.35,
    "langScoreComment": "B2 Polish",
    "uniType": "Public",
    "gpaLevel": 2.8,
    "status": 1,
    "version": 1.1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года (Licencjat) или 3.5 года (Inżynier). Медицина — 6 лет непрерывного обучения."
    },
    "enrollment_age": {
      "age_min": 17,
      "comment": "18 лет. Одно из самых популярных направлений для студентов из СНГ.",
      "age_max": 18
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. С 11 классами РФ поступать можно, требуется апостиль и перевод."
    },
    "deadlines": [
      {
        "date": "04"
      },
      {
        "date": "05"
      }
    ],
    "costTuition": 2000
  },
  {
    "iso": "cz",
    "langCode": "cs",
    "langScore": 4,
    "langScoreComment": "CCE B2",
    "uniType": "Public",
    "gpaLevel": 3,
    "status": 1,
    "version": 1.1,
    "study_duration": {
      "years_mid": 4,
      "comment": "3 года. Обучение на чешском в госвузах бесплатно при любом гражданстве.",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Обязательна процедура нострификации аттестата (часто со сдачей экзаменов)."
    },
    "school_grade": {
      "grade_min": 13,
      "comment": "13 лет. Выпускникам 11 классов РФ нужно подтверждать аттестат через нострификацию."
    },
    "deadlines": [
      {
        "date": "04"
      },
      {
        "date": "05"
      }
    ],
    "costTuition": 400
  },
  {
    "iso": "hu",
    "langCode": "hu",
    "langScore": 4,
    "langScoreComment": "ECL B2",
    "uniType": "Public",
    "gpaLevel": 2.8,
    "status": 1,
    "version": 1.1,
    "deadlines": [
      {
        "date": "04-30",
        "comment": "на осень"
      },
      {
        "date": "06-15",
        "comment": "на осень"
      },
      {
        "date": "11-15",
        "comment": "на зиму"
      }
    ],
    "study_duration": {
      "years_mid": 3,
      "comment": "3 или 3.5 года в зависимости от специальности. Инженерные направления часто длиннее."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Популярно среди иностранных студентов благодаря доступности и качеству."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет школы. Требуется легализованный перевод аттестата и подтверждение квалификации."
    },
    "costTuition": 1500
  },
  {
    "iso": "tr",
    "langCode": "tr",
    "langScore": 4,
    "langScoreComment": "TÖMER B2",
    "uniType": "Public",
    "gpaLevel": 2.8,
    "status": 1,
    "version": 1.1,
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года. Перед началом обучения часто требуется год языковой подготовки (турецкий или английский)."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Иностранцы часто сдают специальный экзамен TR-YÖS для поступления."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "\"12 лет. Требуется \"\"Denklik\"\" — документ о признании эквивалентности аттестата.\""
    },
    "deadlines": [
      {
        "date": "06-01"
      },
      {
        "date": "08-30"
      }
    ],
    "costTuition": 1500
  },
  {
    "iso": "my",
    "langCode": "ms",
    "langScore": 3.35,
    "langScoreComment": "B1 Level",
    "uniType": "Public",
    "gpaLevel": 2.8,
    "status": 1,
    "version": 1.1,
    "study_duration": {
      "years_mid": 4,
      "comment": "3 года для большинства программ. Технические и медицинские направления — 4-5 лет.",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Обучение в международных филиалах часто дешевле, чем в оригинальных кампусах."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет (STPM/UEC). После 11 классов СНГ обычно требуется Foundation (1 год)."
    },
    "deadlines": [
      {
        "date": "02-28"
      },
      {
        "date": "07-30"
      }
    ],
    "costTuition": 4800
  },
  {
    "iso": "vn",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0",
    "uniType": "Private",
    "gpaLevel": 3,
    "status": 1,
    "version": 1.1,
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года для большинства специальностей. Инженерные программы часто длятся 5 лет."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Поступление на базе результатов национального экзамена или международных тестов."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет образования (K-12). Иностранные аттестаты проходят процедуру признания в министерстве."
    },
    "costTuition": 7500
  },
  {
    "iso": "ru",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0",
    "uniType": "Public",
    "gpaLevel": 3,
    "version": 1.1,
    "costTuition": 4500,
    "recommended": 0.5,
    "deadlines": [
      {
        "date": "06-15",
        "comment": "Основной дедлайн для оформления приглашений (виз)"
      }
    ],
    "study_duration": {
      "years_mid": 4,
      "comment": "Степень бакалавра с обучением на английском"
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "Минимум 11 лет среднего образования"
    }
  },
  {
    "iso": "ar",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0",
    "uniType": "Private",
    "gpaLevel": 3,
    "status": 1,
    "version": 1.1,
    "costTuition": 4000,
    "study_duration": {
      "years_mid": 4
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "Принимаются международные школьные дипломы"
    }
  },
  {
    "iso": "mx",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0",
    "uniType": "Private",
    "gpaLevel": 3,
    "status": 1,
    "version": 1.1,
    "costTuition": 7000,
    "study_duration": {
      "years_mid": 4
    },
    "enrollment_age": {
      "age_min": 18
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "Международные документы, эквивалентные Bachillerato"
    }
  },
  {
    "iso": "br",
    "langCode": "pt",
    "langScore": 4.35,
    "langScoreComment": "Celpe-Bras B2",
    "uniType": "Public",
    "gpaLevel": 3,
    "status": 1,
    "version": 1.1,
    "costTuition": 400,
    "study_duration": {
      "years_mid": 4.5,
      "comment": "Общий диапазон 4-5 лет, медицина - 6 лет"
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "Сертификат о среднем образовании (Certificado de Ensino Medio)"
    }
  },
  {
    "iso": "br",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0",
    "uniType": "Private",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1.1,
    "costTuition": 4000,
    "study_duration": {
      "years_mid": 4
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 12
    }
  },
  {
    "iso": "cl",
    "langCode": "es",
    "langScore": 4,
    "langScoreComment": "DELE B2",
    "uniType": "Public",
    "gpaLevel": 3,
    "status": 1,
    "version": 1.1,
    "costTuition": 4000,
    "study_duration": {
      "years_mid": 5,
      "comment": "Licenciatura и профессиональные степени"
    },
    "enrollment_age": {
      "age_min": 18
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "Лицензия о среднем образовании (Licencia de Educacion Media)"
    }
  },
  {
    "iso": "cl",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0",
    "uniType": "Private",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1.1,
    "costTuition": 6000,
    "deadlines": [
      {
        "date": "01-15",
        "comment": "Для оформления визы иностранного студента"
      }
    ],
    "study_duration": {
      "years_mid": 4
    },
    "enrollment_age": {
      "age_min": 18
    },
    "school_grade": {
      "grade_min": 12
    }
  },
  {
    "iso": "co",
    "langCode": "es",
    "langScore": 4,
    "langScoreComment": "DELE B2",
    "uniType": "Public",
    "gpaLevel": 2.8,
    "status": 1,
    "version": 1.1,
    "costTuition": 2500,
    "study_duration": {
      "years_mid": 5,
      "comment": "Стандарт для профессиональной степени"
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "Bachillerato (11 лет - типично для Колумбии)"
    }
  },
  {
    "iso": "pe",
    "langCode": "es",
    "langScore": 3.35,
    "langScoreComment": "DELE B1",
    "uniType": "Private",
    "gpaLevel": 2.8,
    "status": 1,
    "version": 1.1,
    "costTuition": 3000,
    "study_duration": {
      "years_mid": 5,
      "comment": "Стандартная продолжительность для университетских степеней Перу"
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "Официальный сертификат об обучении (Certificado Oficial de Estudios)"
    }
  },
  {
    "iso": "sa",
    "langCode": "ar",
    "langScore": 4.35,
    "langScoreComment": "ALPT B2",
    "uniType": "Public",
    "gpaLevel": 3,
    "status": 1,
    "version": 1.1,
    "costTuition": 2000,
    "deadlines": [
      {
        "date": "02-28",
        "comment": "Осенний набор через единый электронный портал"
      }
    ],
    "study_duration": {
      "years_mid": 4,
      "comment": "Исключая возможный подготовительный год (Foundation)"
    },
    "enrollment_age": {
      "age_min": 17,
      "age_max": 25,
      "comment": "Верхний предел применяется к иностранным соискателям стипендий"
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "Диплом старшей школы"
    }
  },
  {
    "iso": "sa",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0",
    "uniType": "Private",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1.1,
    "costTuition": 8000,
    "deadlines": [
      {
        "date": "05-31",
        "comment": "Дедлайн осеннего набора"
      }
    ],
    "study_duration": {
      "years_mid": 4
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "Принимаются международные системы (AP, IB, A-Levels)"
    }
  },
  {
    "iso": "eg",
    "langCode": "ar",
    "langScore": 4.35,
    "langScoreComment": "ALPT B2",
    "uniType": "Public",
    "gpaLevel": 2.8,
    "status": 1,
    "version": 1.1,
    "costTuition": 1500,
    "study_duration": {
      "years_mid": 4
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "Сертификат Thanawiya Amma"
    }
  },
  {
    "iso": "eg",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0",
    "uniType": "Private",
    "gpaLevel": 3,
    "status": 1,
    "version": 1.1,
    "costTuition": 9000,
    "study_duration": {
      "years_mid": 4
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "Международные эквиваленты: IGCSE, American Diploma"
    }
  },
  {
    "iso": "za",
    "langCode": "af",
    "langScore": 4,
    "langScoreComment": "B2 Afrikaans",
    "uniType": "Public",
    "gpaLevel": 3,
    "status": 1,
    "version": 1.1,
    "costTuition": 4500,
    "deadlines": [
      {
        "date": "09-30",
        "comment": "Основной набор на программы на языке африкаанс"
      }
    ],
    "study_duration": {
      "years_mid": 3,
      "comment": "Степень бакалавра"
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "Национальный сертификат старшей школы (National Senior Certificate)"
    }
  },
  {
    "iso": "ma",
    "langCode": "fr",
    "langScore": 4,
    "langScoreComment": "DELF B2",
    "uniType": "Public",
    "gpaLevel": 2.8,
    "status": 1,
    "version": 1.1,
    "costTuition": 1000,
    "deadlines": [
      {
        "date": "07-31",
        "comment": "Осенний набор"
      }
    ],
    "study_duration": {
      "years_mid": 3,
      "comment": "Степень Licence (система LMD)"
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "Аттестат бакалавриата (Attestation du Baccalauréat)"
    }
  },
  {
    "iso": "ma",
    "langCode": "ar",
    "langScore": 3.35,
    "langScoreComment": "ALPT B1",
    "uniType": "Public",
    "gpaLevel": 2.8,
    "status": 1,
    "version": 1.1,
    "costTuition": 500,
    "deadlines": [
      {
        "date": "07-31",
        "comment": "Осенний набор"
      }
    ],
    "study_duration": {
      "years_mid": 3,
      "comment": "Степень Licence"
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "Аттестат бакалавриата (Attestation du Baccalauréat)"
    }
  },
  {
    "iso": "id",
    "langCode": "id",
    "langScore": 3.35,
    "langScoreComment": "TIBA B1",
    "uniType": "Public",
    "gpaLevel": 2.8,
    "status": 1,
    "version": 1.1,
    "costTuition": 1500,
    "study_duration": {
      "years_mid": 4,
      "comment": "Степень Sarjana (S1)"
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "Сертификат SMA"
    }
  },
  {
    "iso": "id",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0",
    "uniType": "Private",
    "gpaLevel": 3,
    "status": 1,
    "version": 1.1,
    "costTuition": 4500,
    "study_duration": {
      "years_mid": 4
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 12
    }
  },
  {
    "iso": "kz",
    "langCode": "ru",
    "langScore": 4,
    "langScoreComment": "ТРКИ-2",
    "uniType": "Public",
    "gpaLevel": 2.8,
    "version": 1.1,
    "costTuition": 2000,
    "recommended": 0.5,
    "deadlines": [
      {
        "date": "08-15",
        "comment": "Основной набор для иностранных студентов на платной основе"
      }
    ],
    "study_duration": {
      "years_mid": 4
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "Аттестат о среднем образовании (GPA 3/5 или 82/100)"
    }
  },
  {
    "iso": "kz",
    "langCode": "kk",
    "langScore": 3.35,
    "langScoreComment": "KAZTEST B1",
    "uniType": "Public",
    "gpaLevel": 2.8,
    "status": 1,
    "version": 1.1,
    "costTuition": 1500,
    "recommended": 0.5,
    "deadlines": [
      {
        "date": "08-15",
        "comment": "Основной набор"
      }
    ],
    "study_duration": {
      "years_mid": 4
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "Аттестат о среднем образовании"
    }
  },
  {
    "iso": "kz",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0",
    "uniType": "Private",
    "gpaLevel": 3,
    "status": 1,
    "version": 1.1,
    "costTuition": 4000,
    "recommended": 0.5,
    "study_duration": {
      "years_mid": 4
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "Аттестат о среднем образовании"
    }
  },
  {
    "iso": "uz",
    "langCode": "ru",
    "langScore": 3.35,
    "langScoreComment": "ТРКИ-1",
    "uniType": "Public",
    "gpaLevel": 2.8,
    "version": 1.1,
    "costTuition": 1500,
    "recommended": 0.5,
    "deadlines": [
      {
        "date": "08-15",
        "comment": "Осенний набор для иностранных студентов"
      }
    ],
    "study_duration": {
      "years_mid": 4,
      "comment": "Бакалавр"
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "Аттестат о среднем образовании"
    }
  },
  {
    "iso": "uz",
    "langCode": "en",
    "langScore": 4,
    "langScoreComment": "IELTS 5.5",
    "uniType": "Private",
    "gpaLevel": 3,
    "status": 1,
    "version": 1.1,
    "costTuition": 4000,
    "recommended": 0.5,
    "deadlines": [
      {
        "date": "08-31",
        "comment": "Продленные дедлайны для частных англоязычных программ"
      }
    ],
    "study_duration": {
      "years_mid": 4
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 11
    }
  },
  {
    "iso": "az",
    "langCode": "en",
    "langScore": 4,
    "langScoreComment": "IELTS 5.5",
    "uniType": "Private",
    "gpaLevel": 2.8,
    "status": 1,
    "version": 1.1,
    "costTuition": 2500,
    "recommended": 0.5,
    "deadlines": [
      {
        "date": "08-15",
        "comment": "Осенний набор"
      }
    ],
    "study_duration": {
      "years_mid": 4
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "Аттестат о полном среднем образовании (Tam Orta Təhsil Haqqında Attestat)"
    }
  },
  {
    "iso": "am",
    "langCode": "en",
    "langScore": 4,
    "langScoreComment": "IELTS 5.5",
    "uniType": "Private",
    "gpaLevel": 2.8,
    "status": 1,
    "version": 1.1,
    "costTuition": 2000,
    "recommended": 0.7,
    "study_duration": {
      "years_mid": 4
    },
    "enrollment_age": {
      "age_min": 17
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "Аттестат о среднем образовании (Mijnakarg Krtutyan Attestat)"
    }
  },
  {
    "iso": "ge",
    "langCode": "ka",
    "langScore": 3.35,
    "langScoreComment": "B1 Georgian",
    "uniType": "Public",
    "gpaLevel": 2.8,
    "status": 1,
    "version": 1.1,
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года (240 ECTS). Медицинские программы (MD) длятся 6 лет и приравнены к магистратуре."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Признание документов для иностранцев проходит через центр NCEQE в упрощенном порядке."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "deadlines": [
      {
        "date": "06"
      },
      {
        "date": "08"
      }
    ],
    "costTuition": 1500,
    "recommended": 0.7
  },
  {
    "iso": "rs",
    "langCode": "sr",
    "langScore": 4,
    "langScoreComment": "B2 Serbian",
    "uniType": "Public",
    "gpaLevel": 2.8,
    "status": 1,
    "version": 1.1,
    "study_duration": {
      "years_mid": 4,
      "comment": "3 или 4 года (180 или 240 ECTS). Зависит от конкретной программы и факультета."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Процедура признания дипломов (нострификация) обязательна для всех иностранцев."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "deadlines": [
      {
        "date": "06"
      }
    ],
    "costTuition": 3000
  },
  {
    "iso": "ro",
    "langCode": "en",
    "langScore": 4.35,
    "langScoreComment": "IELTS 6.0",
    "uniType": "Public",
    "gpaLevel": 3,
    "status": 1,
    "version": 1.1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года для большинства, 4 года для технических специальностей, 6 лет — медицина."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Требуется письмо о зачислении от Министерства образования Румынии."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. Аттестат должен пройти процедуру нострификации (признания)."
    },
    "deadlines": [
      {
        "date": "07-31",
        "comment": "Основной период"
      },
      {
        "date": "09-13",
        "comment": "Период поздней подачи заявок"
      }
    ],
    "costTuition": 2500
  },
  {
    "iso": "bg",
    "langCode": "bg",
    "langScore": 4,
    "langScoreComment": "B2 Bulgarian",
    "uniType": "Public",
    "gpaLevel": 2.8,
    "status": 1,
    "version": 1.1,
    "study_duration": {
      "years_mid": 4,
      "comment": "Обычно 4 года для степени бакалавра. Магистратура после этого занимает еще 1-2 года."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Поступление возможно до конца июля — начала сентября."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов"
    },
    "deadlines": [
      {
        "date": "04"
      },
      {
        "date": "05"
      }
    ],
    "costTuition": 1500
  },
  {
    "iso": "lt",
    "langCode": "lt",
    "langScore": 4,
    "langScoreComment": "B2 Lithuanian",
    "uniType": "Public",
    "gpaLevel": 3,
    "status": 1,
    "version": 1.1,
    "study_duration": {
      "years_mid": 3.5,
      "comment": "3.5 – 4 года. Программы включают обязательную практику и написание дипломной работы."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Многие вузы предлагают программы на английском для иностранных групп."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. Документы об образовании должны быть верифицированы центром SKVC."
    },
    "deadlines": [
      {
        "date": "05"
      },
      {
        "date": "07"
      }
    ],
    "costTuition": 2000
  },
  {
    "iso": "lv",
    "langCode": "lv",
    "langScore": 4,
    "langScoreComment": "B2 Latvian",
    "uniType": "Public",
    "gpaLevel": 3,
    "status": 1,
    "version": 1.1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года для академического бакалавриата, 4 года — для профессионального."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Студенческая виза позволяет работать до 20 часов в неделю."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. Требуется академическая справка (AIC) о признании уровня образования."
    },
    "deadlines": [
      {
        "date": "05"
      },
      {
        "date": "07"
      }
    ],
    "costTuition": 2000
  },
  {
    "iso": "ee",
    "langCode": "et",
    "langScore": 4,
    "langScoreComment": "B2 Estonian",
    "uniType": "Public",
    "gpaLevel": 3,
    "status": 1,
    "version": 1.1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года. Эстония — лидер по цифровизации образования, много программ в сфере ИТ."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет. Для поступления часто требуется минимальный средний балл аттестата."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. Принимаются аттестаты СНГ при условии их эквивалентности эстонскому уровню."
    },
    "deadlines": [
      {
        "date": "02"
      },
      {
        "date": "05"
      }
    ],
    "costTuition": 2500
  },
  {
    "iso": "gr",
    "langCode": "el",
    "langScore": 4.35,
    "langScoreComment": "B2 Greek",
    "uniType": "Public",
    "gpaLevel": 2.8,
    "status": 1,
    "version": 1.1,
    "study_duration": {
      "years_mid": 4,
      "comment": "4 года для большинства специальностей. Политехнические и некоторые аграрные вузы — 5 лет.",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 17,
      "comment": "18 лет. Иностранцы поступают по отдельной квоте через Министерство образования.",
      "age_max": 18
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет. Обязателен сертификат о знании греческого языка (или год на его изучение)."
    },
    "deadlines": [
      {
        "date": "07-20"
      },
      {
        "date": "07-30"
      }
    ],
    "costTuition": 10800
  },
  {
    "iso": "il",
    "langCode": "he",
    "langScore": 4.35,
    "langScoreComment": "Ya'el B2",
    "uniType": "Public",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1.1,
    "study_duration": {
      "years_mid": 3,
      "comment": "3 года для большинства гуманитарных и точных наук. Инженерия — 4 года."
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "18 лет для иностранцев. Местные студенты обычно поступают в 20-21 год после службы в армии."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет (Bagrut). Выпускникам 11 классов СНГ обычно требуется подготовительный год (Mechina)."
    },
    "deadlines": [
      {
        "date": "01"
      },
      {
        "date": "05"
      }
    ],
    "costTuition": 5000
  },
  {
    "iso": "in",
    "langCode": "hi",
    "langScore": 3.35,
    "langScoreComment": "B1 Hindi",
    "uniType": "Public",
    "gpaLevel": 2.8,
    "status": 1,
    "version": 1.1,
    "study_duration": {
      "years_mid": 4,
      "comment": "3 года для искусств и коммерции. 4 года для инженерии (B.Tech) и сельского хозяйства.",
      "years_min": 3
    },
    "enrollment_age": {
      "age_min": 18,
      "comment": "17-18 лет. Возрастной ценз может варьироваться в зависимости от штата и университета."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "12 лет (10+2). Высоко ценятся результаты экзаменов центральных советов (CBSE/ICSE)."
    },
    "deadlines": [
      {
        "date": "01-15"
      },
      {
        "date": "03-15"
      }
    ],
    "costTuition": 1000
  },
  {
    "iso": "nl",
    "langCode": "en",
    "langScore": 4.29,
    "langScoreComment": "IELTS Academic 6.0 (не ниже 5.5 по модулям). Для рейтинговых программ (Numerus Fixus, TU Delft, UvA) требуется 6.5-7.0. Эквивалент TOEFL iBT 80-100.",
    "uniType": "Public",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1.1,
    "recommended": 1.1,
    "study_duration": {
      "years_min": 3,
      "years_mid": 3,
      "comment": "3 года. Исследовательские университеты (Research Universities). Интенсивная самостоятельная работа, высокий процент отсева на первом курсе."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "11 классов + 1 год в профильном вузе на родине ИЛИ программа Foundation. Аттестат должен быть строго эквивалентен нидерландскому VWO."
    },
    "deadlines": [
      {
        "date": "01-15",
        "comment": "Дедлайн для программ Numerus Fixus (конкурентные специальности)"
      },
      {
        "date": "04-01",
        "comment": "Ранний дедлайн некоторых университетов (например, UvA)"
      },
      {
        "date": "05-01",
        "comment": "Стандартный дедлайн для нерезидентов ЕС (обеспечивает визовую поддержку)"
      }
    ],
    "enrollment_age": {
      "age_min": 17,
      "comment": "Должен получить диплом, эквивалентный VWO, до начала учебного года"
    },
    "costTuition": 15000
  },
  {
    "iso": "us",
    "langCode": "en",
    "langScore": 4.71,
    "langScoreComment": "IELTS 6.5-7.0 (зависит от департамента, инженерные специальности требуют 7.0); TOEFL iBT 80-100. При IELTS 5.5-6.0 возможно условное зачисление (ESL).",
    "uniType": "Public",
    "gpaLevel": 3.5,
    "status": 1,
    "version": 1.1,
    "recommended": 1.1,
    "study_duration": {
      "years_min": 4,
      "years_mid": 4,
      "comment": "4 года. Первые два года посвящены изучению широкого спектра дисциплин (General Education), с последующей специализацией (Major). Возможна экономия через трансфер из Community College (модель 2+2)."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов. Прямое поступление возможно. Для большинства топовых государственных вузов в 2026 году рекомендована (или обязательна) сдача SAT/ACT."
    },
    "deadlines": [
      {
        "date": "11-01",
        "comment": "Early Action"
      },
      {
        "date": "01-15",
        "comment": "Regular Decision"
      },
      {
        "date": "03-01",
        "comment": "Rolling Admission"
      }
    ],
    "enrollment_age": {
      "age_min": 17,
      "comment": "Лицам до 18 лет требуется опекун по условиям визы F-1"
    },
    "costTuition": 31000
  },
  {
    "iso": "gb",
    "langCode": "en",
    "langScore": 4.29,
    "langScoreComment": "IELTS Academic 6.0 (не ниже 5.5 в каждой секции, строгое визовое требование UKVI); PTE Academic 58-65. Для зачисления на IFP требования могут быть снижены до IELTS 5.0-5.5.",
    "uniType": "Private",
    "gpaLevel": 2.6,
    "status": 1,
    "version": 1.1,
    "recommended": 1.1,
    "study_duration": {
      "years_min": 2,
      "years_mid": 3,
      "comment": "3 года (стандарт). Многие частные вузы предлагают ускоренные (fast-track) программы за 2 года без летних каникул для экономии средств."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "11 классов + 1 год на программе International Foundation Programme (IFP) обязателен. Интегрированные программы удлиняют срок обучения до 4 лет."
    },
    "enrollment_age": {
      "age_min": 18,
      "age_max": 18,
      "comment": "Максимальный возраст 18 лет строго применяется к некоторым клиническим программам/программам NHS"
    },
    "costTuition": 22500
  },
  {
    "iso": "de",
    "langCode": "de",
    "langScore": 4.5,
    "langScoreComment": "Сертификаты уровня C1: TestDaF (минимум TDN 4 во всех частях), DSH-2, Goethe-Zertifikat C1 или Telc Deutsch C1 Hochschule.",
    "uniType": "Private",
    "gpaLevel": 3.0,
    "status": 1,
    "version": 1.1,
    "recommended": 1.1,
    "study_duration": {
      "years_min": 3,
      "years_mid": 3,
      "comment": "3 года (6 семестров). Программы частных вузов глубоко интегрированы с индустрией, что включает обязательные длительные стажировки."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "11 классов + 1 год в Studienkolleg (и сдача экзамена FSP) ИЛИ 1 год очного обучения в признанном вузе на родине."
    },
    "deadlines": [
      {
        "date": "07-15",
        "comment": "Стандартный дедлайн для зимнего семестра по всей Германии"
      },
      {
        "date": "08-15",
        "comment": "Продленный дедлайн для частных университетов (зависит от сроков получения визы)"
      },
      {
        "date": "01-15",
        "comment": "Дедлайн для летнего семестра (если программа предполагает весенний старт)"
      }
    ],
    "enrollment_age": {
      "age_min": 17,
      "comment": "До 18 лет требуется согласие родителей для заключения юридических контрактов"
    },
    "costTuition": 11000
  },
  {
    "iso": "de",
    "langCode": "en",
    "langScore": 4.29,
    "langScoreComment": "IELTS 6.0-6.5 (в престижных бизнес-школах может требоваться 7.0); TOEFL iBT 80. Сертификат знания немецкого языка не требуется при поступлении.",
    "uniType": "Private",
    "gpaLevel": 3.0,
    "status": 1,
    "version": 1.1,
    "recommended": 1.1,
    "study_duration": {
      "years_min": 3,
      "years_mid": 3,
      "comment": "3 года. Многие программы предлагают семестр по обмену (Exchange Semester) в партнерских университетах по всему миру."
    },
    "school_grade": {
      "grade_min": 12,
      "comment": "11 классов + Studienkolleg ИЛИ программа International Year One (интегрированная подготовка при частном вузе на английском языке)."
    },
    "enrollment_age": {
      "age_min": 17,
      "comment": "Требуется согласие родителей на проживание и зачисление"
    },
    "costTuition": 18000
  },
  {
    "iso": "cn",
    "langCode": "zh",
    "langScore": 4.0,
    "langScoreComment": "HSK Level 4 (не менее 180 баллов) для инженерных/естественных наук; HSK Level 5 (не менее 180 баллов) для гуманитарных специальностей + обязательный HSKK Intermediate.",
    "uniType": "Private",
    "gpaLevel": 3.5,
    "status": 1,
    "version": 1.1,
    "recommended": 1.1,
    "study_duration": {
      "years_min": 4,
      "years_mid": 4,
      "comment": "4 года. Обучение включает элементы двуязычной подготовки. Отсутствие необходимого сертификата HSK компенсируется прохождением годичных языковых курсов."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов. Доступно прямое зачисление. Обязательна сдача стандартизированного теста CSCA (оценка академических компетенций по профильным предметам)."
    },
    "deadlines": [
      {
        "date": "04-30",
        "comment": "Ранние приоритетные дедлайны обычно в янв-фев"
      }
    ],
    "enrollment_age": {
      "age_min": 18,
      "comment": "К 1 сентября. Несовершеннолетним требуется нотариально заверенное местное опекунство"
    },
    "costTuition": 3500
  },
  {
    "iso": "cn",
    "langCode": "en",
    "langScore": 3.86,
    "langScoreComment": "IELTS 5.5-6.0; TOEFL iBT 72-80. Возможен waiver (освобождение), если обучение в старшей школе полностью велось на английском языке.",
    "uniType": "Private",
    "gpaLevel": 3.5,
    "status": 1,
    "version": 1.1,
    "recommended": 1.1,
    "study_duration": {
      "years_min": 4,
      "years_mid": 4,
      "comment": "4 года. Студенты получают два диплома (КНР и западного вуза-партнера). Изучение мандаринского языка обязательно на протяжении всей программы."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов. Прямое зачисление. Оценка осуществляется комплексно, включая мотивационные эссе и рекомендательные письма (особенно для вузов на базе Common App)."
    },
    "deadlines": [
      {
        "date": "05-30",
        "comment": "ранняя подача для Sino-foreign вузов"
      },
      {
        "date": "07-15",
        "comment": "поздняя подача"
      }
    ],
    "enrollment_age": {
      "age_min": 18,
      "comment": "К 1 сентября. Несовершеннолетним требуется нотариально заверенное местное опекунство"
    },
    "costTuition": 6500
  },
  {
    "iso": "kr",
    "langCode": "en",
    "langScore": 3.86,
    "langScoreComment": "IELTS Academic 5.5-7.0 (в зависимости от рейтинга; SKY-университеты требуют 6.5-7.0); TOEFL iBT 71-100. Внутренние тесты отменены.",
    "uniType": "Private",
    "gpaLevel": 3.2,
    "status": 1,
    "version": 1.1,
    "recommended": 1.1,
    "study_duration": {
      "years_min": 4,
      "years_mid": 4,
      "comment": "4 года (English Track). Обучение ведется на английском языке, однако для выпуска может потребоваться получение сертификата TOPIK (уровень 3 или 4)."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов. Прямое зачисление. Обязательна строгая процедура консульской легализации или проставления апостиля на аттестатах."
    },
    "deadlines": [
      {
        "date": "10-31",
        "comment": "на весенний семестр (Март)"
      },
      {
        "date": "04-30",
        "comment": "на осенний семестр (Сентябрь)"
      }
    ],
    "enrollment_age": {
      "age_min": 17,
      "comment": "Требуется завершение 12 лет начального/среднего образования"
    },
    "costTuition": 9000
  },
  {
    "iso": "hu",
    "langCode": "en",
    "langScore": 3.43,
    "langScoreComment": "IELTS 5.0-6.0; TOEFL iBT 70-80. Значительное число университетов предлагает внутреннее тестирование или интервью для подтверждения уровня B2 (CEFR) без сертификата.",
    "uniType": "Public",
    "gpaLevel": 2.5,
    "status": 1,
    "version": 1.1,
    "recommended": 1.1,
    "study_duration": {
      "years_min": 3,
      "years_mid": 3.5,
      "comment": "3-4 года. Продолжительность зависит от профиля (гуманитарные/бизнес – 3 года, инженерия – 3.5 года, медицина – до 6 лет)."
    },
    "school_grade": {
      "grade_min": 11,
      "comment": "11 классов. Прямое зачисление без Foundation. Могут потребоваться внутренние вступительные онлайн-экзамены (профильные тесты)."
    },
    "deadlines": [
      {
        "date": "01-15",
        "comment": "дедлайн на стипендию Stipendium Hungaricum"
      },
      {
        "date": "06-15",
        "comment": "платное обучение"
      }
    ],
    "enrollment_age": {
      "age_min": 17,
      "comment": "Требуется аттестат об окончании старшей школы"
    },
    "costTuition": 5500
  }
];

export const db_visas = {
  "ae": {
    "title": "Student Visa",
    "study_work_conditions": {
      "work_hours_per_week": 15,
      "comment": "Работа разрешена при получении разрешения (NOC) от университета и работодателя."
    },
    "financial_threshold": 15000,
    "post_study_visa": {
      "title": "Job Seeker Visa",
      "duration_min": 0.5,
      "duration_max": 0.5,
      "comment": "Стандартная виза для поиска работы выдается на 6 месяцев, однако студенты-отличники могут претендовать на 10-летнюю Golden Visa."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 1,
        "comment": "Въезд без визы или по тур. визе с оформлением ВНЖ/визы на месте или онлайн."
      },
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "by, kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "am": {
    "title": "Student Residence Permit",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Свободный доступ к рынку труда для граждан ЕАЭС, для остальных требуется разрешение на работу, поэтому по умолчанию 0."
    },
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Специального статуса для поиска работы нет (граждане ЕАЭС имеют свободный доступ к рынку труда без виз)."
    },
    "visa_risks": [
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "by, kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ru",
        "risk": 0,
        "comment": "Безвизовый въезд. Оформление ВНЖ на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "ar": {
    "title": "Residencia Temporaria - Estudiante",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "По студенческой визе официально работать нельзя, требуется смена статуса."
    },
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Специальная программа Post-Study не предусмотрена, смена статуса происходит по стандартной процедуре ВНЖ."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 1,
        "comment": "Въезд без визы или по тур. визе с оформлением ВНЖ/визы на месте или онлайн."
      },
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "by, kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "at": {
    "title": "Aufenthaltsbewilligung - Student",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "Требуется разрешение на работу (Beschäftigungsbewilligung), запрашиваемое работодателем."
    },
    "financial_threshold": 10900,
    "post_study_visa": {
      "title": "Red-White-Red Card (Job Seeker Visa)",
      "duration_min": 1,
      "duration_max": 1,
      "comment": "Выпускники австрийских вузов имеют право продлить ВНЖ на 12 месяцев специально для поиска работы."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 9.5,
        "comment": "Подача на студенческий ВНЖ лично в консульстве в Москве. Требуется консульская легализация документов. Отказы минимальны при строгом соблюдении формы."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 9,
        "comment": "Лояльное отношение к студентам. Процедура стандартизирована, отказы минимальны при полном пакете."
      },
      {
        "residencies": "by",
        "risk": 9,
        "comment": "Требуется легализация документов. Отказы редки при правильном пакете."
      },
      {
        "residencies": "kz",
        "risk": 6,
        "comment": "Подача штатная. Визовая политика лояльная, отказы минимальны при наличии допуска от вуза."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 5,
        "comment": "Лояльное отношение к студентам. Процедура стандартизирована, отказы минимальны при полном пакете."
      },
      {
        "residencies": "other",
        "risk": 2.5,
        "comment": "Лояльное отношение. Риски сводятся к нехватке финансовых средств или академическому несоответствию."
      },
      {
        "residencies": "ua",
        "risk": 1.5,
        "comment": "Подача стандартная, отношение максимально благоприятное. Отказы только из-за критических ошибок в досье."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      }
    ]
  },
  "au": {
    "title": "Student visa (subclass 500)",
    "study_work_conditions": {
      "work_hours_per_week": 24,
      "comment": "Разрешено работать до 48 часов в две недели во время учебы (в среднем 24 часа) и без ограничений на каникулах."
    },
    "financial_threshold": 19600,
    "post_study_visa": {
      "title": "Temporary Graduate Visa (Subclass 485)",
      "duration_min": 2,
      "duration_max": 2,
      "comment": "Срок действия для бакалавров недавно сокращен до 2 лет, а максимальный возраст заявителя снижен до 35 лет."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 41,
        "comment": "Подача на визу (Subclass 500) полностью онлайн, ВНЖ третьей страны не нужен. Глубокий скоринг документов (Genuine Student requirement). Есть риск аннуляции визы по прибытии при сомнениях погранслужбы."
      },
      {
        "residencies": "by",
        "risk": 39,
        "comment": "Глубокий скоринг Genuine Student. Повышенный риск из-за общих миграционных трендов."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 37.5,
        "comment": "Сложный процесс оценки Genuine Student. Высокие требования к документам."
      },
      {
        "residencies": "kz",
        "risk": 28,
        "comment": "Строгий скоринг Genuine Student. Риск аннуляции визы на границе при неубедительных ответах."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 27.5,
        "comment": "Сложный процесс оценки Genuine Student. Высокие требования к документам."
      },
      {
        "residencies": "other",
        "risk": 14.5,
        "comment": "Проверка Genuine Student обязательна. Отказы возможны при слабой академической мотивации."
      },
      {
        "residencies": "ua",
        "risk": 14,
        "comment": "Оценка профиля студента. При отсутствии убедительных академических целей возможен отказ."
      },
      {
        "residencies": "eu",
        "risk": 7.5,
        "comment": "Требуется студенческая виза. Процент одобрения высокий, однако проверки Genuine Student проводятся в полном объеме независимо от статуса в ЕС."
      },
      {
        "residencies": "us",
        "risk": 2.5,
        "comment": "Единая англосаксонская система обмена миграционными данными. Для резидентов США (с паспортом РФ) миграционные риски оцениваются как минимальные. Граждане США оформляют визы по максимально упрощенной электронной процедуре."
      }
    ]
  },
  "az": {
    "title": "Student Residence Permit (TRP)",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Иностранным студентам официально работать не разрешается без рабочей визы."
    },
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Азербайджан не предоставляет иностранцам дополнительных сроков пребывания для поиска работы после вуза."
    },
    "visa_risks": [
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "by, kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ru",
        "risk": 0,
        "comment": "Безвизовый въезд. Оформление ВНЖ на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "be": {
    "title": "Student Visa (Type D)",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "Разрешено работать до 475 часов в год при наличии регистрации в качестве работающего студента."
    },
    "financial_threshold": 12797,
    "post_study_visa": {
      "title": "Orientation Year (Zoekjaar / Année de recherche)",
      "duration_min": 1,
      "duration_max": 1,
      "comment": "Дает право остаться в стране на 12 месяцев для поиска подходящего места работы или открытия бизнеса."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 10,
        "comment": "Подача через ВЦ в РФ. Обязательна легализация и апостиль образовательных документов. Рассмотрение долгое, но предсказуемое."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 9,
        "comment": "Лояльное отношение к студентам. Процедура стандартизирована, отказы минимальны при полном пакете."
      },
      {
        "residencies": "by",
        "risk": 9,
        "comment": "Требуется легализация документов. Отказы редки при правильном пакете."
      },
      {
        "residencies": "kz",
        "risk": 6,
        "comment": "Подача штатная. Визовая политика лояльная, отказы минимальны при наличии допуска от вуза."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 5,
        "comment": "Лояльное отношение к студентам. Процедура стандартизирована, отказы минимальны при полном пакете."
      },
      {
        "residencies": "other",
        "risk": 2.5,
        "comment": "Лояльное отношение. Риски сводятся к нехватке финансовых средств или академическому несоответствию."
      },
      {
        "residencies": "ua",
        "risk": 1.5,
        "comment": "Подача стандартная, отношение максимально благоприятное. Отказы только из-за критических ошибок в досье."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      }
    ]
  },
  "bg": {
    "title": "Visa D / Student Residence Permit",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "Разрешено работать до 20 часов в неделю."
    },
    "financial_threshold": 5500,
    "post_study_visa": {
      "title": "Residence Permit for Job Seeking",
      "duration_min": 0.75,
      "duration_max": 0.75,
      "comment": "Разрешение на пребывание с целью поиска работы после учебы выдается на срок до 9 месяцев."
    },
    "visa_risks": [
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 4.5,
        "comment": "Низкие риски. Визы оформляются стабильно и быстро."
      },
      {
        "residencies": "ru",
        "risk": 3,
        "comment": "Выдача национальных виз D работает без сбоев через консульские учреждения в РФ."
      },
      {
        "residencies": "by",
        "risk": 3,
        "comment": "Подача работает штатно. Отказы минимальны."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 2.5,
        "comment": "Низкие риски. Визы оформляются стабильно и быстро."
      },
      {
        "residencies": "kz",
        "risk": 2.5,
        "comment": "Очень низкий процент отказов. Виза выдается без проблем."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "other",
        "risk": 1,
        "comment": "Формальная проверка документов. Риски минимальны."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      }
    ]
  },
  "br": {
    "title": "VITEM IV (Student Visa)",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Студенческая виза не дает права на работу."
    },
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Бразилия не предлагает выпускникам отдельной визы для поиска работы после завершения бакалавриата."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 1,
        "comment": "Въезд без визы или по тур. визе с оформлением ВНЖ/визы на месте или онлайн."
      },
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "by, kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "ca": {
    "title": "Study Permit",
    "study_work_conditions": {
      "work_hours_per_week": 24,
      "comment": "Лимит 24 часа в неделю вне кампуса. На кампусе без ограничений."
    },
    "financial_threshold": 22895,
    "post_study_visa": {
      "title": "Post-Graduation Work Permit (PGWP)",
      "duration_min": 1,
      "duration_max": 3,
      "comment": "Обязателен тест CLB 7. Срок по-прежнему до 3 лет, но без сдачи языкового экзамена ПГВП (PGWP) больше не выдают. (Новые регламенты IRCC)"
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 52,
        "comment": "Магистратура и PhD выведены из-под квот на Study Permits. Подача онлайн, сдача биометрии возможна в ВЦ как в РФ, так и в любых третьих странах без требования местного ВНЖ. Жесткая проверка миграционных намерений. (IRCC)"
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 48,
        "comment": "Высокий процент отказов из-за риска иммиграции. Тщательная проверка финансовых гарантий."
      },
      {
        "residencies": "by",
        "risk": 48,
        "comment": "Высокий уровень отказов из-за жесткой оценки миграционных намерений. Подача онлайн."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 38,
        "comment": "Высокий процент отказов из-за риска иммиграции. Тщательная проверка финансовых гарантий."
      },
      {
        "residencies": "kz",
        "risk": 38,
        "comment": "Жесткая оценка миграционных намерений. Высокий уровень отказов по категории 'неуверенность в возвращении'."
      },
      {
        "residencies": "other",
        "risk": 18,
        "comment": "Оценка миграционных рисков сохраняется для всех. Наличие сильного ВНЖ снижает риск, но не отменяет стандартную проверку."
      },
      {
        "residencies": "ua",
        "risk": 17,
        "comment": "Несмотря на лояльность, при подаче именно на классическую Study Permit (без спецпрограмм) проводится оценка намерений."
      },
      {
        "residencies": "eu",
        "risk": 10,
        "comment": "Процедура получения Study Permit / F-1 прозрачна. Отказы редки (в основном из-за ошибок в анкете или подозрений в нелегальной работе). Для граждан РФ с ВНЖ ЕС подача из Европы значительно повышает шансы."
      },
      {
        "residencies": "us",
        "risk": 2.5,
        "comment": "Единая англосаксонская система обмена миграционными данными. Для резидентов США (с паспортом РФ) миграционные риски оцениваются как минимальные. Граждане США оформляют визы по максимально упрощенной электронной процедуре."
      }
    ]
  },
  "ch": {
    "title": "Student B Permit",
    "study_work_conditions": {
      "work_hours_per_week": 15,
      "comment": "Разрешено работать до 15 часов в неделю, но только спустя 6 месяцев после начала учебы (кроме работы в самом вузе)."
    },
    "financial_threshold": 29400,
    "post_study_visa": {
      "title": "Право работы после учебы отсутствует",
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Право работы после учебы - 0 лет."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 11,
        "comment": "Подача в посольстве в Москве. Многоступенчатая проверка (одобрение кантона и федерального органа SEM). Основной упор на мотивационный план."
      },
      {
        "residencies": "by",
        "risk": 10,
        "comment": "Процедура инициируется вузом или требует одобрения локальных властей. Риски умеренные."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 9,
        "comment": "Лояльное отношение к студентам. Процедура стандартизирована, отказы минимальны при полном пакете."
      },
      {
        "residencies": "kz",
        "risk": 6,
        "comment": "Подача штатная. Визовая политика лояльная, отказы минимальны при наличии допуска от вуза."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 5,
        "comment": "Лояльное отношение к студентам. Процедура стандартизирована, отказы минимальны при полном пакете."
      },
      {
        "residencies": "other",
        "risk": 2.5,
        "comment": "Лояльное отношение. Риски сводятся к нехватке финансовых средств или академическому несоответствию."
      },
      {
        "residencies": "ua",
        "risk": 1.5,
        "comment": "Подача стандартная, отношение максимально благоприятное. Отказы только из-за критических ошибок в досье."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      }
    ]
  },
  "cl": {
    "title": "Visa de Estudiante",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "По умолчанию работать нельзя, требуется запрашивать специальное разрешение для прохождения практики."
    },
    "post_study_visa": {
      "title": "Permiso de Búsqueda de Oportunidades",
      "duration_min": 1,
      "duration_max": 1,
      "comment": "Новое миграционное законодательство Чили позволяет запрашивать визу на 12 месяцев для поиска возможностей."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 1,
        "comment": "Въезд без визы или по тур. визе с оформлением ВНЖ/визы на месте или онлайн."
      },
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "by, kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "cn": {
    "title": "X1 Visa",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Студентам запрещено работать за плату, разрешены только стажировки с согласия вуза и полиции."
    },
    "financial_threshold": 6000,
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Прямой визы для поиска работы нет, но выдающиеся выпускники могут сразу получить рабочую визу при наличии контракта."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 2,
        "comment": "Виза X1 выдается в РФ на базе формы JW201/JW202, оформляемой вузом. Проверки формальные."
      },
      {
        "residencies": "by",
        "risk": 2,
        "comment": "Процедура прозрачна, виза часто оформляется при участии вуза."
      },
      {
        "residencies": "kz",
        "risk": 1.5,
        "comment": "Виза оформляется быстро, часто через электронные системы или при поддержке вуза."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 1.5,
        "comment": "Подача проходит легко при поддержке принимающего университета."
      },
      {
        "residencies": "eu",
        "risk": 1,
        "comment": "Максимально лояльное отношение. Оформление проходит по линии университетов без задержек."
      },
      {
        "residencies": "other",
        "risk": 1,
        "comment": "Подача проходит легко при поддержке принимающего университета (Approval Letter/CoE)."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Процедура полностью стандартизирована и инициируется самим университетом (выдача электронных сертификатов CoE или Approval Letters). Риски минимальны для обладателей любого статуса в США."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      }
    ]
  },
  "co": {
    "title": "Visa V (Student)",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Студенческая виза не дает права на оплачиваемую работу."
    },
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Для продолжения пребывания в стране необходимо сразу оформить рабочую визу через компанию-спонсора."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 1,
        "comment": "Въезд без визы или по тур. визе с оформлением ВНЖ/визы на месте или онлайн."
      },
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "by, kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "cy": {
    "title": "Student Residence Permit",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "Работа разрешена до 20 часов в неделю, только в определенных секторах (после 6 месяцев учебы)."
    },
    "financial_threshold": 9810,
    "post_study_visa": {
      "title": "Job Seeker Residence Permit",
      "duration_min": 1,
      "duration_max": 1,
      "comment": "Успешные выпускники местных университетов могут получить временный вид на жительство на 12 месяцев для трудоустройства."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 5,
        "comment": "Учебную визу (Blue Slip) оформляет вуз через миграционную службу. Студент получает копию разрешения, по которой въезжает в страну."
      },
      {
        "residencies": "by",
        "risk": 4.5,
        "comment": "Визы выдаются стабильно. Требования к документам стандартные."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 4.5,
        "comment": "Низкие риски. Визы оформляются стабильно и быстро."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 2.5,
        "comment": "Низкие риски. Визы оформляются стабильно и быстро."
      },
      {
        "residencies": "kz",
        "risk": 2.5,
        "comment": "Очень низкий процент отказов. Виза выдается без проблем."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "other",
        "risk": 1,
        "comment": "Формальная проверка документов. Риски минимальны."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      }
    ]
  },
  "cz": {
    "title": "Long-term visa for study",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Студенты очного отделения имеют свободный доступ к рынку труда без ограничений по часам (поэтому часы формально не лимитированы, но вписан 0 по требованиям ограничений)."
    },
    "financial_threshold": 5400,
    "post_study_visa": {
      "title": "Residence Permit for Job Seeking",
      "duration_min": 0.75,
      "duration_max": 0.75,
      "comment": "Иностранцы, успешно окончившие чешский вуз, могут получить специальный ВНЖ для поиска работы сроком на 9 месяцев."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 100,
        "comment": "Полное эмбарго. Запрет на новые визы продлен; возможны только продления. (МИД Чехии)"
      },
      {
        "residencies": "by",
        "risk": 100,
        "comment": "Полное эмбарго. Запрет на новые визы продлен аналогично ограничениям для граждан РФ. (МИД Чехии)"
      },
      {
        "residencies": "us",
        "risk": 25,
        "comment": "Резкое разделение статусов: для граждан США риски отсутствуют (0%). Для граждан РФ, даже при наличии ВНЖ/ПМЖ США, сохраняются строгие законодательные ограничения на выдачу национальных студенческих виз D и ВНЖ по основному паспорту."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 11,
        "comment": "Выдача виз D и ВНЖ проходит в штатном режиме без политических ограничений."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 6,
        "comment": "Выдача виз D и ВНЖ проходит в штатном режиме без политических ограничений."
      },
      {
        "residencies": "kz",
        "risk": 4,
        "comment": "Для граждан РК ограничений нет. Процедура стандартная."
      },
      {
        "residencies": "eu",
        "risk": 2,
        "comment": "Для граждан ЕС действует свобода передвижения. Для граждан РФ с ПМЖ/ВНЖ ЕС политические барьеры существенно снижены или полностью снимаются (зависит от типа директивы ЕС)."
      },
      {
        "residencies": "other",
        "risk": 1.5,
        "comment": "Для обладателей паспортов вне РФ/РБ ограничений нет. Для граждан РФ с ВНЖ ЕС подача возможна, но рассматривается индивидуально."
      },
      {
        "residencies": "ua",
        "risk": 1.5,
        "comment": "Подача стандартная, отношение максимально благоприятное. Отказы только из-за критических ошибок в досье."
      }
    ]
  },
  "de": {
    "title": "Aufenthaltserlaubnis für Studienzwecke",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "140 полных или 280 неполных рабочих дней в году (в среднем 20 часов в неделю во время семестра)."
    },
    "financial_threshold": 13646,
    "post_study_visa": {
      "title": "Aufenthaltserlaubnis zur Arbeitsplatzsuche",
      "duration_min": 1.5,
      "duration_max": 1.5,
      "comment": "Выпускники немецких университетов получают право искать работу по профилю своего обучения в течение 18 месяцев."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 26.5,
        "comment": "Визовые риски значительные."
      },
      {
        "residencies": "by",
        "risk": 11,
        "comment": "Стандартная процедура выдачи национальных виз."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 9,
        "comment": "Лояльное отношение к студентам. Процедура стандартизирована, отказы минимальны при полном пакете."
      },
      {
        "residencies": "kz",
        "risk": 6,
        "comment": "Подача штатная. Визовая политика лояльная, отказы минимальны при наличии допуска от вуза."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 5,
        "comment": "Лояльное отношение к студентам. Процедура стандартизирована, отказы минимальны при полном пакете."
      },
      {
        "residencies": "other",
        "risk": 2.5,
        "comment": "Лояльное отношение. Риски сводятся к нехватке финансовых средств или академическому несоответствию."
      },
      {
        "residencies": "ua",
        "risk": 1.5,
        "comment": "Подача стандартная, отношение максимально благоприятное. Отказы только из-за критических ошибок в досье."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      }
    ]
  },
  "dk": {
    "title": "Student Residence Permit",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "До 20 часов в неделю в учебное время и полный рабочий день в июне, июле и августе."
    },
    "financial_threshold": 10584,
    "post_study_visa": {
      "title": "Residence Permit for Job Seeking",
      "duration_min": 3,
      "duration_max": 3,
      "comment": "По новым правилам, для выпускников аккредитованных бакалаврских программ срок визы для поиска работы увеличен до 3 лет."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 14,
        "comment": "Заявления на учебный ВНЖ принимаются через VFS Global в Москве. Обязательна сдача биометрии и тщательная верификация документов об образовании."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 13.5,
        "comment": "Стандартная скандинавская проверка. Причины отказа чаще всего в нехватке средств или ошибках досье."
      },
      {
        "residencies": "by",
        "risk": 13,
        "comment": "Обязательна сдача биометрии и тщательная верификация."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 9.5,
        "comment": "Стандартная скандинавская проверка. Причины отказа чаще всего в нехватке средств или ошибках досье."
      },
      {
        "residencies": "kz",
        "risk": 9.5,
        "comment": "Стандартные проверки скандинавских стран. Отказы из-за ошибок в досье."
      },
      {
        "residencies": "other",
        "risk": 4,
        "comment": "Стандартная процедура. Для резидентов безопасных третьих стран процент отказов стремится к базовой погрешности."
      },
      {
        "residencies": "ua",
        "risk": 2.5,
        "comment": "Лояльная визовая политика для украинских студентов. Риски почти отсутствуют."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      }
    ]
  },
  "ee": {
    "title": "TRP for Study",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Ограничений по часам нет (можно работать полный день), но работа не должна мешать учебе."
    },
    "financial_threshold": 6600,
    "post_study_visa": {
      "title": "Residence Permit for Job Seeking",
      "duration_min": 0.75,
      "duration_max": 0.75,
      "comment": "Эстония предоставляет выпускникам 9 месяцев для поиска работы или открытия бизнеса после окончания учебы."
    },
    "visa_risks": [
      {
        "residencies": "by",
        "risk": 100,
        "comment": "Выдача учебных виз и ВНЖ гражданам РБ приостановлена аналогично ограничениям для граждан РФ."
      },
      {
        "residencies": "ru",
        "risk": 100,
        "comment": "Оформление учебных виз и ВНЖ полностью прекращено для граждан РФ."
      },
      {
        "residencies": "us",
        "risk": 25,
        "comment": "Резкое разделение статусов: для граждан США риски отсутствуют (0%). Для граждан РФ, даже при наличии ВНЖ/ПМЖ США, сохраняются строгие законодательные ограничения на выдачу национальных студенческих виз D и ВНЖ по основному паспорту."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 11,
        "comment": "Выдача виз D и ВНЖ проходит в штатном режиме без политических ограничений."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 6,
        "comment": "Выдача виз D и ВНЖ проходит в штатном режиме без политических ограничений."
      },
      {
        "residencies": "kz",
        "risk": 4,
        "comment": "Для граждан РК ограничений нет. Процедура стандартная."
      },
      {
        "residencies": "eu",
        "risk": 2,
        "comment": "Для граждан ЕС действует свобода передвижения. Для граждан РФ с ПМЖ/ВНЖ ЕС политические барьеры существенно снижены или полностью снимаются (зависит от типа директивы ЕС)."
      },
      {
        "residencies": "other",
        "risk": 1.5,
        "comment": "Для обладателей паспортов вне РФ/РБ ограничений нет. Для граждан РФ с ВНЖ ЕС подача возможна, но рассматривается индивидуально."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      }
    ]
  },
  "eg": {
    "title": "Student Visa",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Иностранным студентам официально запрещено работать."
    },
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Законодательство Египта не предусматривает отдельного периода для поиска работы иностранными выпускниками."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 1,
        "comment": "Въезд без визы или по тур. визе с оформлением ВНЖ/визы на месте или онлайн."
      },
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "by, kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "es": {
    "title": "Estancia por estudios",
    "study_work_conditions": {
      "work_hours_per_week": 30,
      "comment": "До 30 часов в неделю, если работа не пересекается с расписанием занятий."
    },
    "financial_threshold": 7700,
    "post_study_visa": {
      "title": "Autorización de residencia para búsqueda de empleo",
      "duration_min": 1,
      "duration_max": 1,
      "comment": "Выпускники получают 1 год для поиска квалифицированной занятости или основания собственного бизнес-проекта."
    },
    "visa_risks": [
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 9,
        "comment": "Лояльное отношение к студентам. Процедура стандартизирована, отказы минимальны при полном пакете."
      },
      {
        "residencies": "ru",
        "risk": 8.5,
        "comment": "Подача в консульстве в Москве работает. Допускается въезд по шенгену (С) и подача на учебный ВНЖ непосредственно из Испании (estancia por estudios)."
      },
      {
        "residencies": "by",
        "risk": 6.5,
        "comment": "Лояльная визовая политика. Отказы единичны и связаны с академическими вопросами."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 5,
        "comment": "Лояльное отношение к студентам. Процедура стандартизирована, отказы минимальны при полном пакете."
      },
      {
        "residencies": "kz",
        "risk": 4,
        "comment": "Для граждан РК ограничений нет. Процедура стандартная."
      },
      {
        "residencies": "other",
        "risk": 2.5,
        "comment": "Лояльное отношение. Риски сводятся к нехватке финансовых средств или академическому несоответствию."
      },
      {
        "residencies": "ua",
        "risk": 1.5,
        "comment": "Подача стандартная, отношение максимально благоприятное. Отказы только из-за критических ошибок в досье."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      }
    ]
  },
  "fi": {
    "title": "Student Residence Permit",
    "study_work_conditions": {
      "work_hours_per_week": 30,
      "comment": "Разрешено работать в среднем до 30 часов в неделю."
    },
    "financial_threshold": 7325,
    "post_study_visa": {
      "title": "Job Seeker Permit",
      "duration_min": 2,
      "duration_max": 2,
      "comment": "Финляндия расширила срок действия ВНЖ для выпускников-соискателей до 2 лет для интеграции талантов."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 31,
        "comment": "Подача возможна в посольстве в Москве. Студентов впускают через границу (сухопутная закрыта, перелет через третьи страны), но проверки усилены. Особое внимание к мотивации обучения."
      },
      {
        "residencies": "by",
        "risk": 27.5,
        "comment": "Усиленные проверки мотивации обучения."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 13.5,
        "comment": "Стандартная скандинавская проверка. Причины отказа чаще всего в нехватке средств или ошибках досье."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 9.5,
        "comment": "Стандартная скандинавская проверка. Причины отказа чаще всего в нехватке средств или ошибках досье."
      },
      {
        "residencies": "kz",
        "risk": 9.5,
        "comment": "Стандартные проверки скандинавских стран. Отказы из-за ошибок в досье."
      },
      {
        "residencies": "other",
        "risk": 4,
        "comment": "Стандартная процедура. Для резидентов безопасных третьих стран процент отказов стремится к базовой погрешности."
      },
      {
        "residencies": "ua",
        "risk": 2.5,
        "comment": "Лояльная визовая политика для украинских студентов. Риски почти отсутствуют."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      }
    ]
  },
  "fr": {
    "title": "VLS-TS Étudiant",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "Разрешено работать до 964 часов в год (около 60% от полной занятости)."
    },
    "financial_threshold": 8118,
    "post_study_visa": {
      "title": "Recherche d'Emploi ou Création d'Entreprise (RECE)",
      "duration_min": 1,
      "duration_max": 1,
      "comment": "Виза на 1 год доступна выпускникам магистратуры и только обладателям профессионального бакалавриата (Licence Professionnelle)."
    },
    "visa_risks": [
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 9,
        "comment": "Лояльное отношение к студентам. Процедура стандартизирована, отказы минимальны при полном пакете."
      },
      {
        "residencies": "ru",
        "risk": 7.5,
        "comment": "Подача штатно через Campus France в РФ. Проводится обязательное академическое собеседование, отказы редки и мотивированы академической слабостью."
      },
      {
        "residencies": "by",
        "risk": 6.5,
        "comment": "Лояльная визовая политика. Отказы единичны и связаны с академическими вопросами."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 5,
        "comment": "Лояльное отношение к студентам. Процедура стандартизирована, отказы минимальны при полном пакете."
      },
      {
        "residencies": "kz",
        "risk": 4,
        "comment": "Для граждан РК ограничений нет. Процедура стандартная."
      },
      {
        "residencies": "other",
        "risk": 2.5,
        "comment": "Лояльное отношение. Риски сводятся к нехватке финансовых средств или академическому несоответствию."
      },
      {
        "residencies": "ua",
        "risk": 1.5,
        "comment": "Подача стандартная, отношение максимально благоприятное. Отказы только из-за критических ошибок в досье."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      }
    ]
  },
  "gb": {
    "title": "Student Visa",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "Максимум 20 часов в неделю во время семестра (для бакалавриата). На каникулах без ограничений."
    },
    "financial_threshold": 18834,
    "post_study_visa": {
      "title": "Graduate Route",
      "duration_min": 1.5,
      "duration_max": 1.5,
      "comment": "Для заявок с 01.01.2027 срок Graduate Visa сокращается до 18 месяцев. (Home Office)"
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 18,
        "comment": "Обязателен ATAS для STEM специальностей. Без сертификата ATAS (ожидание 6 недель) отказ в CAS. (Home Office)"
      },
      {
        "residencies": "by",
        "risk": 16.5,
        "comment": "Обязателен ATAS для STEM специальностей. Без сертификата ATAS (ожидание 6 недель) отказ в CAS. (Home Office)"
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 16.5,
        "comment": "Строгая оценка истории поездок и связей с родиной."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 11.5,
        "comment": "Строгая оценка истории поездок и связей с родиной."
      },
      {
        "residencies": "kz",
        "risk": 11.5,
        "comment": "Требуется хорошая визовая история. В целом процедура прозрачная."
      },
      {
        "residencies": "ua",
        "risk": 6,
        "comment": "Отношение максимально лояльное, но бумажные формальности (ошибки в анкетах) могут привести к отказу."
      },
      {
        "residencies": "other",
        "risk": 6,
        "comment": "Процедура прозрачна. Для обладателей ПМЖ/ВНЖ развитых стран риски минимальны (в основном технические ошибки)."
      },
      {
        "residencies": "eu",
        "risk": 4,
        "comment": "После Brexit гражданам ЕС требуются студенческие визы. Процесс автоматизирован (во многих случаях через приложение), отказы единичны."
      },
      {
        "residencies": "us",
        "risk": 1.5,
        "comment": "Максимальный уровень доверия. Отказы возможны исключительно из-за грубых ошибок в визовых анкетах (технический фактор) или неправильно оформленных документов от учебного заведения."
      }
    ]
  },
  "ge": {
    "title": "Study Visa (D3)",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Ограничений по часам нет, работать разрешено."
    },
    "financial_threshold": 5500,
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Отдельной визы нет, однако граждане многих стран могут находиться в Грузии без визы до 1 года."
    },
    "visa_risks": [
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "by, kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ru",
        "risk": 0,
        "comment": "Безвизовый въезд. Оформление ВНЖ на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "gr": {
    "title": "National Visa D (Study)",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "Допускается работа на неполный рабочий день (part-time)."
    },
    "financial_threshold": 5500,
    "post_study_visa": {
      "title": "Residence Permit for Job Seeking",
      "duration_min": 1,
      "duration_max": 1,
      "comment": "Греция выдает выпускникам национальных университетов вид на жительство сроком на 1 год для трудоустройства."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 6,
        "comment": "Визы выдаются стабильно через консульства в РФ. Строгие требования к апостилям. Риск проверок на границе незначительный."
      },
      {
        "residencies": "by",
        "risk": 4.5,
        "comment": "Визы выдаются стабильно. Требования к документам стандартные."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 4.5,
        "comment": "Низкие риски. Визы оформляются стабильно и быстро."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 2.5,
        "comment": "Низкие риски. Визы оформляются стабильно и быстро."
      },
      {
        "residencies": "kz",
        "risk": 2.5,
        "comment": "Очень низкий процент отказов. Виза выдается без проблем."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "other",
        "risk": 1,
        "comment": "Формальная проверка документов. Риски минимальны."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      }
    ]
  },
  "hk": {
    "title": "Student Visa",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Работа запрещена без спецразрешения NOL, допускаются только стажировки на кампусе."
    },
    "financial_threshold": 18000,
    "post_study_visa": {
      "title": "Immigration Arrangements for Non-local Graduates (IANG)",
      "duration_min": 2,
      "duration_max": 2,
      "comment": "Виза выдается на 24 месяца без требования иметь предварительное предложение о работе на момент подачи."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 1.5,
        "comment": "Виза оформляется иммиграционным департаментом Гонконга онлайн при спонсорстве университета. Вклейка визы не нужна (выдается e-Visa)."
      },
      {
        "residencies": "by",
        "risk": 1.5,
        "comment": "Оформление спонсируется университетом или проходит формально."
      },
      {
        "residencies": "eu",
        "risk": 1,
        "comment": "Максимально лояльное отношение. Оформление проходит по линии университетов без задержек."
      },
      {
        "residencies": "other",
        "risk": 1,
        "comment": "Подача проходит легко при поддержке принимающего университета (Approval Letter/CoE)."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Процедура полностью стандартизирована и инициируется самим университетом (выдача электронных сертификатов CoE или Approval Letters). Риски минимальны для обладателей любого статуса в США."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      }
    ]
  },
  "hr": {
    "title": "Temporary Stay for Study",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "Возможна работа через студенческие центры, но с ограничениями по доходу."
    },
    "financial_threshold": 4400,
    "post_study_visa": {
      "title": "Temporary Stay for Job Searching",
      "duration_min": 0.5,
      "duration_max": 0.5,
      "comment": "Хорватия позволяет иностранным студентам оставаться до 6 месяцев после учебы для поиска работы."
    },
    "visa_risks": [
      {
        "residencies": "by",
        "risk": 4.5,
        "comment": "Визы выдаются стабильно. Требования к документам стандартные."
      },
      {
        "residencies": "ru",
        "risk": 4.5,
        "comment": "Заявления подаются через визовые центры в РФ. Дополнительные собеседования не практикуются, въезд беспрепятственный."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 4.5,
        "comment": "Низкие риски. Визы оформляются стабильно и быстро."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 2.5,
        "comment": "Низкие риски. Визы оформляются стабильно и быстро."
      },
      {
        "residencies": "kz",
        "risk": 2.5,
        "comment": "Очень низкий процент отказов. Виза выдается без проблем."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "other",
        "risk": 1,
        "comment": "Формальная проверка документов. Риски минимальны."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      }
    ]
  },
  "hu": {
    "title": "Residence Permit for the Purpose of Study",
    "study_work_conditions": {
      "work_hours_per_week": 24,
      "comment": "До 24 часов в неделю во время семестра и до 90 дней в году вне семестра."
    },
    "financial_threshold": 8720,
    "post_study_visa": {
      "title": "Study-to-Work Residence Permit",
      "duration_min": 0.75,
      "duration_max": 0.75,
      "comment": "Выдается на 9 месяцев, предоставляя выпускникам время на профильное трудоустройство или регистрацию компании."
    },
    "visa_risks": [
      {
        "residencies": "by",
        "risk": 4.5,
        "comment": "Визы выдаются стабильно. Требования к документам стандартные."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 4.5,
        "comment": "Низкие риски. Визы оформляются стабильно и быстро."
      },
      {
        "residencies": "ru",
        "risk": 4.5,
        "comment": "Подача в консульстве в Москве. Процесс быстрый, собеседование лояльное, проверки документов базовые."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 2.5,
        "comment": "Низкие риски. Визы оформляются стабильно и быстро."
      },
      {
        "residencies": "kz",
        "risk": 2.5,
        "comment": "Очень низкий процент отказов. Виза выдается без проблем."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "other",
        "risk": 1,
        "comment": "Формальная проверка документов. Риски минимальны."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      }
    ]
  },
  "id": {
    "title": "Student ITAS",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Официально работать по студенческой визе нельзя."
    },
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Специального периода для поиска работы нет, статус зависит от немедленного спонсорства работодателем."
    },
    "visa_risks": [
      {
        "residencies": "by",
        "risk": 1.5,
        "comment": "Оформление спонсируется университетом или проходит формально."
      },
      {
        "residencies": "ru",
        "risk": 1.5,
        "comment": "Оформление студенческой визы онлайн или формально."
      },
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "ie": {
    "title": "Stamp 2",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "20 часов в неделю во время семестра и 40 часов во время установленных каникул."
    },
    "financial_threshold": 10900,
    "post_study_visa": {
      "title": "Third Level Graduate Programme (Stamp 1G)",
      "duration_min": 1,
      "duration_max": 1,
      "comment": "Программа Stamp 1G позволяет обладателям степени Honours Bachelor Degree (Level 8) легально работать ровно 1 год."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 24,
        "comment": "Подача документов через визовый центр VFS в Москве. Очень строгий контроль предыдущей визовой истории и связей с родиной. Процесс бумажный и долгий."
      },
      {
        "residencies": "by",
        "risk": 22,
        "comment": "Долгий процесс, строгий контроль связей с родиной."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 16.5,
        "comment": "Строгая оценка истории поездок и связей с родиной."
      },
      {
        "residencies": "kz",
        "risk": 14,
        "comment": "Строгий контроль предыдущей визовой истории."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 11.5,
        "comment": "Строгая оценка истории поездок и связей с родиной."
      },
      {
        "residencies": "other",
        "risk": 6,
        "comment": "Процедура прозрачна. Для обладателей ПМЖ/ВНЖ развитых стран риски минимальны (в основном технические ошибки)."
      },
      {
        "residencies": "ua",
        "risk": 5,
        "comment": "Сверхлояльное отношение к гражданам Украины, минимальные риски."
      },
      {
        "residencies": "eu",
        "risk": 4,
        "comment": "После Brexit гражданам ЕС требуются студенческие визы. Процесс автоматизирован (во многих случаях через приложение), отказы единичны."
      },
      {
        "residencies": "us",
        "risk": 1.5,
        "comment": "Максимальный уровень доверия. Отказы возможны исключительно из-за грубых ошибок в визовых анкетах (технический фактор) или неправильно оформленных документов от учебного заведения."
      }
    ]
  },
  "il": {
    "title": "A/2 Student Visa",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Виза А/2 не дает права на работу, требуется специальное разрешение МВД."
    },
    "financial_threshold": 7200,
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Открытой визы для соискателей нет, выпускники должны подаваться на стандартную рабочую визу (B/1) через работодателя."
    },
    "visa_risks": [
      {
        "residencies": "other",
        "risk": 4,
        "comment": "Возможны проверки безопасности на границе независимо от резидентства."
      },
      {
        "residencies": "by",
        "risk": 3.5,
        "comment": "Обязательное собеседование. Риск дополнительных проверок на границе."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 3.5,
        "comment": "Риск дополнительных проверок на границе."
      },
      {
        "residencies": "ua",
        "risk": 3.5,
        "comment": "Строгий пограничный контроль, возможны дополнительные проверки на границе."
      },
      {
        "residencies": "ru",
        "risk": 3,
        "comment": "Оформление визы А/2 в посольстве в РФ. Обязательное собеседование с консулом. На границе проводятся строгие проверки службы безопасности."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 3,
        "comment": "Риск дополнительных проверок на границе."
      },
      {
        "residencies": "kz",
        "risk": 3,
        "comment": "Риск отказов минимален, но есть риск дополнительных проверок на границе."
      },
      {
        "residencies": "eu",
        "risk": 2.5,
        "comment": "Отказов в консульстве практически нет, но возможны стандартные собеседования на границе для подтверждения целей."
      },
      {
        "residencies": "us",
        "risk": 2,
        "comment": "Консульские отказы крайне редки, однако сохраняется вероятность стандартных пограничных проверок и детальных собеседований при пересечении границы."
      }
    ]
  },
  "in": {
    "title": "Student Visa",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Иностранным студентам запрещено работать во время учебы."
    },
    "financial_threshold": 2000,
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Индия не предоставляет иностранным студентам специальных виз для поиска работы после окончания учебы."
    },
    "visa_risks": [
      {
        "residencies": "by",
        "risk": 1.5,
        "comment": "Оформление спонсируется университетом или проходит формально."
      },
      {
        "residencies": "ru",
        "risk": 1.5,
        "comment": "Оформление студенческой визы онлайн или формально."
      },
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "is": {
    "title": "Student Residence Permit",
    "study_work_conditions": {
      "work_hours_per_week": 22,
      "comment": "Разрешено работать до 22.5 часов в неделю с получением разрешения на работу (60% от полной ставки)."
    },
    "post_study_visa": {
      "title": "Residence Permit for Job Seeking",
      "duration_min": 0.5,
      "duration_max": 0.5,
      "comment": "Выпускники исландских университетов могут запросить ВНЖ на 6 месяцев для поиска квалифицированной работы."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 17,
        "comment": "Подача на ВНЖ возможна в РФ через визовые центры стран-партнеров (обычно Дания или Норвегия). Строгая проверка бумажных документов."
      },
      {
        "residencies": "by",
        "risk": 16,
        "comment": "Строгая проверка бумажных документов."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 13.5,
        "comment": "Стандартная скандинавская проверка. Причины отказа чаще всего в нехватке средств или ошибках досье."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 9.5,
        "comment": "Стандартная скандинавская проверка. Причины отказа чаще всего в нехватке средств или ошибках досье."
      },
      {
        "residencies": "kz",
        "risk": 9.5,
        "comment": "Стандартные проверки скандинавских стран. Отказы из-за ошибок в досье."
      },
      {
        "residencies": "other",
        "risk": 4,
        "comment": "Стандартная процедура. Для резидентов безопасных третьих стран процент отказов стремится к базовой погрешности."
      },
      {
        "residencies": "ua",
        "risk": 2.5,
        "comment": "Лояльная визовая политика для украинских студентов. Риски почти отсутствуют."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      }
    ]
  },
  "it": {
    "title": "Permesso di soggiorno per motivi di studio",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "До 20 часов в неделю, максимум 1040 часов в год."
    },
    "financial_threshold": 7100,
    "post_study_visa": {
      "title": "Permesso di soggiorno per attesa occupazione",
      "duration_min": 1,
      "duration_max": 1,
      "comment": "Данный тип ВНЖ позволяет иностранцам легально находиться в Италии 1 год для трудоустройства после учебы."
    },
    "visa_risks": [
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 9,
        "comment": "Лояльное отношение к студентам. Процедура стандартизирована, отказы минимальны при полном пакете."
      },
      {
        "residencies": "ru",
        "risk": 7,
        "comment": "Прием через ВЦ в Москве. Ключевой процедурный момент — оформление Dichiarazione di Valore. Въезд проходит без препятствий на погранконтроле."
      },
      {
        "residencies": "by",
        "risk": 6.5,
        "comment": "Лояльная визовая политика. Отказы единичны и связаны с академическими вопросами."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 5,
        "comment": "Лояльное отношение к студентам. Процедура стандартизирована, отказы минимальны при полном пакете."
      },
      {
        "residencies": "kz",
        "risk": 4,
        "comment": "Для граждан РК ограничений нет. Процедура стандартная."
      },
      {
        "residencies": "other",
        "risk": 2.5,
        "comment": "Лояльное отношение. Риски сводятся к нехватке финансовых средств или академическому несоответствию."
      },
      {
        "residencies": "ua",
        "risk": 1.5,
        "comment": "Подача стандартная, отношение максимально благоприятное. Отказы только из-за критических ошибок в досье."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      }
    ]
  },
  "jp": {
    "title": "Student Visa",
    "study_work_conditions": {
      "work_hours_per_week": 28,
      "comment": "С разрешением до 28 часов в неделю во время семестра, 40 часов на каникулах."
    },
    "financial_threshold": 15000,
    "post_study_visa": {
      "title": "Designated Activities Visa (Job Hunting)",
      "duration_min": 0.5,
      "duration_max": 2,
      "comment": "До 2 лет (по новой визе J-Find для выпускников топ-вузов). (Immigration Services Agency of Japan)"
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 3.5,
        "comment": "Подача в РФ на основе оригинала Certificate of Eligibility от японского вуза. При наличии сертификата виза выдается автоматически."
      },
      {
        "residencies": "by",
        "risk": 3,
        "comment": "Подача работает штатно. Отказы минимальны."
      },
      {
        "residencies": "kz",
        "risk": 1.5,
        "comment": "Виза оформляется быстро, часто через электронные системы или при поддержке вуза."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 1.5,
        "comment": "Подача проходит легко при поддержке принимающего университета."
      },
      {
        "residencies": "eu",
        "risk": 1,
        "comment": "Максимально лояльное отношение. Оформление проходит по линии университетов без задержек."
      },
      {
        "residencies": "other",
        "risk": 1,
        "comment": "Подача проходит легко при поддержке принимающего университета (Approval Letter/CoE)."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Процедура полностью стандартизирована и инициируется самим университетом (выдача электронных сертификатов CoE или Approval Letters). Риски минимальны для обладателей любого статуса в США."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      }
    ]
  },
  "kr": {
    "title": "D-2 Visa",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "Обычно до 20 часов в неделю (лимит может увеличиваться в зависимости от знания корейского языка TOPIK)."
    },
    "financial_threshold": 15000,
    "post_study_visa": {
      "title": "D-10 Job Seeker Visa",
      "duration_min": 0.5,
      "duration_max": 2,
      "comment": "Виза первоначально выдается на 6 месяцев, но может продлеваться каждые полгода (до 2 лет) при активном поиске вакансий."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 3,
        "comment": "Выдача виз D-2 в штатном режиме через консульства в РФ. Возможны интервью, но отказы единичны."
      },
      {
        "residencies": "by",
        "risk": 3,
        "comment": "Подача работает штатно. Отказы минимальны."
      },
      {
        "residencies": "kz",
        "risk": 1.5,
        "comment": "Виза оформляется быстро, часто через электронные системы или при поддержке вуза."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 1.5,
        "comment": "Подача проходит легко при поддержке принимающего университета."
      },
      {
        "residencies": "eu",
        "risk": 1,
        "comment": "Максимально лояльное отношение. Оформление проходит по линии университетов без задержек."
      },
      {
        "residencies": "other",
        "risk": 1,
        "comment": "Подача проходит легко при поддержке принимающего университета (Approval Letter/CoE)."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Процедура полностью стандартизирована и инициируется самим университетом (выдача электронных сертификатов CoE или Approval Letters). Риски минимальны для обладателей любого статуса в США."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      }
    ]
  },
  "kz": {
    "title": "Student Visa (C9)",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Официально по студенческой визе работать нельзя."
    },
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Иностранным студентам для работы необходимо оформлять стандартное разрешение через работодателя."
    },
    "visa_risks": [
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "by, kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ru",
        "risk": 0,
        "comment": "Безвизовый въезд. Оформление ВНЖ на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "lt": {
    "title": "TRP for Study",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "Для бакалавров до 20 часов в неделю."
    },
    "financial_threshold": 6600,
    "post_study_visa": {
      "title": "Temporary Residence Permit for Job Seeking",
      "duration_min": 1,
      "duration_max": 1,
      "comment": "Литва предоставляет выпускникам-иностранцам 1 год на поиск работы по полученной квалификации."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 100,
        "comment": "Выдача национальных виз D и ВНЖ приостановлена. Подача невозможна ни в РФ, ни в третьих странах без иных оснований."
      },
      {
        "residencies": "by",
        "risk": 45,
        "comment": "~40-50. Белорусы проходят усиленные проверки Департамента госбезопасности (VSD), но полного запрета на учебные ВНЖ для них нет (в отличие от РФ). (MIGRIS)"
      },
      {
        "residencies": "us",
        "risk": 25,
        "comment": "Резкое разделение статусов: для граждан США риски отсутствуют (0%). Для граждан РФ, даже при наличии ВНЖ/ПМЖ США, сохраняются строгие законодательные ограничения на выдачу национальных студенческих виз D и ВНЖ по основному паспорту."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 11,
        "comment": "Выдача виз D и ВНЖ проходит в штатном режиме без политических ограничений."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 6,
        "comment": "Выдача виз D и ВНЖ проходит в штатном режиме без политических ограничений."
      },
      {
        "residencies": "kz",
        "risk": 4,
        "comment": "Для граждан РК ограничений нет. Процедура стандартная."
      },
      {
        "residencies": "eu",
        "risk": 2,
        "comment": "Для граждан ЕС действует свобода передвижения. Для граждан РФ с ПМЖ/ВНЖ ЕС политические барьеры существенно снижены или полностью снимаются (зависит от типа директивы ЕС)."
      },
      {
        "residencies": "other",
        "risk": 1.5,
        "comment": "Для обладателей паспортов вне РФ/РБ ограничений нет. Для граждан РФ с ВНЖ ЕС подача возможна, но рассматривается индивидуально."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      }
    ]
  },
  "lu": {
    "title": "Residence Permit for Students",
    "study_work_conditions": {
      "work_hours_per_week": 15,
      "comment": "Разрешено работать до 15 часов в неделю."
    },
    "post_study_visa": {
      "title": "Residence Permit for Job Search",
      "duration_min": 1,
      "duration_max": 1,
      "comment": "Студенты, окончившие вуз в Люксембурге, получают 12 месяцев на поиск работы или создание компании."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 10.5,
        "comment": "Разрешение запрашивается в миграционном управлении заочно (почтой). После одобрения вклейка визы в Москве. Риски связаны исключительно с корректностью досье."
      },
      {
        "residencies": "by",
        "risk": 10,
        "comment": "Процедура инициируется вузом или требует одобрения локальных властей. Риски умеренные."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 9,
        "comment": "Лояльное отношение к студентам. Процедура стандартизирована, отказы минимальны при полном пакете."
      },
      {
        "residencies": "kz",
        "risk": 6,
        "comment": "Подача штатная. Визовая политика лояльная, отказы минимальны при наличии допуска от вуза."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 5,
        "comment": "Лояльное отношение к студентам. Процедура стандартизирована, отказы минимальны при полном пакете."
      },
      {
        "residencies": "other",
        "risk": 2.5,
        "comment": "Лояльное отношение. Риски сводятся к нехватке финансовых средств или академическому несоответствию."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      }
    ]
  },
  "lv": {
    "title": "TRP for Study",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "До 20 часов в неделю для студентов бакалавриата."
    },
    "financial_threshold": 8250,
    "post_study_visa": {
      "title": "Temporary Residence Permit",
      "duration_min": 0.75,
      "duration_max": 0.75,
      "comment": "Латвия разрешает выпускникам продлить ВНЖ на 9 месяцев специально для поиска работы."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 100,
        "comment": "Выдача первичных ВНЖ по учебе для граждан РФ официально приостановлена. Запрет закреплен на государственном уровне."
      },
      {
        "residencies": "by",
        "risk": 100,
        "comment": "Выдача учебных виз и ВНЖ гражданам РБ приостановлена аналогично ограничениям для граждан РФ."
      },
      {
        "residencies": "us",
        "risk": 25,
        "comment": "Резкое разделение статусов: для граждан США риски отсутствуют (0%). Для граждан РФ, даже при наличии ВНЖ/ПМЖ США, сохраняются строгие законодательные ограничения на выдачу национальных студенческих виз D и ВНЖ по основному паспорту."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 11,
        "comment": "Выдача виз D и ВНЖ проходит в штатном режиме без политических ограничений."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 6,
        "comment": "Выдача виз D и ВНЖ проходит в штатном режиме без политических ограничений."
      },
      {
        "residencies": "kz",
        "risk": 4,
        "comment": "Для граждан РК ограничений нет. Процедура стандартная."
      },
      {
        "residencies": "eu",
        "risk": 2,
        "comment": "Для граждан ЕС действует свобода передвижения. Для граждан РФ с ПМЖ/ВНЖ ЕС политические барьеры существенно снижены или полностью снимаются (зависит от типа директивы ЕС)."
      },
      {
        "residencies": "other",
        "risk": 1.5,
        "comment": "Для обладателей паспортов вне РФ/РБ ограничений нет. Для граждан РФ с ВНЖ ЕС подача возможна, но рассматривается индивидуально."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      }
    ]
  },
  "ma": {
    "title": "Student Visa",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Работа не разрешена без отдельного контракта и рабочей визы."
    },
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Марокко не выдает специальных виз для поиска работы выпускникам национальных университетов."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 1,
        "comment": "Въезд без визы или по тур. визе с оформлением ВНЖ/визы на месте или онлайн."
      },
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "by, kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "mt": {
    "title": "Student Visa",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "Разрешено работать со второго триместра после получения лицензии Jobsplus."
    },
    "financial_threshold": 15118,
    "post_study_visa": {
      "title": "Job Seeker Visa",
      "duration_min": 0.5,
      "duration_max": 0.5,
      "comment": "Иностранным студентам предоставляется ровно 6 месяцев для легального поиска работы после окончания учебы."
    },
    "visa_risks": [
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 4.5,
        "comment": "Низкие риски. Визы оформляются стабильно и быстро."
      },
      {
        "residencies": "ru",
        "risk": 3.5,
        "comment": "Подача в Москве работает. Возможен въезд по шенгенской визе с последующим оформлением национального ВНЖ."
      },
      {
        "residencies": "by",
        "risk": 3,
        "comment": "Подача работает штатно. Отказы минимальны."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 2.5,
        "comment": "Низкие риски. Визы оформляются стабильно и быстро."
      },
      {
        "residencies": "kz",
        "risk": 2.5,
        "comment": "Очень низкий процент отказов. Виза выдается без проблем."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "other",
        "risk": 1,
        "comment": "Формальная проверка документов. Риски минимальны."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      }
    ]
  },
  "mx": {
    "title": "Residente Temporal Estudiante",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Студенческая виза не дает права на работу, требуется оформление рабочего разрешения."
    },
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Для легального трудоустройства потребуется получить предложение о работе и сменить статус на рабочий."
    },
    "visa_risks": [
      {
        "residencies": "other",
        "risk": 4,
        "comment": "Возможны проверки безопасности на границе независимо от резидентства."
      },
      {
        "residencies": "ru",
        "risk": 4,
        "comment": "Обязательное собеседование в посольстве в РФ. Главный риск — контроль на границе из-за общей политики по недопущению нелегальной миграции в США."
      },
      {
        "residencies": "by",
        "risk": 3.5,
        "comment": "Обязательное собеседование. Риск дополнительных проверок на границе."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 3.5,
        "comment": "Риск дополнительных проверок на границе."
      },
      {
        "residencies": "ua",
        "risk": 3.5,
        "comment": "Строгий пограничный контроль, возможны дополнительные проверки на границе."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 3,
        "comment": "Риск дополнительных проверок на границе."
      },
      {
        "residencies": "kz",
        "risk": 3,
        "comment": "Риск отказов минимален, но есть риск дополнительных проверок на границе."
      },
      {
        "residencies": "eu",
        "risk": 2.5,
        "comment": "Отказов в консульстве практически нет, но возможны стандартные собеседования на границе для подтверждения целей."
      },
      {
        "residencies": "us",
        "risk": 2,
        "comment": "Консульские отказы крайне редки, однако сохраняется вероятность стандартных пограничных проверок и детальных собеседований при пересечении границы."
      }
    ]
  },
  "my": {
    "title": "Student Pass",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "Разрешено работать только на каникулах не более 20 часов в неделю с разрешения иммиграции."
    },
    "financial_threshold": 5000,
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Для работы выпускникам необходимо сразу получить Employment Pass при спонсорстве местной компании."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 1.5,
        "comment": "Оформление Approval Letter через EMGS (онлайн). После этого вклейка Single Entry Visa в посольстве в Москве без лишних проверок."
      },
      {
        "residencies": "by",
        "risk": 1.5,
        "comment": "Оформление спонсируется университетом или проходит формально."
      },
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "nl": {
    "title": "Residence Permit for Study",
    "study_work_conditions": {
      "work_hours_per_week": 16,
      "comment": "Требуется разрешение (TWV). Максимум 16 часов в неделю во время учебы ИЛИ полное время в летние месяцы."
    },
    "financial_threshold": 16023,
    "post_study_visa": {
      "title": "Orientation Year (Zoekjaar)",
      "duration_min": 1,
      "duration_max": 1,
      "comment": "Программа «ориентационного года» дает 1 год на поиск работы без необходимости отдельного разрешения (TWV) для работодателя."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 25.5,
        "comment": "Визовые риски значительные."
      },
      {
        "residencies": "by",
        "risk": 10,
        "comment": "Процедура инициируется вузом или требует одобрения локальных властей. Риски умеренные."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 9,
        "comment": "Лояльное отношение к студентам. Процедура стандартизирована, отказы минимальны при полном пакете."
      },
      {
        "residencies": "kz",
        "risk": 6,
        "comment": "Подача штатная. Визовая политика лояльная, отказы минимальны при наличии допуска от вуза."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 5,
        "comment": "Лояльное отношение к студентам. Процедура стандартизирована, отказы минимальны при полном пакете."
      },
      {
        "residencies": "other",
        "risk": 2.5,
        "comment": "Лояльное отношение. Риски сводятся к нехватке финансовых средств или академическому несоответствию."
      },
      {
        "residencies": "ua",
        "risk": 1.5,
        "comment": "Подача стандартная, отношение максимально благоприятное. Отказы только из-за критических ошибок в досье."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      }
    ]
  },
  "no": {
    "title": "Study Permit",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "До 20 часов в неделю в течение семестра, без ограничений на каникулах."
    },
    "post_study_visa": {
      "title": "Residence Permit for Job Seekers",
      "duration_min": 1,
      "duration_max": 1,
      "comment": "Выпускники норвежских вузов могут получить ВНЖ сроком на 1 год для поиска квалифицированной работы."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 22.5,
        "comment": "Сложная процедура подачи через ВЦ в РФ. Значительно повышен процент отказов из-за строгой оценки привязки к родине. На границе возможны длительные опросы."
      },
      {
        "residencies": "by",
        "risk": 20.5,
        "comment": "Сложная процедура, высокая доля отказов по причине подозрений в иммиграции."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 13.5,
        "comment": "Стандартная скандинавская проверка. Причины отказа чаще всего в нехватке средств или ошибках досье."
      },
      {
        "residencies": "kz",
        "risk": 12,
        "comment": "Оценка привязки к родине. Риски средние."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 9.5,
        "comment": "Стандартная скандинавская проверка. Причины отказа чаще всего в нехватке средств или ошибках досье."
      },
      {
        "residencies": "other",
        "risk": 4,
        "comment": "Стандартная процедура. Для резидентов безопасных третьих стран процент отказов стремится к базовой погрешности."
      },
      {
        "residencies": "ua",
        "risk": 2.5,
        "comment": "Лояльная визовая политика для украинских студентов. Риски почти отсутствуют."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      }
    ]
  },
  "nz": {
    "title": "Fee Paying Student Visa",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "До 20 часов в неделю во время учебы, полный рабочий день на каникулах."
    },
    "financial_threshold": 12000,
    "post_study_visa": {
      "title": "Post-Study Work Visa",
      "duration_min": 3,
      "duration_max": 3,
      "comment": "Выпускники бакалавриата (Level 7) получают право на открытую рабочую визу с фиксированным сроком 3 года."
    },
    "visa_risks": [
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 37.5,
        "comment": "Сложный процесс оценки Genuine Student. Высокие требования к документам."
      },
      {
        "residencies": "ru",
        "risk": 32.5,
        "comment": "Подача онлайн из РФ. Доскональная проверка подлинности намерений. Собеседования редки, но в случае малейших несостыковок в документах следует отказ."
      },
      {
        "residencies": "by",
        "risk": 30.5,
        "comment": "Строгая оценка подлинности намерений. Подача онлайн."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 27.5,
        "comment": "Сложный процесс оценки Genuine Student. Высокие требования к документам."
      },
      {
        "residencies": "kz",
        "risk": 22,
        "comment": "Онлайн-подача. Строгая оценка подлинности намерений."
      },
      {
        "residencies": "other",
        "risk": 14.5,
        "comment": "Проверка Genuine Student обязательна. Отказы возможны при слабой академической мотивации."
      },
      {
        "residencies": "ua",
        "risk": 11.5,
        "comment": "Стандартная проверка намерений."
      },
      {
        "residencies": "eu",
        "risk": 7.5,
        "comment": "Требуется студенческая виза. Процент одобрения высокий, однако проверки Genuine Student проводятся в полном объеме независимо от статуса в ЕС."
      },
      {
        "residencies": "us",
        "risk": 2.5,
        "comment": "Единая англосаксонская система обмена миграционными данными. Для резидентов США (с паспортом РФ) миграционные риски оцениваются как минимальные. Граждане США оформляют визы по максимально упрощенной электронной процедуре."
      }
    ]
  },
  "pe": {
    "title": "Visa de Estudiante",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "По умолчанию работать нельзя."
    },
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "В Перу отсутствует специальная миграционная программа для интеграции иностранных выпускников."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 1,
        "comment": "Въезд без визы или по тур. визе с оформлением ВНЖ/визы на месте или онлайн."
      },
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "by, kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "ph": {
    "title": "Student Visa (9F)",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Работа строго запрещена иностранным студентам."
    },
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Специального разрешения на поиск работы после учебы на Филиппинах не предусмотрено."
    },
    "visa_risks": [
      {
        "residencies": "by",
        "risk": 1.5,
        "comment": "Оформление спонсируется университетом или проходит формально."
      },
      {
        "residencies": "ru",
        "risk": 1.5,
        "comment": "Удобная процедура конвертации обычной туристической визы в студенческую (9F) прямо на территории Филиппин."
      },
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "pl": {
    "title": "Student Visa / TRP",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Студенты дневного отделения имеют право работать без ограничений по часам."
    },
    "financial_threshold": 1010,
    "post_study_visa": {
      "title": "Residence Permit for Job-seeking",
      "duration_min": 0.75,
      "duration_max": 0.75,
      "comment": "Выпускники польских вузов дневного отделения имеют право получить ВНЖ на 9 месяцев для поиска работы по специальности."
    },
    "visa_risks": [
      {
        "residencies": "by",
        "risk": 35,
        "comment": "~30-40. Студенческие визы для граждан РБ выдаются (особенно при наличии Карты Поляка). (МИД Польши)"
      },
      {
        "residencies": "ru",
        "risk": 100,
        "comment": "Приостановлена выдача национальных виз для студентов-граждан РФ. Подача документов заблокирована."
      },
      {
        "residencies": "us",
        "risk": 25,
        "comment": "Резкое разделение статусов: для граждан США риски отсутствуют (0%). Для граждан РФ, даже при наличии ВНЖ/ПМЖ США, сохраняются строгие законодательные ограничения на выдачу национальных студенческих виз D и ВНЖ по основному паспорту."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 11,
        "comment": "Выдача виз D и ВНЖ проходит в штатном режиме без политических ограничений."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 6,
        "comment": "Выдача виз D и ВНЖ проходит в штатном режиме без политических ограничений."
      },
      {
        "residencies": "kz",
        "risk": 4,
        "comment": "Для граждан РК ограничений нет. Процедура стандартная."
      },
      {
        "residencies": "eu",
        "risk": 2,
        "comment": "Для граждан ЕС действует свобода передвижения. Для граждан РФ с ПМЖ/ВНЖ ЕС политические барьеры существенно снижены или полностью снимаются (зависит от типа директивы ЕС)."
      },
      {
        "residencies": "other",
        "risk": 1.5,
        "comment": "Для обладателей паспортов вне РФ/РБ ограничений нет. Для граждан РФ с ВНЖ ЕС подача возможна, но рассматривается индивидуально."
      },
      {
        "residencies": "ua",
        "risk": 1.5,
        "comment": "Подача стандартная, отношение максимально благоприятное. Отказы только из-за критических ошибок в досье."
      }
    ]
  },
  "pt": {
    "title": "Student Visa",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "Разрешается работать с уведомлением иммиграционной службы (AIMA/SEF)."
    },
    "financial_threshold": 7700,
    "post_study_visa": {
      "title": "Residence Permit for Job Searching",
      "duration_min": 1,
      "duration_max": 1,
      "comment": "Выпускники имеют право запросить ВНЖ сроком на 12 месяцев для трудоустройства в Португалии."
    },
    "visa_risks": [
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 4.5,
        "comment": "Низкие риски. Визы оформляются стабильно и быстро."
      },
      {
        "residencies": "ru",
        "risk": 3.5,
        "comment": "Подача через VFS в РФ. Главная сложность — долгие сроки рассмотрения, однако процент одобрения близок к 100%."
      },
      {
        "residencies": "by",
        "risk": 3,
        "comment": "Подача работает штатно. Отказы минимальны."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 2.5,
        "comment": "Низкие риски. Визы оформляются стабильно и быстро."
      },
      {
        "residencies": "kz",
        "risk": 2.5,
        "comment": "Очень низкий процент отказов. Виза выдается без проблем."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "other",
        "risk": 1,
        "comment": "Формальная проверка документов. Риски минимальны."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      }
    ]
  },
  "ro": {
    "title": "Student Visa (D/SD)",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "Не более 4 часов в день (около 20 часов в неделю)."
    },
    "post_study_visa": {
      "title": "Residence Permit for Job Seeking",
      "duration_min": 0.75,
      "duration_max": 0.75,
      "comment": "Румыния позволяет иностранным выпускникам остаться в стране на 9 месяцев с целью поиска работы."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 28.5,
        "comment": "Подача на визу D проходит через консульство в Москве. Скрупулезная проверка мотивационного письма и подлинности документов из вуза."
      },
      {
        "residencies": "by",
        "risk": 25,
        "comment": "Строгая проверка документов и мотивационного письма."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 4.5,
        "comment": "Низкие риски. Визы оформляются стабильно и быстро."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 2.5,
        "comment": "Низкие риски. Визы оформляются стабильно и быстро."
      },
      {
        "residencies": "kz",
        "risk": 2.5,
        "comment": "Очень низкий процент отказов. Виза выдается без проблем."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "other",
        "risk": 1,
        "comment": "Формальная проверка документов. Риски минимальны."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      }
    ]
  },
  "rs": {
    "title": "Temporary Residence (Study)",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Для работы нужно оформлять отдельное разрешение через работодателя."
    },
    "financial_threshold": 4400,
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Специальная виза для поиска работы не предусмотрена, для легализации требуется рабочий контракт."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 0.5,
        "comment": "Безвизовый въезд. Учебный ВНЖ (Privremeni boravak) оформляется в Управлении по делам иностранцев на территории страны."
      },
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "by, kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "ru": {
    "title": "Student Visa / РВПО",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Студенты могут работать в свободное время без отдельного разрешения. Ограничений по часам нет."
    },
    "post_study_visa": {
      "title": "РВПО (Разрешение на временное проживание в целях образования)",
      "duration_min": 0.5,
      "duration_max": 0.5,
      "comment": "Закон позволяет выпускникам оставаться в РФ легально еще 180 дней после выпуска для трудоустройства."
    },
    "visa_risks": [
      {
        "residencies": "ua",
        "risk": 100,
        "comment": "Выдача студенческих виз гражданам Украины не осуществляется по соображениям безопасности."
      },
      {
        "residencies": "us",
        "risk": 3,
        "comment": "Для граждан США процедура требует оформления официального приглашения от принимающего вуза, возможны базовые бюрократические проверки. Для граждан РФ с ВНЖ США виза не требуется (свободный въезд по загранпаспорту РФ)."
      },
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "by, kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Виза не требуется (СНГ) или лояльный режим."
      },
      {
        "residencies": "ru",
        "risk": 0,
        "comment": "Гражданам РФ виза для обучения не требуется."
      }
    ]
  },
  "sa": {
    "title": "Student Visa",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Работа не разрешена."
    },
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Остаться в стране можно только при немедленном переводе спонсорства на местного работодателя."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 1,
        "comment": "Въезд без визы или по тур. визе с оформлением ВНЖ/визы на месте или онлайн."
      },
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "by, kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "se": {
    "title": "Residence Permit for Studies",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Официальных ограничений по часам нет, можно работать, но требуется сохранять успеваемость."
    },
    "financial_threshold": 11990,
    "post_study_visa": {
      "title": "Residence permit for looking for work",
      "duration_min": 1,
      "duration_max": 1,
      "comment": "Выпускникам бакалаврских программ предоставляется 12 месяцев на поиск работы в Швеции или старт собственного дела."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 16,
        "comment": "Заявление на ВНЖ подается онлайн из РФ, биометрия сдается в посольстве. Проверки стандартизированы, отказы в основном из-за некомплектности досье."
      },
      {
        "residencies": "by",
        "risk": 15,
        "comment": "Проверки стандартизированы, отказы в основном из-за неполного пакета."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 13.5,
        "comment": "Стандартная скандинавская проверка. Причины отказа чаще всего в нехватке средств или ошибках досье."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 9.5,
        "comment": "Стандартная скандинавская проверка. Причины отказа чаще всего в нехватке средств или ошибках досье."
      },
      {
        "residencies": "kz",
        "risk": 9.5,
        "comment": "Стандартные проверки скандинавских стран. Отказы из-за ошибок в досье."
      },
      {
        "residencies": "other",
        "risk": 4,
        "comment": "Стандартная процедура. Для резидентов безопасных третьих стран процент отказов стремится к базовой погрешности."
      },
      {
        "residencies": "ua",
        "risk": 2.5,
        "comment": "Лояльная визовая политика для украинских студентов. Риски почти отсутствуют."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      }
    ]
  },
  "sg": {
    "title": "Student's Pass",
    "study_work_conditions": {
      "work_hours_per_week": 16,
      "comment": "Только студенты одобренных вузов могут работать до 16 часов в неделю во время семестра."
    },
    "financial_threshold": 30000,
    "post_study_visa": {
      "title": "Short-Term Visit Pass (STVP)",
      "duration_min": 0.25,
      "duration_max": 0.25,
      "comment": "После аннулирования студенческой визы дается 90 дней (STVP) на завершение дел или поиск спонсора-работодателя."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 2.5,
        "comment": "Виза (Student's Pass) оформляется университетом онлайн через систему SOLAR. Личное присутствие студента не требуется вплоть до въезда."
      },
      {
        "residencies": "by",
        "risk": 2,
        "comment": "Процедура прозрачна, виза часто оформляется при участии вуза."
      },
      {
        "residencies": "kz",
        "risk": 1.5,
        "comment": "Виза оформляется быстро, часто через электронные системы или при поддержке вуза."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 1.5,
        "comment": "Подача проходит легко при поддержке принимающего университета."
      },
      {
        "residencies": "eu",
        "risk": 1,
        "comment": "Максимально лояльное отношение. Оформление проходит по линии университетов без задержек."
      },
      {
        "residencies": "other",
        "risk": 1,
        "comment": "Подача проходит легко при поддержке принимающего университета (Approval Letter/CoE)."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Процедура полностью стандартизирована и инициируется самим университетом (выдача электронных сертификатов CoE или Approval Letters). Риски минимальны для обладателей любого статуса в США."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      }
    ]
  },
  "si": {
    "title": "Residence Permit for Study",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "Работа возможна через студенческие службы (Student Service)."
    },
    "financial_threshold": 3300,
    "post_study_visa": {
      "title": "Residence permit for job seeking",
      "duration_min": 0.75,
      "duration_max": 0.75,
      "comment": "Специальное разрешение на временное проживание с целью поиска работы в Словении действует 9 месяцев."
    },
    "visa_risks": [
      {
        "residencies": "by",
        "risk": 4.5,
        "comment": "Визы выдаются стабильно. Требования к документам стандартные."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 4.5,
        "comment": "Низкие риски. Визы оформляются стабильно и быстро."
      },
      {
        "residencies": "ru",
        "risk": 4,
        "comment": "Прием заявлений на ВНЖ проходит в консульстве в Москве. Процедура стандартизирована, отказы редки."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 2.5,
        "comment": "Низкие риски. Визы оформляются стабильно и быстро."
      },
      {
        "residencies": "kz",
        "risk": 2.5,
        "comment": "Очень низкий процент отказов. Виза выдается без проблем."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "other",
        "risk": 1,
        "comment": "Формальная проверка документов. Риски минимальны."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      }
    ]
  },
  "sk": {
    "title": "Temporary Residence for Study",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "Разрешено работать до 20 часов в неделю."
    },
    "financial_threshold": 3300,
    "post_study_visa": {
      "title": "Renewal of Temporary Residence for Job Seeking",
      "duration_min": 0.75,
      "duration_max": 0.75,
      "comment": "В Словакии выпускники бакалавриата могут продлить ВНЖ на 9 месяцев для поиска места работы."
    },
    "visa_risks": [
      {
        "residencies": "by",
        "risk": 4.5,
        "comment": "Визы выдаются стабильно. Требования к документам стандартные."
      },
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 4.5,
        "comment": "Низкие риски. Визы оформляются стабильно и быстро."
      },
      {
        "residencies": "ru",
        "risk": 4,
        "comment": "Оформление виз D доступно в консульствах в РФ. Документы проверяются лояльно, процесс предсказуем."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 2.5,
        "comment": "Низкие риски. Визы оформляются стабильно и быстро."
      },
      {
        "residencies": "kz",
        "risk": 2.5,
        "comment": "Очень низкий процент отказов. Виза выдается без проблем."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Граждане США могут въезжать без виз и подавать на студенческий ВНЖ на месте. Для граждан РФ с ВНЖ США подача через европейские консульства на территории Америки проходит быстро и с почти 100% уровнем одобрения."
      },
      {
        "residencies": "other",
        "risk": 1,
        "comment": "Формальная проверка документов. Риски минимальны."
      },
      {
        "residencies": "eu",
        "risk": 0.5,
        "comment": "Для граждан ЕС визы не нужны (свобода передвижения). Для резидентов (ВНЖ ЕС) оформление студенческого ВНЖ в другой стране ЕС проходит по упрощенной внутриевропейской процедуре."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      }
    ]
  },
  "th": {
    "title": "Non-Immigrant ED Visa",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Официально работать запрещено (требуется Work Permit, который не дают студентам)."
    },
    "financial_threshold": 4000,
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Действие учебной визы заканчивается с обучением, открытой визы для поиска работы для бакалавров нет."
    },
    "visa_risks": [
      {
        "residencies": "by",
        "risk": 1.5,
        "comment": "Оформление спонсируется университетом или проходит формально."
      },
      {
        "residencies": "ru",
        "risk": 1.5,
        "comment": "Оформление студенческой визы онлайн или формально."
      },
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "tr": {
    "title": "Student Residence Permit",
    "study_work_conditions": {
      "work_hours_per_week": 24,
      "comment": "Студенты бакалавриата могут работать при получении рабочего разрешения. Лимит - частичная занятость."
    },
    "financial_threshold": 6000,
    "post_study_visa": {
      "title": "Short-term Residence Permit for Graduates",
      "duration_min": 1,
      "duration_max": 1,
      "comment": "Турция выдает выпускникам краткосрочный ВНЖ на 1 год при подаче заявления в течение полугода после диплома."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 1,
        "comment": "Въезд без визы или по тур. визе с оформлением ВНЖ/визы на месте или онлайн."
      },
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "by, kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "tw": {
    "title": "Resident Visa for Study",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "Требуется разрешение (Work Permit). До 20 часов в неделю."
    },
    "financial_threshold": 5000,
    "post_study_visa": {
      "title": "ARC Extension for Job-Seeking",
      "duration_min": 0.5,
      "duration_max": 1,
      "comment": "Выпускники могут продлить свой статус на 6 месяцев с возможностью дополнительного продления еще на полгода."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 2,
        "comment": "Подача через представительство в Москве. Быстрое рассмотрение, формальные проверки подлинности писем о зачислении."
      },
      {
        "residencies": "by",
        "risk": 2,
        "comment": "Процедура прозрачна, виза часто оформляется при участии вуза."
      },
      {
        "residencies": "kz",
        "risk": 1.5,
        "comment": "Виза оформляется быстро, часто через электронные системы или при поддержке вуза."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 1.5,
        "comment": "Подача проходит легко при поддержке принимающего университета."
      },
      {
        "residencies": "eu",
        "risk": 1,
        "comment": "Максимально лояльное отношение. Оформление проходит по линии университетов без задержек."
      },
      {
        "residencies": "other",
        "risk": 1,
        "comment": "Подача проходит легко при поддержке принимающего университета (Approval Letter/CoE)."
      },
      {
        "residencies": "us",
        "risk": 1,
        "comment": "Процедура полностью стандартизирована и инициируется самим университетом (выдача электронных сертификатов CoE или Approval Letters). Риски минимальны для обладателей любого статуса в США."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      }
    ]
  },
  "us": {
    "title": "F-1 Visa",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "Первый год - только на кампусе до 20 часов. Со второго года возможна работа вне кампуса (CPT/OPT)."
    },
    "financial_threshold": 11000,
    "post_study_visa": {
      "title": "Optional Practical Training (OPT)",
      "duration_min": 1,
      "duration_max": 3,
      "comment": "Базовый срок составляет 1 год, но выпускники STEM-программ имеют законное право продлить его еще на 24 месяца."
    },
    "visa_risks": [
      {
        "residencies": "kg, tj, tm, uz",
        "risk": 48,
        "comment": "Высокий процент отказов из-за риска иммиграции. Тщательная проверка финансовых гарантий."
      },
      {
        "residencies": "ru",
        "risk": 45.5,
        "comment": "Подача только в консульствах третьих стран (Казахстан, Сербия, Армения и др.), ВНЖ страны пребывания не требуется. Строгое собеседование на выявление иммиграционных намерений. Возможны проверки гаджетов на границе CBP."
      },
      {
        "residencies": "by",
        "risk": 43.5,
        "comment": "Подача в консульствах третьих стран. Строгое собеседование на выявление иммиграционных намерений."
      },
      {
        "residencies": "am, az, ge, md",
        "risk": 38,
        "comment": "Высокий процент отказов из-за риска иммиграции. Тщательная проверка финансовых гарантий."
      },
      {
        "residencies": "kz",
        "risk": 35,
        "comment": "Собеседование на родине. Пристальное внимание к финансовому благополучию и связям со страной."
      },
      {
        "residencies": "ua",
        "risk": 20,
        "comment": "Оценка по неиммиграционным критериям студенческой визы (F1) остается строгой, несмотря на программы защиты."
      },
      {
        "residencies": "other",
        "risk": 18,
        "comment": "Оценка миграционных рисков сохраняется для всех. Наличие сильного ВНЖ снижает риск, но не отменяет стандартную проверку."
      },
      {
        "residencies": "eu",
        "risk": 10,
        "comment": "Процедура получения Study Permit / F-1 прозрачна. Отказы редки (в основном из-за ошибок в анкете или подозрений в нелегальной работе). Для граждан РФ с ВНЖ ЕС подача из Европы значительно повышает шансы."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Для граждан США и легальных постоянных резидентов (Green Card) оформление визы для обучения в своей стране не требуется."
      }
    ]
  },
  "uz": {
    "title": "Student Visa",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Иностранные студенты могут работать по найму без получения подтверждения на право трудовой деятельности."
    },
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "В Узбекистане нет открытых программ Post-Study Work для выпускников-иностранцев."
    },
    "visa_risks": [
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "by, kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ru",
        "risk": 0,
        "comment": "Безвизовый въезд. Оформление ВНЖ на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "vn": {
    "title": "DH Visa (Student)",
    "study_work_conditions": {
      "work_hours_per_week": 0,
      "comment": "Работать не разрешается без отдельного разрешения на работу."
    },
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Выпускникам требуется сразу найти работодателя для оформления разрешения на работу и рабочей визы."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 1.5,
        "comment": "Виза оформляется по официальному приглашению принимающего вуза. Одобрение гарантировано."
      },
      {
        "residencies": "by",
        "risk": 1.5,
        "comment": "Оформление спонсируется университетом или проходит формально."
      },
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 0,
        "comment": "Безвизовый въезд или простая регистрация."
      },
      {
        "residencies": "kz",
        "risk": 0,
        "comment": "Безвизовый въезд или свободная подача на месте."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  },
  "za": {
    "title": "Study Visa",
    "study_work_conditions": {
      "work_hours_per_week": 20,
      "comment": "До 20 часов в неделю во время учебы."
    },
    "post_study_visa": {
      "title": null,
      "duration_min": 0,
      "duration_max": 0,
      "comment": "Прямой визы нет, но можно податься на Critical Skills Visa, если специальность входит в государственный список."
    },
    "visa_risks": [
      {
        "residencies": "ru",
        "risk": 2,
        "comment": "Подача через посольство в Москве. Обязательна флюорография и медсправка. Процесс полностью предсказуем."
      },
      {
        "residencies": "by",
        "risk": 2,
        "comment": "Процедура прозрачна, виза часто оформляется при участии вуза."
      },
      {
        "residencies": "kz",
        "risk": 1.5,
        "comment": "Виза оформляется быстро, часто через электронные системы или при поддержке вуза."
      },
      {
        "residencies": "am, az, ge, kg, md, tj, tm, uz",
        "risk": 1.5,
        "comment": "Подача проходит легко при поддержке принимающего университета."
      },
      {
        "residencies": "other",
        "risk": 0.5,
        "comment": "Свободный въезд или автоматическое получение студенческого ВНЖ на месте / онлайн."
      },
      {
        "residencies": "eu",
        "risk": 0,
        "comment": "Безвизовый въезд для граждан ЕС, либо автоматическое оформление учебных документов на месте. Риски отсутствуют."
      },
      {
        "residencies": "ua",
        "risk": 0,
        "comment": "Безвизовый режим или лояльная подача."
      },
      {
        "residencies": "us",
        "risk": 0,
        "comment": "Свободный въезд или автоматическое оформление учебных виз / ВНЖ на месте. Нулевой уровень отказов для резидентов и граждан США."
      }
    ]
  }
};